export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};

export type AcceptUserInviteInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type AcceptUserInviteResult = {
  __typename?: 'AcceptUserInviteResult';
  success: Scalars['Boolean'];
};

export type ActionItem = DiscrepancyActionItem;

export type ActionItems = {
  __typename?: 'ActionItems';
  completed: Array<ActionItem>;
  pending: Array<ActionItem>;
};

export type AddExceptionNoteInput = {
  businessSlug: Scalars['String'];
  content: ExceptionNoteContentInput;
  exceptionId: Scalars['ID'];
  facilitySlug: Scalars['String'];
};

export type AddItemsToOrderInput = {
  id: Scalars['ID'];
  items: Array<OrderItemInput>;
};

export type AddItemsToOrderResult = {
  __typename?: 'AddItemsToOrderResult';
  success: Scalars['Boolean'];
};

export type AddShipmentNoteInput = {
  content: ShipmentNoteContentInput;
  shipmentId: Scalars['Int'];
};

export type Address = {
  __typename?: 'Address';
  addressOne: Scalars['String'];
  addressTwo: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AddressInput = {
  addressOne: Scalars['String'];
  addressTwo?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AggregateLabel = {
  __typename?: 'AggregateLabel';
  fields: Array<MultiValueDataField>;
  identifiers: Array<Scalars['String']>;
  images: Array<TaggedImage>;
};

export type AnalyticsAvailableFilter = {
  __typename?: 'AnalyticsAvailableFilter';
  displayName: Scalars['String'];
  fieldName: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type AnalyticsAvailableFiltersResult = {
  __typename?: 'AnalyticsAvailableFiltersResult';
  availableFilters: Array<AnalyticsAvailableFilter>;
};

export type AnalyticsBreakDownEntries = {
  __typename?: 'AnalyticsBreakDownEntries';
  label: Scalars['String'];
  value: Scalars['Int'];
};

export enum AnalyticsBreakdown {
  ALL = 'ALL',
  CARRIER = 'CARRIER',
  CARRIER_SERVICE = 'CARRIER_SERVICE',
  CONSIGNEE = 'CONSIGNEE',
  DIRECTION = 'DIRECTION',
  DOOR_NUMBER = 'DOOR_NUMBER'
}

export enum AnalyticsDataType {
  PERFORMANCE = 'PERFORMANCE',
  VOLUME = 'VOLUME'
}

export type AnalyticsFilterInput = {
  carrier?: InputMaybe<Array<Scalars['String']>>;
  carrierService?: InputMaybe<Array<Scalars['String']>>;
  consignee?: InputMaybe<Array<Scalars['String']>>;
  direction?: InputMaybe<Array<Scalars['String']>>;
  doorNumber?: InputMaybe<Array<Scalars['String']>>;
};

export enum AnalyticsFrequency {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export type AnalyticsInput = {
  breakdownBy?: InputMaybe<AnalyticsBreakdown>;
  businessSlug: Scalars['String'];
  dataType: AnalyticsDataType;
  facilitySlug: Scalars['String'];
  filters?: InputMaybe<AnalyticsFilterInput>;
  frequency: AnalyticsFrequency;
  fromDate: Scalars['String'];
  objectLevel: AnalyticsObjectLevel;
  toDate: Scalars['String'];
};

export enum AnalyticsObjectLevel {
  PALLET = 'PALLET',
  TRUCK_SHIPMENT = 'TRUCK_SHIPMENT'
}

export type AnalyticsReportResult = {
  __typename?: 'AnalyticsReportResult';
  result: Array<AnalyticsResultEntry>;
};

export type AnalyticsResultEntry = {
  __typename?: 'AnalyticsResultEntry';
  breakDowns: Array<AnalyticsBreakDownEntries>;
  label: Scalars['String'];
};

export type AnalyticsRoot = {
  __typename?: 'AnalyticsRoot';
  getAnalyticsAvailableFilters: AnalyticsAvailableFiltersResult;
  getAnalyticsReport: AnalyticsReportResult;
};


export type AnalyticsRootgetAnalyticsAvailableFiltersArgs = {
  input: AnalyticsInput;
};


export type AnalyticsRootgetAnalyticsReportArgs = {
  input: AnalyticsInput;
};

export type AssignTaskInput = {
  taskId: Scalars['Int'];
  userId: Scalars['ID'];
};

export type AssignTaskResult = {
  __typename?: 'AssignTaskResult';
  success: Scalars['Boolean'];
  task: Maybe<OpsTask>;
};

export type BulkAssignTasksInput = {
  taskIds: Array<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type BulkAssignTasksResult = {
  __typename?: 'BulkAssignTasksResult';
  count: Scalars['Int'];
};

export type BulkUnassignTasksInput = {
  taskIds: Array<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type BulkUnassignTasksResult = {
  __typename?: 'BulkUnassignTasksResult';
  count: Scalars['Int'];
};

export type Business = {
  __typename?: 'Business';
  facilities: Array<Facility>;
  facility: Facility;
  facilityBySlug: Facility;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  users: BusinessUsers;
};


export type BusinessfacilityArgs = {
  id: Scalars['Int'];
};


export type BusinessfacilityBySlugArgs = {
  slug: Scalars['String'];
};

export type BusinessFeatureFlag = IFeatureFlag & {
  __typename?: 'BusinessFeatureFlag';
  displayName: Scalars['String'];
  enabledVariantId: Scalars['String'];
  featureId: Scalars['String'];
  variants: Array<FeatureFlagVariant>;
};

export type BusinessOperationMutation = {
  __typename?: 'BusinessOperationMutation';
  addDoorEvent: Scalars['Boolean'];
  addOpsUserToFacility: OpsUser;
  addTruckShipmentFlag: Scalars['Boolean'];
  archiveOrder: Maybe<OpsOrder>;
  assignTask: AssignTaskResult;
  bulkAssignTasks: BulkAssignTasksResult;
  bulkUnassignTasks: BulkUnassignTasksResult;
  createLabelReadingTemplate: CreateLabelReadingTemplateResult;
  createLoadingEvent: Scalars['Boolean'];
  deleteFlagMetadata: Scalars['Boolean'];
  deleteIdentifiedLabel: Maybe<OpsDeleteIdentifiedLabelResult>;
  deleteLabelReadingTemplateField: OpsLabelReadingTemplateField;
  deleteOpsUserFromFacility: OpsUser;
  deleteTruckShipmentFlag: Scalars['Boolean'];
  hideException: Scalars['Boolean'];
  inviteOpsUsers: InviteOpsUsersOutput;
  linkShipments: LinkShipmentsResult;
  mergeShipments: MergeShipmentsResult;
  sendDigestEmails: Scalars['Boolean'];
  splitShipment: SplitShipmentResult;
  triggerTowerStatusLight: OpsTriggerTowerStatusLightResponse;
  unassignTask: OpsTask;
  unlinkShipments: UnlinkShipmentsResult;
  updateIdentifiedLabel: Maybe<OpsUpdateIdentifiedLabelResult>;
  updateItemDisplayNames: Scalars['Boolean'];
  updateLabelReadingTemplate: OpsLabelReadingTemplate;
  updateLoadingEvent: Scalars['Boolean'];
  updatePalletFlags: UpdateShippingItemFlagsResult;
  updatePalletLabel: OpsPallet;
  updatePalletLayerCount: OpsPallet;
  updateShipment: OpsShipment;
  updateTaskStatus: UpdateTaskStatusResult;
  uploadGistDocument: UploadGistDocumentResult;
  upsertFeatureFlag: FeatureFlag;
  upsertFlagMetadata: Scalars['Boolean'];
  upsertLabelReadingTemplateField: OpsLabelReadingTemplateField;
  upsertOrder: OpsOrder;
  upsertPalletEventAnnotation: OpsPallet;
};


export type BusinessOperationMutationaddDoorEventArgs = {
  opened: Scalars['Boolean'];
  videoExternalId: Scalars['String'];
};


export type BusinessOperationMutationaddOpsUserToFacilityArgs = {
  facilityId: Scalars['Int'];
  userId: Scalars['ID'];
};


export type BusinessOperationMutationaddTruckShipmentFlagArgs = {
  input: TruckShipmentFlagInput;
};


export type BusinessOperationMutationarchiveOrderArgs = {
  orderId: Scalars['ID'];
};


export type BusinessOperationMutationassignTaskArgs = {
  input: AssignTaskInput;
};


export type BusinessOperationMutationbulkAssignTasksArgs = {
  input: BulkAssignTasksInput;
};


export type BusinessOperationMutationbulkUnassignTasksArgs = {
  input: BulkUnassignTasksInput;
};


export type BusinessOperationMutationcreateLabelReadingTemplateArgs = {
  input: CreateLabelReadingTemplateInput;
};


export type BusinessOperationMutationcreateLoadingEventArgs = {
  direction: ItemLoadingDirection;
  palletCount: Scalars['Int'];
  videoExternalId: Scalars['String'];
};


export type BusinessOperationMutationdeleteFlagMetadataArgs = {
  issueType: Scalars['String'];
};


export type BusinessOperationMutationdeleteIdentifiedLabelArgs = {
  identifiedLabelId: Scalars['Int'];
  shouldDelete: Scalars['Boolean'];
};


export type BusinessOperationMutationdeleteLabelReadingTemplateFieldArgs = {
  labelReadingTemplateFieldId: Scalars['ID'];
};


export type BusinessOperationMutationdeleteOpsUserFromFacilityArgs = {
  facilityId: Scalars['Int'];
  userId: Scalars['ID'];
};


export type BusinessOperationMutationdeleteTruckShipmentFlagArgs = {
  id: Scalars['Int'];
};


export type BusinessOperationMutationhideExceptionArgs = {
  id: Scalars['ID'];
};


export type BusinessOperationMutationinviteOpsUsersArgs = {
  users: Array<InviteOpsUserInput>;
};


export type BusinessOperationMutationlinkShipmentsArgs = {
  shipmentId1: Scalars['Int'];
  shipmentId2: Scalars['Int'];
};


export type BusinessOperationMutationmergeShipmentsArgs = {
  input: MergeShipmentsInput;
};


export type BusinessOperationMutationsplitShipmentArgs = {
  input: SplitShipmentInput;
};


export type BusinessOperationMutationtriggerTowerStatusLightArgs = {
  input: OpsTriggerTowerStatusLightInput;
};


export type BusinessOperationMutationunassignTaskArgs = {
  taskId: Scalars['Int'];
};


export type BusinessOperationMutationunlinkShipmentsArgs = {
  shipmentId1: Scalars['Int'];
  shipmentId2?: InputMaybe<Scalars['Int']>;
};


export type BusinessOperationMutationupdateIdentifiedLabelArgs = {
  input: UpdateIdentifiedLabelInput;
};


export type BusinessOperationMutationupdateItemDisplayNamesArgs = {
  businessId: Scalars['Int'];
  displayNames: Array<ItemLabelToDisplayNameInput>;
  facilityId: Scalars['Int'];
};


export type BusinessOperationMutationupdateLabelReadingTemplateArgs = {
  input: UpdateLabelReadingTemplateInput;
};


export type BusinessOperationMutationupdateLoadingEventArgs = {
  direction: ItemLoadingDirection;
  loadingEventId: Scalars['Int'];
  palletConfiguration?: InputMaybe<PalletConfigurationInput>;
  palletCount: Scalars['Int'];
};


export type BusinessOperationMutationupdatePalletFlagsArgs = {
  input: UpdateShippingItemFlagsInput;
};


export type BusinessOperationMutationupdatePalletLabelArgs = {
  input: UpdatePalletLabelInput;
};


export type BusinessOperationMutationupdatePalletLayerCountArgs = {
  input: UpdatePalletLayerCountInput;
};


export type BusinessOperationMutationupdateShipmentArgs = {
  input: OpsUpdateShipmentInput;
};


export type BusinessOperationMutationupdateTaskStatusArgs = {
  input: UpdateTaskStatusInput;
};


export type BusinessOperationMutationuploadGistDocumentArgs = {
  file: Scalars['Upload'];
};


export type BusinessOperationMutationupsertFeatureFlagArgs = {
  input: FeatureFlagInput;
};


export type BusinessOperationMutationupsertFlagMetadataArgs = {
  input: UpsertFlagMetadataInput;
};


export type BusinessOperationMutationupsertLabelReadingTemplateFieldArgs = {
  input: OpsLabelReadingTemplateFieldInput;
};


export type BusinessOperationMutationupsertOrderArgs = {
  input: UpsertOrderInput;
};


export type BusinessOperationMutationupsertPalletEventAnnotationArgs = {
  input: PalletAnnotationInput;
};

export type BusinessScopeFeatureFlag = {
  __typename?: 'BusinessScopeFeatureFlag';
  businessId: Scalars['Int'];
  enabledVariantId: Scalars['String'];
};

export type BusinessUser = {
  __typename?: 'BusinessUser';
  canResendInvite: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  pendingInvite: Scalars['Boolean'];
  role: BusinessUserRole;
};

export enum BusinessUserRole {
  CUSTOMER_ADMIN = 'CUSTOMER_ADMIN',
  CUSTOMER_USER = 'CUSTOMER_USER'
}

export type BusinessUsers = {
  __typename?: 'BusinessUsers';
  hasPermission: Scalars['Boolean'];
  users: Array<BusinessUser>;
};

export enum ConfigurationType {
  DOUBLE = 'DOUBLE'
}

export type CreateDatasetInput = {
  name: Scalars['String'];
  query: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type CreateExceptionInput = {
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  ownerUserId?: InputMaybe<Scalars['ID']>;
  shipmentId?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type CreateExceptionResult = {
  __typename?: 'CreateExceptionResult';
  exception: Exception;
};

export type CreateLabelReadingTemplateInput = {
  businessId: Scalars['Int'];
  externalId: Scalars['String'];
  facilityId: Scalars['Int'];
  templateReadLocations: Array<ReadLocation>;
};

export type CreateLabelReadingTemplateResult = {
  __typename?: 'CreateLabelReadingTemplateResult';
  success: Scalars['Boolean'];
  template: Maybe<OpsLabelReadingTemplate>;
};

export type CreateOrUpdateOrderItemInput = {
  description?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  orderItemId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityUnit: ShipperUnitType;
  weightPerUnit?: InputMaybe<Scalars['Int']>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export type CreateOrderResult = {
  __typename?: 'CreateOrderResult';
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type CvMutation = {
  __typename?: 'CvMutation';
  createDataset: Scalars['String'];
};


export type CvMutationcreateDatasetArgs = {
  input: CreateDatasetInput;
};

export type CvRoot = {
  __typename?: 'CvRoot';
  runDatapoolQuery: DatapoolResult;
};


export type CvRootrunDatapoolQueryArgs = {
  query: Scalars['String'];
};

export type DashboardMutation = {
  __typename?: 'DashboardMutation';
  acceptUserInvite: AcceptUserInviteResult;
  addExceptionNote: ExceptionNote;
  addExceptionSharedWithUsers: Exception;
  addItemsToOrder: AddItemsToOrderResult;
  addShipmentNote: ShipmentNote;
  archiveShipperRequest: Scalars['Boolean'];
  createException: CreateExceptionResult;
  createOrder: CreateOrderResult;
  deleteException: Scalars['Boolean'];
  deleteExceptionDocument: Exception;
  deleteExceptionNote: ExceptionNote;
  deleteExceptionSharedWithUsers: Exception;
  deleteExceptions: Scalars['Boolean'];
  deletePendingUserInvite: Scalars['Boolean'];
  deleteShipmentDocument: DeleteShipmentDocumentResult;
  deleteShipmentNote: ShipmentNote;
  deleteUser: DeleteUserResult;
  dismissActionItem: Scalars['Boolean'];
  dismissDiscrepancy: Scalars['Boolean'];
  hideShipment: HideShipmentResult;
  inviteUser: InviteUserResult;
  submitShipperRequestForm: Scalars['Boolean'];
  updateDefaultExceptionOwner: User;
  updateDefaultExceptionSharedWithUsers: Array<User>;
  updateExceptionIssueType: Exception;
  updateExceptionNote: ExceptionNote;
  updateExceptionOwner: Exception;
  updateExceptionPriority: Exception;
  updateExceptionStatus: Exception;
  updateExceptionsOwner: Array<Exception>;
  updateExceptionsStatuses: Array<Exception>;
  updateFacilityLights: UpdateFacilityLightsResult;
  updateFeatureForBusiness: Maybe<UpdateFeatureForBusinessResult>;
  updateFeatureForUser: Maybe<UpdateFeatureForUserResult>;
  updateShipment: UpdateShipmentResult;
  updateShipmentNote: ShipmentNote;
  updateShipmentOrderItems: Order;
  updateShippingItemFlags: UpdateShippingItemFlagsResult;
  uploadExceptionDocument: ExceptionDocument;
  uploadShipmentDocument: UploadShipmentDocumentResult;
};


export type DashboardMutationacceptUserInviteArgs = {
  input: AcceptUserInviteInput;
};


export type DashboardMutationaddExceptionNoteArgs = {
  input: AddExceptionNoteInput;
};


export type DashboardMutationaddExceptionSharedWithUsersArgs = {
  input: UpdateExceptionSharedWithUsersInput;
};


export type DashboardMutationaddItemsToOrderArgs = {
  input: AddItemsToOrderInput;
};


export type DashboardMutationaddShipmentNoteArgs = {
  input: AddShipmentNoteInput;
};


export type DashboardMutationarchiveShipperRequestArgs = {
  externalId: Scalars['String'];
};


export type DashboardMutationcreateExceptionArgs = {
  input: CreateExceptionInput;
};


export type DashboardMutationcreateOrderArgs = {
  input: OrderInput;
};


export type DashboardMutationdeleteExceptionArgs = {
  input: DeleteExceptionInput;
};


export type DashboardMutationdeleteExceptionDocumentArgs = {
  documentId: Scalars['ID'];
};


export type DashboardMutationdeleteExceptionNoteArgs = {
  id: Scalars['ID'];
};


export type DashboardMutationdeleteExceptionSharedWithUsersArgs = {
  input: UpdateExceptionSharedWithUsersInput;
};


export type DashboardMutationdeleteExceptionsArgs = {
  input: DeleteExceptionsInput;
};


export type DashboardMutationdeletePendingUserInviteArgs = {
  input?: InputMaybe<DeletePendingUserInviteInput>;
};


export type DashboardMutationdeleteShipmentDocumentArgs = {
  externalId: Scalars['String'];
};


export type DashboardMutationdeleteShipmentNoteArgs = {
  input: DeleteShipmentNoteInput;
};


export type DashboardMutationdeleteUserArgs = {
  email: Scalars['String'];
};


export type DashboardMutationdismissActionItemArgs = {
  externalId: Scalars['String'];
};


export type DashboardMutationdismissDiscrepancyArgs = {
  truckShipmentId: Scalars['Int'];
};


export type DashboardMutationhideShipmentArgs = {
  hidden: Scalars['Boolean'];
  id: Scalars['Int'];
};


export type DashboardMutationinviteUserArgs = {
  users: Array<InviteUserInput>;
};


export type DashboardMutationsubmitShipperRequestFormArgs = {
  input: ShipperRequestFormInput;
};


export type DashboardMutationupdateDefaultExceptionOwnerArgs = {
  input: UpdateDefaultExceptionOwnerInput;
};


export type DashboardMutationupdateDefaultExceptionSharedWithUsersArgs = {
  input: UpdateDefaultExceptionSharedWithUsersInput;
};


export type DashboardMutationupdateExceptionIssueTypeArgs = {
  input: UpdateExceptionIssueTypeInput;
};


export type DashboardMutationupdateExceptionNoteArgs = {
  input: UpdateExceptionNoteInput;
};


export type DashboardMutationupdateExceptionOwnerArgs = {
  input: UpdateExceptionOwnerInput;
};


export type DashboardMutationupdateExceptionPriorityArgs = {
  input: UpdateExceptionPriorityInput;
};


export type DashboardMutationupdateExceptionStatusArgs = {
  input: UpdateExceptionStatusInput;
};


export type DashboardMutationupdateExceptionsOwnerArgs = {
  input: UpdateExceptionsOwnerInput;
};


export type DashboardMutationupdateExceptionsStatusesArgs = {
  input: UpdateExceptionsStatusesInput;
};


export type DashboardMutationupdateFacilityLightsArgs = {
  facilityId: Scalars['Int'];
  on: Scalars['Boolean'];
};


export type DashboardMutationupdateFeatureForBusinessArgs = {
  businessSlug: Scalars['String'];
  featureId: Scalars['String'];
  variantId: Scalars['String'];
};


export type DashboardMutationupdateFeatureForUserArgs = {
  email: Scalars['String'];
  featureId: Scalars['String'];
  variantId: Scalars['String'];
};


export type DashboardMutationupdateShipmentArgs = {
  input: UpdateShipmentInput;
};


export type DashboardMutationupdateShipmentNoteArgs = {
  input: UpdateShipmentNoteInput;
};


export type DashboardMutationupdateShipmentOrderItemsArgs = {
  input: UpdateShipmentOrderItemsInput;
};


export type DashboardMutationupdateShippingItemFlagsArgs = {
  input: UpdateShippingItemFlagsInput;
};


export type DashboardMutationuploadExceptionDocumentArgs = {
  file: Scalars['Upload'];
  input: UploadExceptionDocumentInput;
};


export type DashboardMutationuploadShipmentDocumentArgs = {
  file: Scalars['Upload'];
  input: UploadShipmentDocumentInput;
};

export type DatapoolItem = {
  __typename?: 'DatapoolItem';
  id: Scalars['Int'];
  imageUri: Maybe<Scalars['String']>;
};

export type DatapoolResult = {
  __typename?: 'DatapoolResult';
  itemCount: Scalars['Int'];
  items: Array<DatapoolItem>;
};

export type DeleteExceptionInput = {
  businessSlug: Scalars['String'];
  exceptionId: Scalars['ID'];
  facilitySlug: Scalars['String'];
};

export type DeleteExceptionsInput = {
  businessSlug: Scalars['String'];
  exceptionIds: Array<Scalars['ID']>;
  facilitySlug: Scalars['String'];
};

export type DeletePendingUserInviteInput = {
  businessId: Scalars['Int'];
  email: Scalars['String'];
};

export type DeleteShipmentDocumentResult = {
  __typename?: 'DeleteShipmentDocumentResult';
  success: Scalars['Boolean'];
};

export type DeleteShipmentNoteInput = {
  noteId: Scalars['ID'];
};

export type DeleteUserResult = {
  __typename?: 'DeleteUserResult';
  success: Scalars['Boolean'];
};

export type Device = {
  __typename?: 'Device';
  business_id: Maybe<Scalars['Int']>;
  device_mac: Maybe<Scalars['String']>;
  device_model: Maybe<Scalars['String']>;
  device_name: Maybe<Scalars['String']>;
  device_sn: Maybe<Scalars['String']>;
  device_version: Maybe<Scalars['String']>;
  dock_id: Maybe<Scalars['Int']>;
  edge_id: Maybe<Scalars['Int']>;
  facility_id: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  part_number: Maybe<Scalars['String']>;
  tunnel: Maybe<TunnelSpec>;
};

export enum DimensionUnit {
  INCH = 'INCH'
}

export enum DiscrepancyAction {
  CREATE_RDR = 'CREATE_RDR',
  DISMISS = 'DISMISS'
}

export type DiscrepancyActionItem = {
  __typename?: 'DiscrepancyActionItem';
  body: Scalars['String'];
  businessId: Scalars['Int'];
  completedAction: Maybe<DiscrepancyAction>;
  dockId: Scalars['Int'];
  externalId: Scalars['String'];
  facilityId: Scalars['Int'];
  possibleActions: Array<DiscrepancyAction>;
  truckShipmentId: Scalars['Int'];
  type: Scalars['String'];
};

export type Dock = {
  __typename?: 'Dock';
  businessId: Scalars['Int'];
  currentTruckShipment: Maybe<TruckShipment>;
  displayName: Scalars['String'];
  facilityId: Scalars['Int'];
  id: Scalars['Int'];
  kargoDock: Scalars['Boolean'];
  slug: Scalars['String'];
  truckShipment: Maybe<TruckShipment>;
  type: DockType;
};


export type DocktruckShipmentArgs = {
  id: Scalars['Int'];
};

export type DockDevice = {
  __typename?: 'DockDevice';
  isLightOn: Scalars['Boolean'];
};

export type DockDoorExceptionLink = {
  __typename?: 'DockDoorExceptionLink';
  dock: Dock;
};

export type DockEventsInput = {
  before: Scalars['String'];
  businessSlug: Scalars['String'];
  dockSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  since: Scalars['String'];
};

export type DockFilter = {
  includeNonKargoDoors?: InputMaybe<Scalars['Boolean']>;
  includeStatuses?: InputMaybe<Array<DockStatus>>;
};

export enum DockStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum DockType {
  DOCK_DOOR = 'DOCK_DOOR',
  YARD = 'YARD'
}

export type DropdownFormField = FormField & {
  __typename?: 'DropdownFormField';
  dropdownOptions: Array<DropdownOption>;
  fieldDisplayName: Scalars['String'];
  fieldName: Scalars['String'];
  required: Scalars['Boolean'];
};

export type DropdownOption = {
  __typename?: 'DropdownOption';
  displayName: Scalars['String'];
  value: Scalars['String'];
};

export type EdgeDeviceMutation = {
  __typename?: 'EdgeDeviceMutation';
  addInformationalTexture: Scalars['Boolean'];
  rpcReply: Scalars['Boolean'];
};


export type EdgeDeviceMutationaddInformationalTextureArgs = {
  inputs: Array<InformationalTextureInput>;
};


export type EdgeDeviceMutationrpcReplyArgs = {
  reply: RpcReplyInput;
};

/** Represents the type of equipment that can be used for a shipment */
export enum EquipmentType {
  /** Represents air-based transport */
  AIR = 'AIR',
  BOX_TRUCK = 'BOX_TRUCK',
  /** Represents sea-based transport */
  CONTAINER = 'CONTAINER',
  /** Represents land-based transport */
  TRAILER = 'TRAILER'
}

export type EquipmentTypeOption = {
  __typename?: 'EquipmentTypeOption';
  displayName: Scalars['String'];
  value: EquipmentType;
};

export type Exception = {
  __typename?: 'Exception';
  activities: Array<ExceptionActivity>;
  category: ExceptionCategory;
  categoryDisplayName: Scalars['String'];
  description: Scalars['String'];
  documents: Array<ExceptionDocument>;
  id: Scalars['ID'];
  level: ExceptionLevel;
  link: Maybe<ExceptionLink>;
  notes: Array<ExceptionNote>;
  occurredAt: Scalars['String'];
  owner: Maybe<User>;
  priority: ExceptionPriority;
  sharedWithUsers: Array<User>;
  status: ExceptionStatus;
  statuses: Array<ExceptionStatusEvent>;
  title: Scalars['String'];
  type: Scalars['String'];
  typeDisplayName: Scalars['String'];
  updatedAt: Maybe<Scalars['String']>;
};


export type ExceptionactivitiesArgs = {
  sortAscending?: InputMaybe<Scalars['Boolean']>;
};

export type ExceptionActivity = {
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
};

export type ExceptionActivityCreated = ExceptionActivity & {
  __typename?: 'ExceptionActivityCreated';
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  user: Maybe<User>;
};

export type ExceptionActivityDeletedDocumentUploaded = ExceptionActivity & {
  __typename?: 'ExceptionActivityDeletedDocumentUploaded';
  documentName: Scalars['String'];
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  user: Maybe<User>;
};

export type ExceptionActivityDocumentDeleted = ExceptionActivity & {
  __typename?: 'ExceptionActivityDocumentDeleted';
  documentName: Scalars['String'];
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  user: Maybe<User>;
};

export type ExceptionActivityDocumentUploaded = ExceptionActivity & {
  __typename?: 'ExceptionActivityDocumentUploaded';
  document: ExceptionDocument;
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  user: Maybe<User>;
};

export type ExceptionActivityIssueTypeUpdated = ExceptionActivity & {
  __typename?: 'ExceptionActivityIssueTypeUpdated';
  fromIssueType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  toIssueType: Scalars['String'];
  user: Maybe<User>;
};

export type ExceptionActivityLevelUpdated = ExceptionActivity & {
  __typename?: 'ExceptionActivityLevelUpdated';
  fromLevel: Maybe<ExceptionLevel>;
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  toLevel: ExceptionLevel;
  user: Maybe<User>;
};

export type ExceptionActivityOwnerUpdated = ExceptionActivity & {
  __typename?: 'ExceptionActivityOwnerUpdated';
  changedByUser: Maybe<User>;
  id: Scalars['ID'];
  newOwner: User;
  occurredAt: Scalars['String'];
  previousOwner: Maybe<User>;
};

export type ExceptionActivityPriorityUpdated = ExceptionActivity & {
  __typename?: 'ExceptionActivityPriorityUpdated';
  fromPriority: Maybe<ExceptionPriority>;
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  toPriority: ExceptionPriority;
  user: Maybe<User>;
};

export type ExceptionActivitySharedWithUsersAdded = ExceptionActivity & {
  __typename?: 'ExceptionActivitySharedWithUsersAdded';
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  sharedWithUsersAdded: Array<User>;
  user: Maybe<User>;
};

export type ExceptionActivitySharedWithUsersDeleted = ExceptionActivity & {
  __typename?: 'ExceptionActivitySharedWithUsersDeleted';
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  sharedWithUsersDeleted: Array<User>;
  user: Maybe<User>;
};

export type ExceptionActivityStatusUpdated = ExceptionActivity & {
  __typename?: 'ExceptionActivityStatusUpdated';
  fromStatus: Maybe<ExceptionStatus>;
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  systemAction: Scalars['Boolean'];
  toStatus: ExceptionStatus;
  user: Maybe<User>;
};

export enum ExceptionCategory {
  DOCUMENTS = 'DOCUMENTS',
  INACTIVITY = 'INACTIVITY',
  LONG_DWELL_TIME = 'LONG_DWELL_TIME',
  OSD = 'OSD',
  OTHER = 'OTHER',
  WORKFLOW_COMPLIANCE = 'WORKFLOW_COMPLIANCE'
}

export type ExceptionDocument = {
  __typename?: 'ExceptionDocument';
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  type: Maybe<Scalars['String']>;
  uploadedAt: Scalars['String'];
  uploadedBy: Maybe<User>;
};

export enum ExceptionLevel {
  DOCK_DOOR = 'DOCK_DOOR',
  PALLET = 'PALLET',
  SHIPMENT = 'SHIPMENT'
}

export type ExceptionLink = DockDoorExceptionLink | ShipmentExceptionLink | ShippingItemExceptionLink;

export type ExceptionNote = {
  __typename?: 'ExceptionNote';
  canModify: Scalars['Boolean'];
  content: ExceptionNoteContent;
  createdAt: Maybe<Scalars['String']>;
  editedAt: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  user: User;
};

export type ExceptionNoteContent = {
  __typename?: 'ExceptionNoteContent';
  text: Scalars['String'];
};

export type ExceptionNoteContentInput = {
  text: Scalars['String'];
};

export enum ExceptionPriority {
  HIGH = 'HIGH',
  LOW = 'LOW'
}

export enum ExceptionStatus {
  CREATED = 'CREATED',
  REOPENED = 'REOPENED',
  RESOLVED = 'RESOLVED'
}

export type ExceptionStatusEvent = {
  __typename?: 'ExceptionStatusEvent';
  occurredAt: Scalars['String'];
  status: ExceptionStatus;
};

export type ExceptionsMetadata = {
  __typename?: 'ExceptionsMetadata';
  category: ExceptionCategory;
  categoryDisplayName: Scalars['String'];
  description: Scalars['String'];
  issueType: Scalars['String'];
  title: Scalars['String'];
};

export type ExceptionsSettingsConfigs = {
  __typename?: 'ExceptionsSettingsConfigs';
  categoryDisplayName: Scalars['String'];
  issueType: Scalars['String'];
  owner: Maybe<User>;
  sharedWithUsers: Array<User>;
  title: Scalars['String'];
};

export type Facility = {
  __typename?: 'Facility';
  actionItems: ActionItems;
  address: Maybe<Address>;
  businessId: Scalars['Int'];
  devices: Array<DockDevice>;
  dock: Dock;
  docks: Array<Dock>;
  exception: Exception;
  exceptions: FacilityExceptions;
  exceptionsSettingsConfigs: Array<ExceptionsSettingsConfigs>;
  filteredTruckShipments: Array<TruckShipment>;
  id: Scalars['Int'];
  itemDisplayNames: Array<ItemLabelToDisplayName>;
  location: Maybe<Location>;
  name: Maybe<Scalars['String']>;
  orders: Array<Order>;
  possibleCarrierServices: Maybe<Array<Scalars['String']>>;
  possibleEquipmentTypes: Array<EquipmentTypeOption>;
  possibleServiceTypes: Array<ServiceTypeOption>;
  shipments: Array<TruckShipment>;
  shipmentsCsvFile: Scalars['String'];
  shipperRequests: Array<ShipperRequest>;
  slug: Scalars['String'];
  timezone: Maybe<FacilityTimezone>;
  truckShipment: TruckShipment;
  users: Array<FacilityUser>;
};


export type FacilitydockArgs = {
  id: Scalars['Int'];
};


export type FacilitydocksArgs = {
  filter?: InputMaybe<DockFilter>;
};


export type FacilityexceptionArgs = {
  id: Scalars['ID'];
};


export type FacilityexceptionsArgs = {
  filter: FacilityExceptionsFilter;
};


export type FacilityfilteredTruckShipmentsArgs = {
  filter?: InputMaybe<ShipmentFilterInput>;
};


export type FacilityordersArgs = {
  filter: OrdersFilter;
};


export type FacilityshipmentsArgs = {
  filter?: InputMaybe<ShipmentFilterInput>;
};


export type FacilityshipmentsCsvFileArgs = {
  format: ShipmentsCsvFileFormat;
  shipmentIds: Array<Scalars['Int']>;
};


export type FacilityshipperRequestsArgs = {
  filter: ShipperRequestFilter;
};


export type FacilitytruckShipmentArgs = {
  id: Scalars['Int'];
};

export type FacilityExceptions = {
  __typename?: 'FacilityExceptions';
  page: Scalars['Int'];
  results: Array<Exception>;
  totalPages: Scalars['Int'];
  totalResults: Scalars['Int'];
};

export type FacilityExceptionsFilter = {
  categories?: InputMaybe<Array<ExceptionCategory>>;
  createdBefore?: InputMaybe<Scalars['String']>;
  createdSince?: InputMaybe<Scalars['String']>;
  levels?: InputMaybe<Array<ExceptionLevel>>;
  ownerUserIds?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  priorities?: InputMaybe<Array<ExceptionPriority>>;
  query?: InputMaybe<Scalars['String']>;
  resultsPerPage?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<ExceptionStatus>>;
  updatedBefore?: InputMaybe<Scalars['String']>;
  updatedSince?: InputMaybe<Scalars['String']>;
};

export type FacilityTimezone = {
  __typename?: 'FacilityTimezone';
  name: Scalars['String'];
};

export enum FacilityType {
  ALL = 'ALL',
  KARGO = 'KARGO',
  OTHER = 'OTHER',
  YARD = 'YARD'
}

export type FacilityUser = {
  __typename?: 'FacilityUser';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  createdAt: Scalars['String'];
  defaultValue: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['String'];
  variants: Array<FeatureFlagVariant>;
};

export type FeatureFlagInput = {
  defaultValue: Scalars['String'];
  displayName: Scalars['String'];
  featureFlagId: Scalars['String'];
  variants: Array<FeatureFlagVariantInput>;
};

export type FeatureFlagVariant = {
  __typename?: 'FeatureFlagVariant';
  displayName: Scalars['String'];
  variantId: Scalars['String'];
};

export type FeatureFlagVariantInput = {
  displayName: Scalars['String'];
  variantId: Scalars['String'];
};

export type FieldListFormField = FormField & {
  __typename?: 'FieldListFormField';
  displayAsList: Maybe<Scalars['Boolean']>;
  fieldDisplayName: Scalars['String'];
  fieldName: Scalars['String'];
  fields: Array<FormField>;
  required: Scalars['Boolean'];
};

export type Form = {
  __typename?: 'Form';
  fields: Array<FormField>;
  formVersion: Scalars['String'];
  sections: Array<FormSection>;
};

export type FormField = {
  fieldDisplayName: Scalars['String'];
  fieldName: Scalars['String'];
  required: Scalars['Boolean'];
};

export type FormSection = {
  __typename?: 'FormSection';
  fields: Array<FormField>;
  title: Maybe<Scalars['String']>;
};

export type HideShipmentResult = {
  __typename?: 'HideShipmentResult';
  success: Scalars['Boolean'];
};

export type IFeatureFlag = {
  enabledVariantId: Scalars['String'];
  featureId: Scalars['String'];
};

export enum InformationalTextureDataType {
  EVENT = 'EVENT',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type InformationalTextureInput = {
  businessId: Scalars['Int'];
  cameraId: Scalars['Int'];
  dockId: Scalars['Int'];
  edgeId: Scalars['Int'];
  facilityId: Scalars['Int'];
  modelInfoJson: Scalars['String'];
  modelResultJson: Scalars['String'];
  s3Location: S3LocationInput;
  timestamp: TimestampInput;
  type: InformationalTextureDataType;
};

export type InviteOpsUserInput = {
  email: Scalars['String'];
  role: OpsUserRole;
};

export type InviteOpsUsersOutput = {
  __typename?: 'InviteOpsUsersOutput';
  count: Scalars['Int'];
};

export type InviteUserInput = {
  businessId: Scalars['Int'];
  email: Scalars['String'];
  role: BusinessUserRole;
};

export type InviteUserResult = {
  __typename?: 'InviteUserResult';
  success: Scalars['Boolean'];
};

export type ItemLabelToDisplayName = {
  __typename?: 'ItemLabelToDisplayName';
  displayName: Scalars['String'];
  hideFromLabelers: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
};

export type ItemLabelToDisplayNameInput = {
  displayName: Scalars['String'];
  hideFromLabelers?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
};

export enum ItemLoadingDirection {
  LOADING = 'LOADING',
  UNLOADING = 'UNLOADING'
}

export enum LabelReadingTemplateState {
  PROD = 'PROD',
  TEST = 'TEST'
}

export type LabelSource = {
  __typename?: 'LabelSource';
  templateId: Scalars['ID'];
};

export type LinkShipmentsResult = {
  __typename?: 'LinkShipmentsResult';
  success: Scalars['Boolean'];
};

export type ListS3ObjectsInput = {
  bucketName: Scalars['String'];
  delimiter?: InputMaybe<Scalars['String']>;
  maxItems?: InputMaybe<Scalars['Int']>;
  prefix: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type Me = {
  __typename?: 'Me';
  email: Scalars['String'];
  featureFlags: Array<UserFeatureFlag>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};

export type MergeShipmentsInput = {
  shipmentId1: Scalars['Int'];
  shipmentId2: Scalars['Int'];
};

export type MergeShipmentsResult = {
  __typename?: 'MergeShipmentsResult';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MultiValueDataField = {
  __typename?: 'MultiValueDataField';
  displayName: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cv: Maybe<CvMutation>;
  dashboard: Maybe<DashboardMutation>;
  edgeDevice: Maybe<EdgeDeviceMutation>;
  ops: Maybe<BusinessOperationMutation>;
};

export type NumericFormField = FormField & {
  __typename?: 'NumericFormField';
  fieldDisplayName: Scalars['String'];
  fieldName: Scalars['String'];
  max: Maybe<Scalars['Int']>;
  min: Maybe<Scalars['Int']>;
  required: Scalars['Boolean'];
};

export type OcrLabelResultItem = {
  __typename?: 'OcrLabelResultItem';
  boundingPoly: Array<Array<Scalars['Int']>>;
  confidence: Maybe<Array<Scalars['Float']>>;
  text: Scalars['String'];
};

export type OpsBusiness = {
  __typename?: 'OpsBusiness';
  facilities: Array<OpsFacility>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OpsDeleteIdentifiedLabelResult = {
  __typename?: 'OpsDeleteIdentifiedLabelResult';
  success: Scalars['Boolean'];
};

export type OpsDeviceTunnel = {
  __typename?: 'OpsDeviceTunnel';
  host: Scalars['String'];
  port: Scalars['Int'];
};

export type OpsDock = {
  __typename?: 'OpsDock';
  businessId: Scalars['Int'];
  displayName: Scalars['String'];
  dockId: Scalars['Int'];
  facilityId: Scalars['Int'];
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  isKargoDock: Scalars['Boolean'];
  slug: Scalars['String'];
  type: DockType;
};

export type OpsDockDevice = {
  __typename?: 'OpsDockDevice';
  businessId: Maybe<Scalars['Int']>;
  dockId: Maybe<Scalars['Int']>;
  edgeId: Maybe<Scalars['Int']>;
  facilityId: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isLightOn: Scalars['Boolean'];
  model: Scalars['String'];
  partNumber: Maybe<Scalars['String']>;
  tunnel: Maybe<OpsDeviceTunnel>;
  version: Scalars['String'];
};

export type OpsDockEvent = {
  __typename?: 'OpsDockEvent';
  at: Maybe<Scalars['String']>;
  details: Maybe<Scalars['String']>;
  dockId: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
  videoExternalId: Maybe<Scalars['String']>;
  videoUri: Maybe<Scalars['String']>;
};

export type OpsException = {
  __typename?: 'OpsException';
  category: ExceptionCategory;
  categoryDisplayName: Scalars['String'];
  displayToUser: Scalars['Boolean'];
  id: Scalars['ID'];
  level: ExceptionLevel;
  occurredAt: Scalars['String'];
  owner: Maybe<User>;
  priority: ExceptionPriority;
  source: OpsExceptionSource;
  status: ExceptionStatus;
  statuses: Array<ExceptionStatusEvent>;
  type: Scalars['String'];
  typeDisplayName: Scalars['String'];
  updatedAt: Maybe<Scalars['String']>;
};

export enum OpsExceptionSource {
  ADMIN_MANUAL = 'ADMIN_MANUAL',
  AUTOMATED_CHECK = 'AUTOMATED_CHECK',
  USER_ACTION = 'USER_ACTION'
}

export type OpsFacility = {
  __typename?: 'OpsFacility';
  business: OpsBusiness;
  businessId: Scalars['Int'];
  devices: Array<OpsDockDevice>;
  docks: Array<OpsDock>;
  id: Scalars['ID'];
  name: Maybe<Scalars['String']>;
  officialName: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  timeZone: Maybe<Scalars['String']>;
};

export type OpsFieldsOrdered = {
  __typename?: 'OpsFieldsOrdered';
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type OpsFieldsOrderedInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OpsFlagMetadata = {
  __typename?: 'OpsFlagMetadata';
  description: Maybe<Scalars['String']>;
  issueType: Scalars['String'];
  title: Scalars['String'];
};

export type OpsIdentifiedLabel = {
  __typename?: 'OpsIdentifiedLabel';
  combinedLabels: Maybe<Array<Maybe<OpsIdentifiedLabel>>>;
  fieldsOrdered: Maybe<Array<Maybe<OpsFieldsOrdered>>>;
  hidden: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  identifierType: Maybe<Scalars['String']>;
  label_type: Maybe<Scalars['String']>;
  palletId: Maybe<Scalars['String']>;
  palletImages: Maybe<Array<Maybe<OpsPalletImages>>>;
  source: Maybe<LabelSource>;
};

export type OpsLabelImage = {
  __typename?: 'OpsLabelImage';
  brightness: Maybe<Scalars['Float']>;
  cameraId: Maybe<Scalars['Int']>;
  edgeId: Maybe<Scalars['Int']>;
  eventType: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUri: Scalars['String'];
  ocrLabelResultFormatted: Maybe<Scalars['String']>;
};

export type OpsLabelReadingTemplate = {
  __typename?: 'OpsLabelReadingTemplate';
  anchorVersion: Scalars['String'];
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  templateReadLocations: Array<TemplateReadLocation>;
  templateState: Maybe<LabelReadingTemplateState>;
  thresholds: Scalars['String'];
};

export type OpsLabelReadingTemplateField = {
  __typename?: 'OpsLabelReadingTemplateField';
  createdAt: Scalars['String'];
  defaultRegex: Scalars['String'];
  externalDisplayName: Scalars['String'];
  fieldType: OpsLabelReadingTemplateFieldType;
  id: Scalars['ID'];
  identifierType: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Maybe<Scalars['String']>;
};

export type OpsLabelReadingTemplateFieldInput = {
  defaultRegex: Scalars['String'];
  externalDisplayName: Scalars['String'];
  fieldType: OpsLabelReadingTemplateFieldType;
  id?: InputMaybe<Scalars['ID']>;
  identifierType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum OpsLabelReadingTemplateFieldType {
  FIELD = 'FIELD',
  PALLET_CLASS = 'PALLET_CLASS',
  PALLET_ID = 'PALLET_ID'
}

export type OpsLabelsAndImages = {
  __typename?: 'OpsLabelsAndImages';
  businessId: Scalars['Int'];
  businessName: Scalars['String'];
  cameraIds: Array<Scalars['Int']>;
  direction: Maybe<Scalars['Int']>;
  dockId: Scalars['Int'];
  dockName: Scalars['String'];
  edgeId: Scalars['Int'];
  edgeIds: Array<Scalars['Int']>;
  endAt: Scalars['String'];
  facilityId: Scalars['Int'];
  facilityName: Scalars['String'];
  images: Array<OpsPalletImages>;
  labels: Array<OpsIdentifiedLabel>;
  loadingEventId: Maybe<Scalars['Int']>;
  palletCount: Maybe<Scalars['Int']>;
  palletEventFlags: Array<OpsPalletEventFlag>;
  palletIds: Array<Scalars['String']>;
  startAt: Scalars['String'];
  timestamp: Scalars['String'];
  timestamps: Array<Scalars['String']>;
};

export type OpsLoadingEvent = {
  __typename?: 'OpsLoadingEvent';
  configuration: Maybe<PalletConfiguration>;
  direction: Maybe<Scalars['String']>;
  endAt: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items: Maybe<Scalars['String']>;
  labelStatesAutoCheckedAt: Maybe<Scalars['String']>;
  occurredAt: Scalars['String'];
  palletCount: Maybe<Scalars['Int']>;
  pallets: Array<OpsPallet>;
  shipmentId: Maybe<Scalars['Int']>;
  startAt: Maybe<Scalars['String']>;
};

export type OpsLoadingEvents = {
  __typename?: 'OpsLoadingEvents';
  business: Scalars['String'];
  businessId: Scalars['Int'];
  dock: Scalars['String'];
  dockId: Scalars['Int'];
  facility: Scalars['String'];
  facilityId: Scalars['Int'];
  loadingEvents: Array<OpsLoadingEvent>;
};

export type OpsOrder = {
  __typename?: 'OpsOrder';
  archived: Scalars['Boolean'];
  bolNumber: Maybe<Scalars['String']>;
  businessSlug: Scalars['String'];
  carrier: Maybe<Scalars['String']>;
  carrierService: Maybe<Scalars['String']>;
  consigneeName: Maybe<Scalars['String']>;
  consigneePhoneNumber: Maybe<Scalars['String']>;
  direction: OrderDirection;
  expectedQuantity: Maybe<Scalars['Int']>;
  facilitySlug: Scalars['String'];
  id: Scalars['ID'];
  items: Array<OpsOrderItem>;
  orderNumber: Scalars['String'];
  orderType: Maybe<Scalars['String']>;
  purchaseOrder: Maybe<Scalars['String']>;
  requestedDeliveryDate: Maybe<Scalars['String']>;
  requestedShipDate: Maybe<Scalars['String']>;
  sealNumber: Maybe<Scalars['String']>;
  shipmentId: Maybe<Scalars['Int']>;
  shipperAddress: Maybe<OpsOrderAddress>;
  shipperEmail: Maybe<Scalars['String']>;
  shipperName: Maybe<Scalars['String']>;
  status: OrderStatus;
};

export type OpsOrderAddress = {
  __typename?: 'OpsOrderAddress';
  addressOne: Scalars['String'];
  addressTwo: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type OpsOrderItem = {
  __typename?: 'OpsOrderItem';
  description: Maybe<Scalars['String']>;
  dimensionUnit: Maybe<DimensionUnit>;
  expirationDate: Maybe<Scalars['String']>;
  height: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  isDangerousGood: Maybe<Scalars['Boolean']>;
  length: Maybe<Scalars['Float']>;
  lot: Maybe<Scalars['String']>;
  lpn: Maybe<Scalars['String']>;
  manufacturingDate: Maybe<Scalars['String']>;
  purchaseOrder: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Int']>;
  quantityUnit: ShipperUnitType;
  sku: Maybe<Scalars['String']>;
  upc: Maybe<Scalars['String']>;
  weightPerUnit: Maybe<Scalars['Float']>;
  weightUnit: Maybe<WeightUnit>;
};

export type OpsOrderItemInput = {
  description?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  lpn?: InputMaybe<Scalars['String']>;
  orderItemId: Scalars['ID'];
  purchaseOrder?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityUnit: ShipperUnitType;
  sku?: InputMaybe<Scalars['String']>;
  weightPerUnit?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export type OpsPallet = {
  __typename?: 'OpsPallet';
  annotation: Maybe<PalletAnnotation>;
  endAt: Maybe<Scalars['String']>;
  flags: Array<ShippingItemFlag>;
  hasPalletClassLabel: Scalars['Boolean'];
  hasPalletIdLabel: Scalars['Boolean'];
  id: Scalars['Int'];
  images: Array<OpsLabelImage>;
  label: OpsPalletLabel;
  layerCount: Maybe<Scalars['Int']>;
  loadingEventId: Maybe<Scalars['Int']>;
  occurredAt: Scalars['String'];
  orientation: Maybe<PalletOrientation>;
  shipmentId: Maybe<Scalars['Int']>;
  startAt: Maybe<Scalars['String']>;
};

export enum OpsPalletAggregationState {
  AGGREGATED = 'AGGREGATED',
  HUMAN_EDITED = 'HUMAN_EDITED',
  /** @deprecated Use HUMAN_EDITED */
  LOCKED = 'LOCKED'
}

export type OpsPalletEventFlag = {
  __typename?: 'OpsPalletEventFlag';
  flags: Array<ShippingItemFlag>;
  id: Scalars['String'];
};

export type OpsPalletImages = {
  __typename?: 'OpsPalletImages';
  brightness: Maybe<Scalars['Float']>;
  cameraId: Maybe<Scalars['Int']>;
  edgeId: Maybe<Scalars['Int']>;
  eventType: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  imageUri: Scalars['String'];
  ocrLabelResultFormatted: Maybe<Scalars['String']>;
};

export type OpsPalletLabel = {
  __typename?: 'OpsPalletLabel';
  aggregateLabel: AggregateLabel;
  alternativeLpnList: Array<OpsPalletLabelSegment>;
  contentAggregationState: Maybe<OpsPalletAggregationState>;
  fields: Array<OpsPalletLabelFieldSegment>;
  licensePlateNumbers: Array<OpsPalletLabelSegment>;
  palletContentIds: Array<OpsPalletLabelSegment>;
};

export type OpsPalletLabelFieldSegment = {
  __typename?: 'OpsPalletLabelFieldSegment';
  imageIds: Array<Scalars['Int']>;
  images: Array<OpsLabelImage>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type OpsPalletLabelFieldSegmentInput = {
  imageIds: Array<Scalars['Int']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type OpsPalletLabelImage = {
  __typename?: 'OpsPalletLabelImage';
  businessId: Scalars['Int'];
  externalId: Scalars['ID'];
  facilityId: Scalars['Int'];
  ocrLabelResult: Array<OcrLabelResultItem>;
};

export type OpsPalletLabelSegment = {
  __typename?: 'OpsPalletLabelSegment';
  displayName: Maybe<Scalars['String']>;
  identifier: Scalars['String'];
  imageIds: Array<Scalars['Int']>;
  type: Scalars['String'];
};

export type OpsPalletLabelSegmentInput = {
  displayName?: InputMaybe<Scalars['String']>;
  identifier: Scalars['String'];
  imageIds: Array<Scalars['Int']>;
  type: Scalars['String'];
};

export type OpsPalletMotionVideo = {
  __typename?: 'OpsPalletMotionVideo';
  cameraLocation: Maybe<Scalars['String']>;
  endAt: Maybe<Scalars['String']>;
  occurredAt: Maybe<Scalars['String']>;
  startAt: Maybe<Scalars['String']>;
  videoThumbnailUri: Maybe<Scalars['String']>;
  videoUri: Scalars['String'];
};

export type OpsRequestTowerVideo = {
  businessId: Scalars['Int'];
  cameraName: Scalars['String'];
  dataType: Scalars['String'];
  dockId: Scalars['Int'];
  edgeId: Scalars['Int'];
  endTime: Scalars['String'];
  facilityId: Scalars['Int'];
  startTime: Scalars['String'];
};

export type OpsRequestTowerVideoResult = {
  __typename?: 'OpsRequestTowerVideoResult';
  s3Path: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  videoUrl: Maybe<Scalars['String']>;
};

export type OpsRoot = {
  __typename?: 'OpsRoot';
  businesses: Array<OpsBusiness>;
  devicesByFacilityId: Array<OpsDockDevice>;
  dockEvents: Array<OpsDockEvent>;
  featureFlags: Array<FeatureFlag>;
  featureFlagsByBusinessSlug: Array<BusinessFeatureFlag>;
  featureFlagsByUserEmail: Array<UserFeatureFlag>;
  flagMetadata: Array<OpsFlagMetadata>;
  generateSignedUrl: Maybe<OpsSignedUrlResult>;
  getLastCompletedTask: Maybe<OpsTask>;
  identifiedLabels: OpsLabelsAndImages;
  labelReadingTemplateFields: Array<OpsLabelReadingTemplateField>;
  labelReadingTemplates: Array<OpsLabelReadingTemplate>;
  labelerUsers: Array<OpsUser>;
  loadingEvent: Maybe<OpsLoadingEvent>;
  loadingEventIdentifiedLabels: Maybe<OpsLabelsAndImages>;
  loadingEvents: Maybe<OpsLoadingEvents>;
  opsShipmentActivityItemsLoaded: OpsShipmentActivityItemsLoaded;
  opsUser: OpsUser;
  opsUsers: Array<OpsUser>;
  order: Maybe<OpsOrder>;
  palletEvent: Maybe<OpsPallet>;
  palletLabelImage: Maybe<OpsPalletLabelImage>;
  pendingInvites: Array<PendingInvite>;
  requestTowerVideo: OpsRequestTowerVideoResult;
  s3Objects: S3Listing;
  shipment: Maybe<OpsShipment>;
  task: OpsTask;
  tasks: OpsTasks;
  tasksSummary: Array<OpsTaskSummary>;
  unlinkedShipments: UnlinkedShipmentsResult;
  validateLabelReadingTemplate: ValidateLabelReadingTemplateResult;
};


export type OpsRootdevicesByFacilityIdArgs = {
  facilityId: Scalars['Int'];
};


export type OpsRootdockEventsArgs = {
  input: DockEventsInput;
};


export type OpsRootfeatureFlagsByBusinessSlugArgs = {
  businessSlug: Scalars['String'];
};


export type OpsRootfeatureFlagsByUserEmailArgs = {
  email: Scalars['String'];
};


export type OpsRootgenerateSignedUrlArgs = {
  s3Path: Scalars['String'];
};


export type OpsRootgetLastCompletedTaskArgs = {
  completedAt: Scalars['String'];
};


export type OpsRootidentifiedLabelsArgs = {
  palletId: Scalars['Int'];
};


export type OpsRootloadingEventArgs = {
  loadingEventId: Scalars['Int'];
};


export type OpsRootloadingEventIdentifiedLabelsArgs = {
  loadingEventId: Scalars['Int'];
};


export type OpsRootloadingEventsArgs = {
  shipmentId: Scalars['Int'];
};


export type OpsRootopsShipmentActivityItemsLoadedArgs = {
  id: Scalars['ID'];
};


export type OpsRootorderArgs = {
  orderId: Scalars['ID'];
};


export type OpsRootpalletEventArgs = {
  palletEventId: Scalars['Int'];
};


export type OpsRootpalletLabelImageArgs = {
  palletLabelImageExternalId: Scalars['ID'];
};


export type OpsRootrequestTowerVideoArgs = {
  input: OpsRequestTowerVideo;
};


export type OpsRoots3ObjectsArgs = {
  input: ListS3ObjectsInput;
};


export type OpsRootshipmentArgs = {
  shipmentId: Scalars['Int'];
};


export type OpsRoottaskArgs = {
  query: OpsTaskQuery;
};


export type OpsRoottasksArgs = {
  after?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  filter: OpsTaskFilter;
  sortDirection?: InputMaybe<SortDirection>;
};


export type OpsRootunlinkedShipmentsArgs = {
  filter: UnlinkedShipmentsFilter;
};


export type OpsRootvalidateLabelReadingTemplateArgs = {
  numberOfImages: Scalars['Int'];
  templateId: Scalars['Int'];
};

export type OpsShipment = {
  __typename?: 'OpsShipment';
  atFacilityAt: Maybe<Scalars['String']>;
  business: OpsBusiness;
  businessId: Scalars['ID'];
  carrier: Maybe<Scalars['String']>;
  direction: Maybe<TruckDirection>;
  dock: Maybe<OpsDock>;
  dockId: Maybe<Scalars['ID']>;
  documents: Array<OpsShipmentDocument>;
  exceptions: Array<OpsException>;
  facility: OpsFacility;
  facilityId: Scalars['ID'];
  hasScheduledShipment: Scalars['Boolean'];
  id: Scalars['ID'];
  linkedShipmentId: Maybe<Scalars['ID']>;
  orders: Array<OpsOrder>;
};

export type OpsShipmentActivity = {
  occurredAt: Scalars['String'];
};

export type OpsShipmentActivityItemsLoaded = OpsShipmentActivity & {
  __typename?: 'OpsShipmentActivityItemsLoaded';
  direction: ItemLoadingDirection;
  forkliftId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemQuantity: Scalars['Int'];
  occurredAt: Scalars['String'];
  videos: Array<OpsPalletMotionVideo>;
};

export type OpsShipmentDocument = {
  __typename?: 'OpsShipmentDocument';
  externalId: Scalars['String'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  ocrProcessedAt: Maybe<Scalars['String']>;
  ocrResultText: Maybe<Array<Scalars['String']>>;
  shipmentId: Scalars['Int'];
  type: Maybe<Scalars['String']>;
  uploadedAt: Scalars['String'];
};

export type OpsSignedUrlResult = {
  __typename?: 'OpsSignedUrlResult';
  exists: Scalars['Boolean'];
  fileUrl: Maybe<Scalars['String']>;
};

export type OpsTask = {
  __typename?: 'OpsTask';
  assignedTo: Maybe<User>;
  business: Maybe<Business>;
  businessId: Maybe<Scalars['ID']>;
  completedAt: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  details: Maybe<OpsTaskDetails>;
  dock: Maybe<Dock>;
  dockId: Maybe<Scalars['ID']>;
  facility: Maybe<Facility>;
  facilityId: Maybe<Scalars['ID']>;
  id: Scalars['Int'];
  loadingEvent: Maybe<OpsLoadingEvent>;
  parentTask: Maybe<OpsTask>;
  parentTaskId: Maybe<Scalars['ID']>;
  priority: Scalars['Int'];
  shipment: Maybe<TruckShipment>;
  shipmentId: Maybe<Scalars['ID']>;
  status: OpsTaskStatus;
  statusAt: Scalars['String'];
  subTasks: Maybe<Array<OpsTask>>;
  type: OpsTaskType;
};

export type OpsTaskDetails = {
  shipmentId: Maybe<Scalars['ID']>;
};

export type OpsTaskFilter = {
  assignedToUserIds?: InputMaybe<Array<Scalars['Int']>>;
  assignedUserExternalIds?: InputMaybe<Array<Scalars['String']>>;
  businessId?: InputMaybe<Scalars['ID']>;
  businessSlug?: InputMaybe<Scalars['String']>;
  dockId?: InputMaybe<Scalars['ID']>;
  dockSlug?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  facilitySlug?: InputMaybe<Scalars['String']>;
  priorities?: InputMaybe<Array<Scalars['Int']>>;
  shipmentId?: InputMaybe<Scalars['ID']>;
  statuses?: InputMaybe<Array<OpsTaskStatus>>;
  taskTypes?: InputMaybe<Array<OpsTaskType>>;
};

export type OpsTaskLoadingEventDetails = OpsTaskDetails & {
  __typename?: 'OpsTaskLoadingEventDetails';
  loadingEventId: Scalars['Int'];
  shipmentId: Maybe<Scalars['ID']>;
};

export type OpsTaskPalletEventDetails = OpsTaskDetails & {
  __typename?: 'OpsTaskPalletEventDetails';
  loadingEventId: Scalars['Int'];
  palletEventId: Scalars['Int'];
  shipmentId: Maybe<Scalars['ID']>;
};

export type OpsTaskQuery = {
  id: Scalars['Int'];
};

export enum OpsTaskStatus {
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  ESCALATED = 'ESCALATED'
}

export type OpsTaskSummary = {
  __typename?: 'OpsTaskSummary';
  businessId: Scalars['ID'];
  businessSlug: Scalars['String'];
  count: Scalars['Int'];
  facilityId: Scalars['ID'];
  facilitySlug: Scalars['String'];
  oldestIncomplete: Maybe<Scalars['String']>;
  taskStatus: OpsTaskStatus;
  taskType: OpsTaskType;
};

export enum OpsTaskType {
  DOCUMENT_UPLOADED = 'DOCUMENT_UPLOADED',
  LOADING_EVENT_CREATED = 'LOADING_EVENT_CREATED',
  PALLET_EVENT_CREATED = 'PALLET_EVENT_CREATED',
  PALLET_LABEL_MISSED = 'PALLET_LABEL_MISSED',
  SHIPMENT_ARRIVED = 'SHIPMENT_ARRIVED',
  SHIPMENT_AUTO_LINKED = 'SHIPMENT_AUTO_LINKED',
  SHIPMENT_DELETED = 'SHIPMENT_DELETED',
  SHIPMENT_UPDATED = 'SHIPMENT_UPDATED'
}

export type OpsTasks = {
  __typename?: 'OpsTasks';
  tasks: Array<OpsTask>;
  total: Scalars['Int'];
};

export type OpsTriggerTowerStatusLightInput = {
  deviceId: Scalars['Int'];
};

export type OpsTriggerTowerStatusLightResponse = {
  __typename?: 'OpsTriggerTowerStatusLightResponse';
  deviceId: Scalars['Int'];
  host: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type OpsUpdateIdentifiedLabelResult = {
  __typename?: 'OpsUpdateIdentifiedLabelResult';
  success: Scalars['Boolean'];
};

export type OpsUpdateShipmentInput = {
  carrier?: InputMaybe<Scalars['String']>;
  shipmentId: Scalars['ID'];
};

export type OpsUser = {
  __typename?: 'OpsUser';
  facilities: Array<OpsFacility>;
  user: User;
};

export enum OpsUserRole {
  OPS_LABELER = 'OPS_LABELER'
}

export type Order = {
  __typename?: 'Order';
  bolNumber: Maybe<Scalars['String']>;
  carrier: Maybe<Scalars['String']>;
  carrierService: Maybe<Scalars['String']>;
  consigneeName: Maybe<Scalars['String']>;
  consigneePhoneNumber: Maybe<Scalars['String']>;
  direction: OrderDirection;
  expectedQuantity: Maybe<Scalars['Int']>;
  externalId: Scalars['String'];
  facility: Facility;
  facilityId: Scalars['Int'];
  id: Scalars['ID'];
  items: Array<OrderItem>;
  orderNumber: Scalars['String'];
  orderType: Maybe<Scalars['String']>;
  purchaseOrder: Maybe<Scalars['String']>;
  requestedDeliveryDate: Maybe<Scalars['String']>;
  requestedShipDate: Maybe<Scalars['String']>;
  sealNumber: Maybe<Scalars['String']>;
  shipmentId: Maybe<Scalars['Int']>;
  shipperAddress: Maybe<Address>;
  shipperEmail: Maybe<Scalars['String']>;
  shipperName: Maybe<Scalars['String']>;
  status: OrderStatus;
};

export enum OrderDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type OrderInput = {
  bolNumber?: InputMaybe<Scalars['String']>;
  businessSlug: Scalars['String'];
  carrier?: InputMaybe<Scalars['String']>;
  carrierService?: InputMaybe<Scalars['String']>;
  consigneeName?: InputMaybe<Scalars['String']>;
  consigneePhoneNumber?: InputMaybe<Scalars['String']>;
  direction: OrderDirection;
  expectedQuantity?: InputMaybe<Scalars['Int']>;
  facilitySlug: Scalars['String'];
  items: Array<OrderItemInput>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['String']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']>;
  requestedShipDate?: InputMaybe<Scalars['String']>;
  sealNumber?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['Int']>;
  shipperAddress?: InputMaybe<AddressInput>;
  shipperEmail?: InputMaybe<Scalars['String']>;
  shipperName?: InputMaybe<Scalars['String']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  description: Maybe<Scalars['String']>;
  dimensionUnit: Maybe<DimensionUnit>;
  expirationDate: Maybe<Scalars['String']>;
  height: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  isDangerousGood: Maybe<Scalars['Boolean']>;
  length: Maybe<Scalars['Float']>;
  lot: Maybe<Scalars['String']>;
  manufacturingDate: Maybe<Scalars['String']>;
  purchaseOrder: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Int']>;
  quantityUnit: ShipperUnitType;
  upc: Maybe<Scalars['String']>;
  weightPerUnit: Maybe<Scalars['Float']>;
  weightUnit: Maybe<WeightUnit>;
};

export type OrderItemInput = {
  description?: InputMaybe<Scalars['String']>;
  dimensionUnit?: InputMaybe<DimensionUnit>;
  expirationDate?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  identifier: Scalars['String'];
  isDangerousGood?: InputMaybe<Scalars['Boolean']>;
  length?: InputMaybe<Scalars['Float']>;
  lot?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityUnit: ShipperUnitType;
  upc?: InputMaybe<Scalars['String']>;
  weightPerUnit?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export enum OrderStatus {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  SCHEDULED = 'SCHEDULED'
}

export type OrdersFilter = {
  direction?: InputMaybe<OrderDirection>;
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type PalletAnnotation = {
  __typename?: 'PalletAnnotation';
  missingLabelReason: PalletAnnotationMissingLabelReason;
  reasons: Array<PalletAnnotationReason>;
};

export enum PalletAnnotationCategory {
  PALLET_CLASS = 'PALLET_CLASS',
  PALLET_ID = 'PALLET_ID'
}

export type PalletAnnotationInput = {
  missingLabelReason: PalletAnnotationReasonInput;
  palletEventId: Scalars['Int'];
};

export type PalletAnnotationMissingLabelReason = {
  __typename?: 'PalletAnnotationMissingLabelReason';
  PALLET_CLASS: Maybe<PalletAnnotationRootCause>;
  PALLET_CLASS_ANNOTATION: Maybe<Array<PalletAnnotationRootCause>>;
  PALLET_ID: Maybe<PalletAnnotationRootCause>;
  PALLET_ID_ANNOTATION: Maybe<Array<PalletAnnotationRootCause>>;
};

export type PalletAnnotationReason = {
  __typename?: 'PalletAnnotationReason';
  category: PalletAnnotationCategory;
  rootCause: PalletAnnotationRootCause;
};

export type PalletAnnotationReasonInput = {
  PALLET_CLASS?: InputMaybe<PalletAnnotationRootCause>;
  PALLET_CLASS_ANNOTATION?: InputMaybe<Array<PalletAnnotationRootCause>>;
  PALLET_ID?: InputMaybe<PalletAnnotationRootCause>;
  PALLET_ID_ANNOTATION?: InputMaybe<Array<PalletAnnotationRootCause>>;
};

export enum PalletAnnotationRootCause {
  GOOD_IMAGE = 'GOOD_IMAGE',
  LABEL_ON_BOX = 'LABEL_ON_BOX',
  LABEL_ON_STICKER = 'LABEL_ON_STICKER',
  LABEL_POSITION_BACK = 'LABEL_POSITION_BACK',
  LABEL_POSITION_FRONT = 'LABEL_POSITION_FRONT',
  LABEL_POSITION_SIDE = 'LABEL_POSITION_SIDE',
  LABEL_POSITION_TOP = 'LABEL_POSITION_TOP',
  NO_LABEL_FACING_TOWER = 'NO_LABEL_FACING_TOWER',
  NO_LABEL_ONLINE = 'NO_LABEL_ONLINE',
  NO_LABEL_ON_PALLET = 'NO_LABEL_ON_PALLET',
  OBSTRUCTED_VIEW = 'OBSTRUCTED_VIEW',
  UNREADABLE_LABEL_BLUR = 'UNREADABLE_LABEL_BLUR',
  UNREADABLE_LABEL_CORRUPT = 'UNREADABLE_LABEL_CORRUPT',
  UNREADABLE_LABEL_COVERED = 'UNREADABLE_LABEL_COVERED',
  UNREADABLE_LABEL_CROP = 'UNREADABLE_LABEL_CROP',
  UNREADABLE_LABEL_DAMAGE = 'UNREADABLE_LABEL_DAMAGE',
  UNREADABLE_LABEL_DARK = 'UNREADABLE_LABEL_DARK',
  UNREADABLE_LABEL_GLARE = 'UNREADABLE_LABEL_GLARE',
  UNREADABLE_LABEL_OCCLUDED = 'UNREADABLE_LABEL_OCCLUDED',
  UNREADABLE_LABEL_QUALITY = 'UNREADABLE_LABEL_QUALITY'
}

export type PalletConfiguration = {
  configurationType: ConfigurationType;
};

export enum PalletConfigurationDouble {
  FRONT_BACK = 'FRONT_BACK',
  LEFT_RIGHT = 'LEFT_RIGHT',
  TOP_BOTTOM = 'TOP_BOTTOM'
}

export type PalletConfigurationInput = {
  configurationType: ConfigurationType;
  doublePalletConfiguration: PalletConfigurationDouble;
};

export type PalletMotionVideo = {
  __typename?: 'PalletMotionVideo';
  cameraLocation: Maybe<Scalars['String']>;
  occurredAt: Maybe<Scalars['String']>;
  videoThumbnailUri: Maybe<Scalars['String']>;
  videoUri: Scalars['String'];
};

export enum PalletOrientation {
  BACK = 'BACK',
  BOTTOM = 'BOTTOM',
  FRONT = 'FRONT',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP'
}

export type PendingInvite = {
  __typename?: 'PendingInvite';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  expiresAt: Scalars['String'];
  inviteUrl: Scalars['String'];
  role: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  analytics: AnalyticsRoot;
  business: Business;
  businessBySlug: Business;
  businesses: Array<Business>;
  cv: CvRoot;
  device: Maybe<Device>;
  error: Scalars['Boolean'];
  estimateTimeToDeparture: TTDResult;
  exceptionsMetadata: Array<ExceptionsMetadata>;
  internal_token: Maybe<Scalars['String']>;
  me: Me;
  ops: OpsRoot;
  order: Order;
  /** @deprecated Query shipmentActivityItemsLoaded.videos */
  palletMotionVideos: Array<PalletMotionVideo>;
  ping: Scalars['Boolean'];
  shipmentActivityDoorEvent: ShipmentActivityDoorEvent;
  shipmentActivityItemsLoaded: ShipmentActivityItemsLoaded;
  shipperRequestFormBySlug: ShipperRequestForm;
  shippingItem: ShippingItem;
  truckShipment: TruckShipment;
};


export type QuerybusinessArgs = {
  id: Scalars['Int'];
};


export type QuerybusinessBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryestimateTimeToDepartureArgs = {
  estimationTime?: InputMaybe<Scalars['String']>;
  truckIds?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryorderArgs = {
  externalId: Scalars['String'];
};


export type QuerypalletMotionVideosArgs = {
  id: Scalars['Int'];
};


export type QueryshipmentActivityDoorEventArgs = {
  id: Scalars['ID'];
};


export type QueryshipmentActivityItemsLoadedArgs = {
  id: Scalars['ID'];
};


export type QueryshipperRequestFormBySlugArgs = {
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  formType: ShipperRequestFormType;
};


export type QueryshippingItemArgs = {
  partID: Scalars['String'];
};


export type QuerytruckShipmentArgs = {
  id: Scalars['Int'];
};

export type ReadLocation = {
  fieldName: Scalars['String'];
  locationItem: ReadLocationItem;
};

export type ReadLocationItem = {
  fieldType?: InputMaybe<OpsLabelReadingTemplateFieldType>;
  identifierType?: InputMaybe<Scalars['String']>;
  points: Array<Array<Scalars['Int']>>;
  polygons: Array<Array<Array<Scalars['Int']>>>;
  regex: Scalars['String'];
};

export type RpcReplyInput = {
  code: Scalars['Int'];
  data?: InputMaybe<Scalars['String']>;
  err?: InputMaybe<Scalars['String']>;
  host: Scalars['String'];
  metadata: RpcReplyMetaData;
};

export type RpcReplyMetaData = {
  id: Scalars['String'];
  time?: InputMaybe<TimestampInput>;
};

export type S3Listing = {
  __typename?: 'S3Listing';
  commonPrefixes: Array<Maybe<Scalars['String']>>;
  objects: Array<S3Object>;
};

export type S3LocationInput = {
  bucketName: Scalars['String'];
  key: Scalars['String'];
  region: Scalars['String'];
};

export type S3Object = {
  __typename?: 'S3Object';
  key: Scalars['String'];
  lastModifiedAt: Maybe<Scalars['String']>;
  uri: Maybe<Scalars['String']>;
};

/** Represents type of service related to shipment */
export enum ServiceType {
  AIR_EXPORT = 'AIR_EXPORT',
  AIR_INTACT = 'AIR_INTACT',
  AIR_LOOSE = 'AIR_LOOSE'
}

export type ServiceTypeOption = {
  __typename?: 'ServiceTypeOption';
  displayName: Scalars['String'];
  value: ServiceType;
};

export type ShipmentActivity = {
  occurredAt: Scalars['String'];
};

export type ShipmentActivityDocumentDeleted = ShipmentActivity & {
  __typename?: 'ShipmentActivityDocumentDeleted';
  documentName: Scalars['String'];
  occurredAt: Scalars['String'];
  systemAction: Scalars['Boolean'];
  uploadedBy: User;
};

export type ShipmentActivityDocumentUpload = ShipmentActivity & {
  __typename?: 'ShipmentActivityDocumentUpload';
  document: ShipmentDocument;
  occurredAt: Scalars['String'];
  systemAction: Scalars['Boolean'];
  uploadedBy: User;
};

export type ShipmentActivityDoorEvent = ShipmentActivity & {
  __typename?: 'ShipmentActivityDoorEvent';
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  opened: Scalars['Boolean'];
  videoThumbnailUri: Maybe<Scalars['String']>;
  videoUri: Scalars['String'];
};

export type ShipmentActivityExceptionCreated = ShipmentActivity & {
  __typename?: 'ShipmentActivityExceptionCreated';
  exceptionId: Scalars['ID'];
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  title: Scalars['String'];
  user: Maybe<User>;
};

export type ShipmentActivityItemsLoaded = ShipmentActivity & {
  __typename?: 'ShipmentActivityItemsLoaded';
  direction: ItemLoadingDirection;
  forkliftId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  itemQuantity: Scalars['Int'];
  items: Array<ShippingItem>;
  occurredAt: Scalars['String'];
  videos: Array<PalletMotionVideo>;
};

export type ShipmentActivityOrderUpdated = ShipmentActivity & {
  __typename?: 'ShipmentActivityOrderUpdated';
  id: Scalars['ID'];
  items: Array<Scalars['String']>;
  occurredAt: Scalars['String'];
  orderId: Scalars['ID'];
  orderNumber: Scalars['String'];
};

export type ShipmentActivityStatusUpdated = ShipmentActivity & {
  __typename?: 'ShipmentActivityStatusUpdated';
  displayStatus: Maybe<Scalars['String']>;
  fromDock: Maybe<Dock>;
  fromStatus: Maybe<ShipmentStatus>;
  occurredAt: Scalars['String'];
  systemAction: Scalars['Boolean'];
  toDock: Maybe<Dock>;
  toStatus: ShipmentStatus;
  user: Maybe<User>;
};

export type ShipmentActivityStringFieldUpdated = ShipmentActivity & {
  __typename?: 'ShipmentActivityStringFieldUpdated';
  fieldId: Scalars['String'];
  fieldName: Scalars['String'];
  fromValue: Maybe<Scalars['String']>;
  occurredAt: Scalars['String'];
  systemAction: Scalars['Boolean'];
  toValue: Maybe<Scalars['String']>;
  user: Maybe<User>;
};

export type ShipmentAdditionalField = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ShipmentAdditionalFieldOutput = {
  __typename?: 'ShipmentAdditionalFieldOutput';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ShipmentContent = {
  __typename?: 'ShipmentContent';
  itemIdentifierColumnName: Scalars['String'];
  items: Array<ShipmentContentItem>;
};

export type ShipmentContentItem = {
  __typename?: 'ShipmentContentItem';
  actualQuantity: Maybe<Scalars['Int']>;
  description: Maybe<Scalars['String']>;
  fields: Array<MultiValueDataField>;
  identifier: Scalars['String'];
  orderQuantity: Maybe<Scalars['Int']>;
  sourceItems: Array<ShippingItem>;
};

export type ShipmentDocument = {
  __typename?: 'ShipmentDocument';
  externalId: Scalars['String'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  shipmentId: Scalars['Int'];
  type: Maybe<Scalars['String']>;
  uploadedAt: Scalars['String'];
};

export type ShipmentExceptionLink = {
  __typename?: 'ShipmentExceptionLink';
  shipment: TruckShipment;
  shipmentId: Scalars['Int'];
};

export type ShipmentFilterInput = {
  before?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Array<TruckDirection>>;
  facilityType?: InputMaybe<Array<FacilityType>>;
  query?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ShipmentStatus>>;
  withFlags?: InputMaybe<Scalars['Boolean']>;
};

export type ShipmentNote = {
  __typename?: 'ShipmentNote';
  canModify: Scalars['Boolean'];
  content: Maybe<ShipmentNoteContent>;
  createdAt: Maybe<Scalars['String']>;
  editedAt: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  user: User;
};

export type ShipmentNoteContent = {
  __typename?: 'ShipmentNoteContent';
  text: Scalars['String'];
};

export type ShipmentNoteContentInput = {
  text: Scalars['String'];
};

export enum ShipmentStatus {
  AT_FACILITY = 'AT_FACILITY',
  CHECKED_OUT = 'CHECKED_OUT',
  DEPARTED = 'DEPARTED',
  DOCKED = 'DOCKED',
  DOOR_ASSIGNED = 'DOOR_ASSIGNED',
  LOADED = 'LOADED',
  LOADING = 'LOADING',
  NEW = 'NEW',
  SCHEDULED = 'SCHEDULED',
  UNLOADED = 'UNLOADED',
  UNLOADING = 'UNLOADING'
}

export type ShipmentStatusEvent = {
  __typename?: 'ShipmentStatusEvent';
  completed: Scalars['Boolean'];
  completedAt: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  status: ShipmentStatus;
};

/** An enum to be assigned to scheduled shipments as they progress through Kargo's status system. */
export enum ShipmentUpdateStatus {
  /** Truck driver checks in OR API request is received indicating the trailer has arrived. */
  AT_FACILITY = 'AT_FACILITY',
  /** Checked Out. */
  CHECKED_OUT = 'CHECKED_OUT',
  /** Dock door assigned. */
  DOOR_ASSIGNED = 'DOOR_ASSIGNED',
  /** Appointment has been generated but has not yet arrived. */
  SCHEDULED = 'SCHEDULED'
}

export type ShipmentUri = {
  __typename?: 'ShipmentUri';
  businessId: Scalars['Int'];
  dockId: Scalars['Int'];
  facilityId: Scalars['Int'];
  id: Scalars['Int'];
};

export enum ShipmentsCsvFileFormat {
  PALLET_LEVEL = 'PALLET_LEVEL',
  SHIPMENT_LEVEL = 'SHIPMENT_LEVEL'
}

export type ShipperRequest = {
  __typename?: 'ShipperRequest';
  address: Address;
  bolNumber: Maybe<Scalars['String']>;
  carrier: Maybe<Scalars['String']>;
  consignee: Scalars['String'];
  contactNumber: Scalars['String'];
  createdAt: Scalars['String'];
  email: Scalars['String'];
  externalId: Scalars['String'];
  formType: ShipperRequestFormType;
  items: Array<ShipperRequestItem>;
  notes: Maybe<Scalars['String']>;
  orderNumber: Scalars['String'];
  sealNumber: Maybe<Scalars['String']>;
  shipmentDate: Scalars['String'];
  shipmentUri: Maybe<ShipmentUri>;
  status: ShipperRequestStatus;
};

export type ShipperRequestFilter = {
  endDate?: InputMaybe<Scalars['String']>;
  formType: ShipperRequestFormType;
  startDate?: InputMaybe<Scalars['String']>;
};

export type ShipperRequestForm = {
  __typename?: 'ShipperRequestForm';
  businessId: Scalars['Int'];
  facilityAddress: Scalars['String'];
  facilityId: Scalars['Int'];
  facilityName: Scalars['String'];
  facilityPhone: Scalars['String'];
  form: Form;
};

export type ShipperRequestFormInput = {
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  formJson: Scalars['String'];
  formType: ShipperRequestFormType;
  formVersion: Scalars['String'];
};

export enum ShipperRequestFormType {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type ShipperRequestItem = {
  __typename?: 'ShipperRequestItem';
  item: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  unitType: ShipperUnitType;
  units: Scalars['Int'];
  weight: Scalars['Int'];
};

export enum ShipperRequestStatus {
  COMPLETED = 'COMPLETED',
  DISCREPANCY = 'DISCREPANCY',
  LATE = 'LATE',
  SCHEDULED = 'SCHEDULED'
}

export enum ShipperUnitType {
  CASE = 'CASE',
  PALLET = 'PALLET'
}

/** Each Shipment is automatically assigned a ShippingDirection. ShippingDirection is assigned when a Shipment is matched to an Order or when ShippinhItems are assigned ItemLoadingDirections. */
export enum ShippingDirection {
  /** Shipment contains both UNLOADING and LOADING ItemLoadingDirection ShippingItems. */
  MIXED = 'MIXED',
  /** Shipment contains exclusively LOADING ItemLoadingDirection ShippingItems. */
  RECEIVING = 'RECEIVING',
  /** Shipment contains exclusively UNLOADING ItemLoadingDirection ShippingItems. */
  SHIPPING = 'SHIPPING',
  /** Shipment has not yet logged any ShippingItems and is not matched with any Order - unclear which ItemLoadingDirection ShippingItem will be moved. */
  UNKNOWN = 'UNKNOWN'
}

export type ShippingItem = {
  __typename?: 'ShippingItem';
  aggregateLabel: AggregateLabel;
  direction: Maybe<TruckDirection>;
  flags: Array<ShippingItemFlag>;
  layerCount: Maybe<Scalars['Int']>;
  occurredAt: Scalars['String'];
  orientation: Maybe<PalletOrientation>;
  partID: Scalars['String'];
  quantity: Scalars['Int'];
  shipmentActivityItemsLoadedId: Scalars['ID'];
};

export type ShippingItemAggregation = {
  __typename?: 'ShippingItemAggregation';
  name: Maybe<Scalars['String']>;
  partID: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Int']>;
};

export type ShippingItemExceptionLink = {
  __typename?: 'ShippingItemExceptionLink';
  item: ShippingItem;
};

export enum ShippingItemFlag {
  CHEP = 'CHEP',
  PARTIAL = 'PARTIAL',
  PARTIALLY_COVERED = 'PARTIALLY_COVERED',
  PECO = 'PECO',
  REGULAR_WOOD = 'REGULAR_WOOD',
  UNDETERMINED_LAYER_COUNT = 'UNDETERMINED_LAYER_COUNT'
}

export type ShippingUnit = {
  __typename?: 'ShippingUnit';
  items: Array<ShippingItem>;
  manifest: Array<ShippingItemAggregation>;
};

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type SplitShipmentInput = {
  shipmentId: Scalars['Int'];
};

export type SplitShipmentResult = {
  __typename?: 'SplitShipmentResult';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type StringFormField = FormField & {
  __typename?: 'StringFormField';
  fieldDisplayName: Scalars['String'];
  fieldName: Scalars['String'];
  multiline: Maybe<Scalars['Boolean']>;
  required: Scalars['Boolean'];
  validation: Maybe<StringValidation>;
};

export enum StringValidation {
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER'
}

export type TTDEstimate = {
  __typename?: 'TTDEstimate';
  estimatedAt: Maybe<Scalars['String']>;
  expectedDepartureAt: Maybe<Scalars['String']>;
  lowerEstimatedDepartureAt: Maybe<Scalars['String']>;
  upperEstimatedDepartureAt: Maybe<Scalars['String']>;
};

export type TTDEstimateFull = {
  __typename?: 'TTDEstimateFull';
  arrivedAt: Maybe<Scalars['String']>;
  business: Maybe<Scalars['String']>;
  departedAt: Maybe<Scalars['String']>;
  dockId: Maybe<Scalars['Int']>;
  estimatedAt: Maybe<Scalars['String']>;
  expectedDepartureAt: Maybe<Scalars['String']>;
  facility: Maybe<Scalars['String']>;
  lowerEstimatedDepartureAt: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
  shipmentId: Maybe<Scalars['Int']>;
  upperEstimatedDepartureAt: Maybe<Scalars['String']>;
};

export type TTDResult = {
  __typename?: 'TTDResult';
  data: Array<TTDEstimateFull>;
};

export type TaggedImage = {
  __typename?: 'TaggedImage';
  brightness: Maybe<Scalars['Float']>;
  identifier: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type TemplateReadLocation = {
  __typename?: 'TemplateReadLocation';
  fieldName: Scalars['String'];
  locationItem: TemplateReadLocationItem;
};

export type TemplateReadLocationItem = {
  __typename?: 'TemplateReadLocationItem';
  fieldType: Maybe<OpsLabelReadingTemplateFieldType>;
  identifierType: Maybe<Scalars['String']>;
  points: Maybe<Array<Array<Scalars['Int']>>>;
  polygons: Maybe<Array<Array<Array<Scalars['Int']>>>>;
  regex: Maybe<Scalars['String']>;
};

export type TimestampInput = {
  secEpoch: Scalars['Int'];
  usPart: Scalars['Int'];
};

export enum TruckDirection {
  mixed = 'mixed',
  receiving = 'receiving',
  shipping = 'shipping',
  unknown = 'unknown'
}

export type TruckShipment = {
  __typename?: 'TruckShipment';
  activities: Array<ShipmentActivity>;
  additionalFields: Array<ShipmentAdditionalFieldOutput>;
  alertBannerText: Maybe<Scalars['String']>;
  arrivedAt: Maybe<Scalars['String']>;
  businessId: Scalars['Int'];
  cargo: Array<ShippingUnit>;
  carrier: Maybe<Scalars['String']>;
  carrierId: Maybe<Scalars['String']>;
  carrierService: Maybe<Scalars['String']>;
  content: ShipmentContent;
  customerShipmentIdentifier: Maybe<Scalars['String']>;
  departedAt: Maybe<Scalars['String']>;
  direction: Maybe<TruckDirection>;
  /** @deprecated Use TruckShipment.exceptions */
  discrepancy: Maybe<Scalars['Boolean']>;
  dock: Maybe<Dock>;
  dockId: Maybe<Scalars['Int']>;
  documents: Array<ShipmentDocument>;
  driverEmailAddress: Maybe<Scalars['String']>;
  driverLicenseNumber: Maybe<Scalars['String']>;
  driverLicensePlate: Maybe<Scalars['String']>;
  driverName: Maybe<Scalars['String']>;
  equipmentType: Maybe<EquipmentType>;
  estimatedTimeToDeparture: Maybe<TTDEstimate>;
  exceptions: Array<Exception>;
  expectedArrivalAt: Maybe<Scalars['String']>;
  facility: Facility;
  facilityId: Scalars['Int'];
  /** @deprecated Use TruckShipment.exceptions */
  flags: Array<TruckShipmentFlag>;
  id: Scalars['Int'];
  item: Maybe<ShippingItem>;
  loadingEndAt: Maybe<Scalars['String']>;
  loadingStartAt: Maybe<Scalars['String']>;
  notes: Array<ShipmentNote>;
  orders: Array<Order>;
  processing: Scalars['Boolean'];
  purchaseOrder: Maybe<Scalars['String']>;
  sealNumber: Maybe<Scalars['String']>;
  serviceType: Maybe<ServiceType>;
  shipFromAddress: Maybe<Address>;
  shipToAddress: Maybe<Address>;
  status: Maybe<ShipmentStatus>;
  statusEvent: Maybe<ShipmentStatusEvent>;
  statusEvents: Array<ShipmentStatusEvent>;
  trailerNumber: Maybe<Scalars['String']>;
};


export type TruckShipmentitemArgs = {
  partID: Scalars['String'];
};

export type TruckShipmentFlag = {
  __typename?: 'TruckShipmentFlag';
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  occurredAt: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type TruckShipmentFlagInput = {
  notifyUsers: Scalars['Boolean'];
  truckShipmentId: Scalars['Int'];
  type: Scalars['String'];
};

export type TunnelSpec = {
  __typename?: 'TunnelSpec';
  host: Maybe<Scalars['String']>;
  port: Maybe<Scalars['Int']>;
};

export type TwoPalletConfiguration = PalletConfiguration & {
  __typename?: 'TwoPalletConfiguration';
  configurationType: ConfigurationType;
  doublePalletConfiguration: PalletConfigurationDouble;
};

export type UnlinkShipmentsResult = {
  __typename?: 'UnlinkShipmentsResult';
  success: Scalars['Boolean'];
};

export type UnlinkedObservedShipment = {
  __typename?: 'UnlinkedObservedShipment';
  arrivedAt: Scalars['String'];
  dockDisplayName: Scalars['String'];
  shipmentId: Scalars['Int'];
};

export type UnlinkedScheduledShipment = {
  __typename?: 'UnlinkedScheduledShipment';
  atFacilityAt: Maybe<Scalars['String']>;
  customerShipmentNumber: Scalars['String'];
  direction: ShippingDirection;
  doorAssignedAt: Maybe<Scalars['String']>;
  expectedArrivalAt: Maybe<Scalars['String']>;
  expectedDockDisplayName: Maybe<Scalars['String']>;
  scheduledAt: Scalars['String'];
  shipmentId: Scalars['Int'];
  status: Scalars['String'];
};

export type UnlinkedShipmentsFilter = {
  businessSlug: Scalars['String'];
  createdAfterDate?: InputMaybe<Scalars['String']>;
  createdBeforeDate?: InputMaybe<Scalars['String']>;
  dockSlug?: InputMaybe<Scalars['String']>;
  facilitySlug: Scalars['String'];
};

export type UnlinkedShipmentsResult = {
  __typename?: 'UnlinkedShipmentsResult';
  observedShipments: Array<UnlinkedObservedShipment>;
  scheduledShipments: Array<UnlinkedScheduledShipment>;
};

export type UpdateDefaultExceptionOwnerInput = {
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  issueType: Scalars['String'];
  newOwnerId: Scalars['ID'];
};

export type UpdateDefaultExceptionSharedWithUsersInput = {
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  issueType: Scalars['String'];
  newSharedUserIds: Array<Scalars['ID']>;
};

export type UpdateExceptionIssueTypeInput = {
  businessSlug: Scalars['String'];
  exceptionId: Scalars['String'];
  facilitySlug: Scalars['String'];
  issueType: Scalars['String'];
};

export type UpdateExceptionNoteInput = {
  content: ExceptionNoteContentInput;
  noteId: Scalars['ID'];
};

export type UpdateExceptionOwnerInput = {
  businessSlug: Scalars['String'];
  exceptionId: Scalars['ID'];
  facilitySlug: Scalars['String'];
  userId: Scalars['ID'];
};

export type UpdateExceptionPriorityInput = {
  businessSlug: Scalars['String'];
  exceptionId: Scalars['String'];
  facilitySlug: Scalars['String'];
  updatedPriority: ExceptionPriority;
};

export type UpdateExceptionSharedWithUsersInput = {
  businessSlug: Scalars['String'];
  exceptionId: Scalars['ID'];
  facilitySlug: Scalars['String'];
  userIds: Array<Scalars['ID']>;
};

export type UpdateExceptionStatusInput = {
  businessSlug: Scalars['String'];
  exceptionId: Scalars['ID'];
  facilitySlug: Scalars['String'];
  status: ExceptionStatus;
};

export type UpdateExceptionsOwnerInput = {
  businessSlug: Scalars['String'];
  exceptionIds: Array<Scalars['ID']>;
  facilitySlug: Scalars['String'];
  userId: Scalars['ID'];
};

export type UpdateExceptionsStatusesInput = {
  businessSlug: Scalars['String'];
  exceptionIds: Array<Scalars['ID']>;
  facilitySlug: Scalars['String'];
  status: ExceptionStatus;
};

export type UpdateFacilityLightsResult = {
  __typename?: 'UpdateFacilityLightsResult';
  success: Scalars['Boolean'];
};

export type UpdateFeatureForBusinessResult = {
  __typename?: 'UpdateFeatureForBusinessResult';
  success: Maybe<Scalars['Boolean']>;
};

export type UpdateFeatureForUserResult = {
  __typename?: 'UpdateFeatureForUserResult';
  success: Maybe<Scalars['Boolean']>;
};

export type UpdateIdentifiedLabelInput = {
  fieldsOrdered: Array<OpsFieldsOrderedInput>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  identifier: Scalars['String'];
  identifierType: Scalars['String'];
  label_type?: InputMaybe<Scalars['String']>;
  palletId?: InputMaybe<Scalars['String']>;
  palletLabelImageId?: InputMaybe<Scalars['Int']>;
};

export type UpdateLabelReadingTemplateInput = {
  templateId: Scalars['Int'];
  templateState: LabelReadingTemplateState;
};

export type UpdatePalletLabelInput = {
  alternativeLpnList: Array<OpsPalletLabelSegmentInput>;
  contentAggregationState: OpsPalletAggregationState;
  fields: Array<OpsPalletLabelFieldSegmentInput>;
  licensePlateNumbers: Array<OpsPalletLabelSegmentInput>;
  palletContentIds: Array<OpsPalletLabelSegmentInput>;
  palletEventId: Scalars['ID'];
};

export type UpdatePalletLayerCountInput = {
  layerCount?: InputMaybe<Scalars['Int']>;
  palletEventId: Scalars['ID'];
};

/** Mutator to create a new shipment or update an existing one. */
export type UpdateShipmentInput = {
  /** Extraneous information about a shipment for integrations */
  additionalFields?: InputMaybe<Array<ShipmentAdditionalField>>;
  /** The short name referencing a business, e.g. "kargo". */
  businessSlug: Scalars['String'];
  /** Carrier associated with the Shipment. */
  carrier?: InputMaybe<Scalars['String']>;
  /** Carrier service associated with the Shipment, e.g. FTL / LTL / FCL / LCL. */
  carrierService?: InputMaybe<Scalars['String']>;
  /** Direction of the Shipment associated with this Appointment. */
  direction?: InputMaybe<ShippingDirection>;
  /** The short name referencing a dock, e.g. "D11". */
  dockSlug?: InputMaybe<Scalars['String']>;
  driverEmailAddress?: InputMaybe<Scalars['String']>;
  /** License number of driver for shipment */
  driverLicenseNumber?: InputMaybe<Scalars['String']>;
  /** License plate number of vehicle driven by driver for shipment */
  driverLicensePlate?: InputMaybe<Scalars['String']>;
  /** Name of driver for shipment */
  driverName?: InputMaybe<Scalars['String']>;
  /** Type of equipment used for shipment */
  equipmentType?: InputMaybe<EquipmentType>;
  /** Facility-provided appointment slot. For appointment slots spanning multiple hours, the starting timestamp. */
  expectedArrivalAt?: InputMaybe<Scalars['String']>;
  /** The short name referencing a facility, e.g. "san-francisco". */
  facilitySlug: Scalars['String'];
  /** Identification number for a container seal */
  sealNumber?: InputMaybe<Scalars['String']>;
  /** Type of service used for shipment */
  serviceType?: InputMaybe<ServiceType>;
  /**
   * Unique facility-provided identification number for the shipment.
   * If not provided, Kargo will generate an ID for this shipment automatically.
   */
  shipmentNumber?: InputMaybe<Scalars['String']>;
  /** Indicates what kind of event occurred. */
  status?: InputMaybe<ShipmentUpdateStatus>;
  /** When the event occurred, in ISO 8601 format. */
  statusOccurredAt?: InputMaybe<Scalars['String']>;
  /** Trailer number associated with the Shipment associated with this Appointment. */
  trailerNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateShipmentNoteInput = {
  noteId: Scalars['ID'];
  updatedContent: ShipmentNoteContentInput;
};

export type UpdateShipmentOrderItemsInput = {
  expectedQuantity?: InputMaybe<Scalars['Int']>;
  items: Array<CreateOrUpdateOrderItemInput>;
  orderId: Scalars['ID'];
};

export type UpdateShipmentResult = {
  __typename?: 'UpdateShipmentResult';
  id: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type UpdateShippingItemFlagsInput = {
  flags: Array<ShippingItemFlag>;
  id: Scalars['String'];
};

export type UpdateShippingItemFlagsResult = {
  __typename?: 'UpdateShippingItemFlagsResult';
  success: Scalars['Boolean'];
};

export type UpdateTaskStatusInput = {
  status: OpsTaskStatus;
  taskId: Scalars['Int'];
};

export type UpdateTaskStatusResult = {
  __typename?: 'UpdateTaskStatusResult';
  success: Scalars['Boolean'];
  task: Maybe<OpsTask>;
};

export type UploadExceptionDocumentInput = {
  businessSlug: Scalars['String'];
  exceptionId: Scalars['ID'];
  facilitySlug: Scalars['String'];
};

export type UploadGistDocumentResult = {
  __typename?: 'UploadGistDocumentResult';
  messages: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UploadShipmentDocumentInput = {
  shipmentId: Scalars['Int'];
};

export type UploadShipmentDocumentResult = {
  __typename?: 'UploadShipmentDocumentResult';
  success: Scalars['Boolean'];
};

export type UpsertFlagMetadataInput = {
  issueType: Scalars['String'];
  title: Scalars['String'];
};

export type UpsertOrderInput = {
  bolNumber?: InputMaybe<Scalars['String']>;
  businessSlug: Scalars['String'];
  carrier?: InputMaybe<Scalars['String']>;
  carrierService?: InputMaybe<Scalars['String']>;
  consigneeName?: InputMaybe<Scalars['String']>;
  consigneePhoneNumber?: InputMaybe<Scalars['String']>;
  direction: OrderDirection;
  expectedQuantity?: InputMaybe<Scalars['Int']>;
  facilitySlug: Scalars['String'];
  id: Scalars['ID'];
  items: Array<OpsOrderItemInput>;
  orderNumber: Scalars['String'];
  orderType?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['String']>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']>;
  requestedShipDate?: InputMaybe<Scalars['String']>;
  sealNumber?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['Int']>;
  shipperAddress?: InputMaybe<AddressInput>;
  shipperEmail?: InputMaybe<Scalars['String']>;
  shipperName?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  externalId: Scalars['ID'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};

export type UserFeatureFlag = IFeatureFlag & {
  __typename?: 'UserFeatureFlag';
  displayName: Scalars['String'];
  enabledVariantId: Scalars['String'];
  featureId: Scalars['String'];
  scopes: Array<BusinessScopeFeatureFlag>;
  variants: Array<FeatureFlagVariant>;
};

export type ValidateLabelReadingTemplateResult = {
  __typename?: 'ValidateLabelReadingTemplateResult';
  responseSummary: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum WeightUnit {
  KILOGRAM = 'KILOGRAM',
  POUND = 'POUND'
}

export type DockEventsGetBusinessesFacilitiesDocksQueryVariables = Exact<{ [key: string]: never; }>;


export type DockEventsGetBusinessesFacilitiesDocksQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', businesses: Array<{ __typename?: 'OpsBusiness', id: string, slug: string, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, timeZone: string | null, docks: Array<{ __typename?: 'OpsDock', id: string, slug: string }> }> }> } };

export type FeatureFlagsByBusinessSlugQueryVariables = Exact<{
  businessSlug: Scalars['String'];
}>;


export type FeatureFlagsByBusinessSlugQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', featureFlagsByBusinessSlug: Array<{ __typename?: 'BusinessFeatureFlag', featureId: string, enabledVariantId: string, displayName: string, variants: Array<{ __typename?: 'FeatureFlagVariant', variantId: string, displayName: string }> }> } };

export type UpdateFeatureForBusinessMutationVariables = Exact<{
  businessSlug: Scalars['String'];
  featureId: Scalars['String'];
  variantId: Scalars['String'];
}>;


export type UpdateFeatureForBusinessMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateFeatureForBusiness: { __typename?: 'UpdateFeatureForBusinessResult', success: boolean | null } | null } | null };

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, displayName: string, createdAt: string, updatedAt: string, defaultValue: string, variants: Array<{ __typename?: 'FeatureFlagVariant', variantId: string, displayName: string }> }> } };

export type UpsertFeatureFlagMutationVariables = Exact<{
  input: FeatureFlagInput;
}>;


export type UpsertFeatureFlagMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', upsertFeatureFlag: { __typename?: 'FeatureFlag', id: string, displayName: string, createdAt: string, updatedAt: string, defaultValue: string, variants: Array<{ __typename?: 'FeatureFlagVariant', variantId: string, displayName: string }> } } | null };

export type FeatureFlagsByUserEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type FeatureFlagsByUserEmailQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', featureFlagsByUserEmail: Array<{ __typename?: 'UserFeatureFlag', featureId: string, enabledVariantId: string, displayName: string, variants: Array<{ __typename?: 'FeatureFlagVariant', variantId: string, displayName: string }>, scopes: Array<{ __typename?: 'BusinessScopeFeatureFlag', businessId: number, enabledVariantId: string }> }> } };

export type UpdateFeatureForUserMutationVariables = Exact<{
  email: Scalars['String'];
  featureId: Scalars['String'];
  variantId: Scalars['String'];
}>;


export type UpdateFeatureForUserMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateFeatureForUser: { __typename?: 'UpdateFeatureForUserResult', success: boolean | null } | null } | null };

export type EditLabelsImagesListFragment = { __typename?: 'OpsLabelsAndImages', images: Array<{ __typename?: 'OpsPalletImages', brightness: number | null, id: number, imageUri: string, ocrLabelResultFormatted: string | null, cameraId: number | null, edgeId: number | null }> };

export type IdentifiedLabelsQueryVariables = Exact<{
  palletId: Scalars['Int'];
}>;


export type IdentifiedLabelsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', identifiedLabels: { __typename?: 'OpsLabelsAndImages', businessName: string, businessId: number, dockName: string, dockId: number, edgeId: number, facilityName: string, facilityId: number, endAt: string, startAt: string, timestamp: string, images: Array<{ __typename?: 'OpsPalletImages', brightness: number | null, id: number, imageUri: string, ocrLabelResultFormatted: string | null, cameraId: number | null, edgeId: number | null }>, labels: Array<{ __typename?: 'OpsIdentifiedLabel', hidden: boolean | null, id: number, palletId: string | null, identifier: string, identifierType: string | null, label_type: string | null, fieldsOrdered: Array<{ __typename?: 'OpsFieldsOrdered', name: string | null, value: string | null } | null> | null, source: { __typename?: 'LabelSource', templateId: string } | null, palletImages: Array<{ __typename?: 'OpsPalletImages', brightness: number | null, id: number, imageUri: string, ocrLabelResultFormatted: string | null } | null> | null }> } } };

export type UpdateIdentifiedLabelMutationVariables = Exact<{
  input: UpdateIdentifiedLabelInput;
}>;


export type UpdateIdentifiedLabelMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updateIdentifiedLabel: { __typename?: 'OpsUpdateIdentifiedLabelResult', success: boolean } | null } | null };

export type DeleteIdentifiedLabelMutationVariables = Exact<{
  identifiedLabelId: Scalars['Int'];
  shouldDelete: Scalars['Boolean'];
}>;


export type DeleteIdentifiedLabelMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', deleteIdentifiedLabel: { __typename?: 'OpsDeleteIdentifiedLabelResult', success: boolean } | null } | null };

export type EditLabelsPalletInfoFragment = { __typename?: 'OpsLabelsAndImages', businessName: string, businessId: number, dockName: string, dockId: number, edgeId: number, facilityName: string, facilityId: number, endAt: string, startAt: string, timestamp: string };

export type EditLabelsListFragment = { __typename?: 'OpsLabelsAndImages', labels: Array<{ __typename?: 'OpsIdentifiedLabel', hidden: boolean | null, id: number, palletId: string | null, identifier: string, identifierType: string | null, label_type: string | null, fieldsOrdered: Array<{ __typename?: 'OpsFieldsOrdered', name: string | null, value: string | null } | null> | null, source: { __typename?: 'LabelSource', templateId: string } | null, palletImages: Array<{ __typename?: 'OpsPalletImages', brightness: number | null, id: number, imageUri: string, ocrLabelResultFormatted: string | null } | null> | null }> };

export type AdminExceptionsMetadataSelectFragment = { __typename?: 'ExceptionsMetadata', categoryDisplayName: string, issueType: string, title: string };

export type AdminExceptionsMetadataSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminExceptionsMetadataSelectQuery = { __typename?: 'Query', exceptionsMetadata: Array<{ __typename?: 'ExceptionsMetadata', categoryDisplayName: string, issueType: string, title: string }> };

export type RequestTowerVideoQueryVariables = Exact<{
  input: OpsRequestTowerVideo;
}>;


export type RequestTowerVideoQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', requestTowerVideo: { __typename?: 'OpsRequestTowerVideoResult', success: boolean, videoUrl: string | null, s3Path: string | null } } };

export type GenerateSignedUrlQueryVariables = Exact<{
  s3Path: Scalars['String'];
}>;


export type GenerateSignedUrlQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', generateSignedUrl: { __typename?: 'OpsSignedUrlResult', exists: boolean, fileUrl: string | null } | null } };

export type ObtainPalletDataQueryVariables = Exact<{
  palletId: Scalars['Int'];
}>;


export type ObtainPalletDataQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', identifiedLabels: { __typename?: 'OpsLabelsAndImages', businessId: number, dockId: number, edgeId: number, facilityId: number, startAt: string, endAt: string } } };

export type UploadGistDocumentMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadGistDocumentMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', uploadGistDocument: { __typename?: 'UploadGistDocumentResult', success: boolean, messages: Array<string> } } | null };

export type HomePageGetLoadingEventParentShipmentQueryVariables = Exact<{
  loadingEventId: Scalars['Int'];
}>;


export type HomePageGetLoadingEventParentShipmentQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', loadingEvent: { __typename?: 'OpsLoadingEvent', id: number, shipmentId: number | null } | null } };

export type HomePageGetPalletEventParentShipmentQueryVariables = Exact<{
  palletEventId: Scalars['Int'];
}>;


export type HomePageGetPalletEventParentShipmentQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', palletEvent: { __typename?: 'OpsPallet', id: number, loadingEventId: number | null, shipmentId: number | null } | null } };

export type GetItemDisplayNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetItemDisplayNamesQuery = { __typename?: 'Query', businesses: Array<{ __typename?: 'Business', id: number, facilities: Array<{ __typename?: 'Facility', id: number, name: string | null, itemDisplayNames: Array<{ __typename?: 'ItemLabelToDisplayName', label: string, displayName: string, hideFromLabelers: boolean | null }> }> }> };

export type ValidateLabelReadingTemplateQueryVariables = Exact<{
  templateId: Scalars['Int'];
  numberOfImages: Scalars['Int'];
}>;


export type ValidateLabelReadingTemplateQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', validateLabelReadingTemplate: { __typename?: 'ValidateLabelReadingTemplateResult', success: boolean, responseSummary: string } } };

export type OpsTasksOpsDockEventFragment = { __typename?: 'OpsDockEvent', at: string | null, details: string | null, dockId: number | null, type: string | null, videoUri: string | null, videoExternalId: string | null };

export type UpdateLoadingEventMutationVariables = Exact<{
  loadingEventId: Scalars['Int'];
  direction: ItemLoadingDirection;
  palletCount: Scalars['Int'];
}>;


export type UpdateLoadingEventMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updateLoadingEvent: boolean } | null };

export type AddDoorEventMutationVariables = Exact<{
  videoExternalId: Scalars['String'];
  opened: Scalars['Boolean'];
}>;


export type AddDoorEventMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', addDoorEvent: boolean } | null };

export type CreateLoadingEventMutationVariables = Exact<{
  videoExternalId: Scalars['String'];
  direction: ItemLoadingDirection;
  palletCount: Scalars['Int'];
}>;


export type CreateLoadingEventMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', createLoadingEvent: boolean } | null };

export type UpdateItemDisplayNamesMutationVariables = Exact<{
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  displayNames: Array<ItemLabelToDisplayNameInput> | ItemLabelToDisplayNameInput;
}>;


export type UpdateItemDisplayNamesMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updateItemDisplayNames: boolean } | null };

export type OpsTaskRowOpsUserFragment = { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string, id: number }, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, officialName: string | null, business: { __typename?: 'OpsBusiness', id: string, slug: string } }> };

export type OpsTaskRowLoadingEventDetailsFragment = { __typename?: 'OpsTaskLoadingEventDetails', shipmentId: string | null, loadingEventId: number };

export type OpsTaskRowPalletEventDetailsFragment = { __typename?: 'OpsTaskPalletEventDetails', shipmentId: string | null, loadingEventId: number, palletEventId: number };

export type OpsTaskRowTaskFragment = { __typename?: 'OpsTask', id: number, type: OpsTaskType, status: OpsTaskStatus, completedAt: string | null, statusAt: string, parentTask: { __typename?: 'OpsTask', id: number, type: OpsTaskType, status: OpsTaskStatus, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string } | null } | null, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string, email: string } | null, business: { __typename?: 'Business', id: number, slug: string | null } | null, facility: { __typename?: 'Facility', id: number, slug: string } | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, loadingEvent: { __typename?: 'OpsLoadingEvent', occurredAt: string } | null, shipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null } | null, details: { __typename?: 'OpsTaskLoadingEventDetails', shipmentId: string | null, loadingEventId: number } | { __typename?: 'OpsTaskPalletEventDetails', shipmentId: string | null, loadingEventId: number, palletEventId: number } | null };

export type TasksPageOpsUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TasksPageOpsUserQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', opsUser: { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string, id: number }, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, officialName: string | null, business: { __typename?: 'OpsBusiness', id: string, slug: string } }> } } };

export type AssignOpsTaskMutationVariables = Exact<{
  input: AssignTaskInput;
}>;


export type AssignOpsTaskMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', assignTask: { __typename?: 'AssignTaskResult', success: boolean, task: { __typename?: 'OpsTask', id: number, status: OpsTaskStatus, statusAt: string, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string, email: string } | null } | null } } | null };

export type TasksPageUnassignTaskMutationVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type TasksPageUnassignTaskMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', unassignTask: { __typename?: 'OpsTask', id: number, priority: number, createdAt: string, type: OpsTaskType, status: OpsTaskStatus, completedAt: string | null, statusAt: string, parentTask: { __typename?: 'OpsTask', id: number, type: OpsTaskType, status: OpsTaskStatus, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string } | null } | null, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string, email: string } | null, business: { __typename?: 'Business', id: number, slug: string | null } | null, facility: { __typename?: 'Facility', id: number, slug: string } | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, loadingEvent: { __typename?: 'OpsLoadingEvent', occurredAt: string } | null, shipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null } | null, details: { __typename?: 'OpsTaskLoadingEventDetails', shipmentId: string | null, loadingEventId: number } | { __typename?: 'OpsTaskPalletEventDetails', shipmentId: string | null, loadingEventId: number, palletEventId: number } | null } } | null };

export type TasksPageBulkAssignTasksMutationVariables = Exact<{
  input: BulkAssignTasksInput;
}>;


export type TasksPageBulkAssignTasksMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', bulkAssignTasks: { __typename?: 'BulkAssignTasksResult', count: number } } | null };

export type TasksPageBulkUnassignTasksMutationVariables = Exact<{
  input: BulkUnassignTasksInput;
}>;


export type TasksPageBulkUnassignTasksMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', bulkUnassignTasks: { __typename?: 'BulkUnassignTasksResult', count: number } } | null };

export type GetOpsTasksQueryVariables = Exact<{
  filter: OpsTaskFilter;
  after?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type GetOpsTasksQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', tasks: { __typename?: 'OpsTasks', total: number, tasks: Array<{ __typename?: 'OpsTask', id: number, priority: number, createdAt: string, type: OpsTaskType, status: OpsTaskStatus, completedAt: string | null, statusAt: string, parentTask: { __typename?: 'OpsTask', id: number, type: OpsTaskType, status: OpsTaskStatus, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string } | null } | null, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string, email: string } | null, business: { __typename?: 'Business', id: number, slug: string | null } | null, facility: { __typename?: 'Facility', id: number, slug: string } | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, loadingEvent: { __typename?: 'OpsLoadingEvent', occurredAt: string } | null, shipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null } | null, details: { __typename?: 'OpsTaskLoadingEventDetails', shipmentId: string | null, loadingEventId: number } | { __typename?: 'OpsTaskPalletEventDetails', shipmentId: string | null, loadingEventId: number, palletEventId: number } | null }> } } };

export type UpsertOrderMutationVariables = Exact<{
  input: UpsertOrderInput;
}>;


export type UpsertOrderMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', upsertOrder: { __typename?: 'OpsOrder', id: string, businessSlug: string, facilitySlug: string, orderNumber: string, direction: OrderDirection, orderType: string | null, purchaseOrder: string | null, requestedShipDate: string | null, requestedDeliveryDate: string | null, shipperName: string | null, shipperEmail: string | null, consigneeName: string | null, consigneePhoneNumber: string | null, carrierService: string | null, carrier: string | null, bolNumber: string | null, sealNumber: string | null, status: OrderStatus, shipmentId: number | null, expectedQuantity: number | null, shipperAddress: { __typename?: 'OpsOrderAddress', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, items: Array<{ __typename?: 'OpsOrderItem', id: string, identifier: string, quantity: number | null, quantityUnit: ShipperUnitType, purchaseOrder: string | null, description: string | null, weightPerUnit: number | null, weightUnit: WeightUnit | null, sku: string | null, lpn: string | null }> } } | null };

export type AdminOrderEditFragment = { __typename?: 'OpsOrder', id: string, businessSlug: string, facilitySlug: string, orderNumber: string, direction: OrderDirection, orderType: string | null, purchaseOrder: string | null, requestedShipDate: string | null, requestedDeliveryDate: string | null, shipperName: string | null, shipperEmail: string | null, consigneeName: string | null, consigneePhoneNumber: string | null, carrierService: string | null, carrier: string | null, bolNumber: string | null, sealNumber: string | null, status: OrderStatus, shipmentId: number | null, expectedQuantity: number | null, shipperAddress: { __typename?: 'OpsOrderAddress', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, items: Array<{ __typename?: 'OpsOrderItem', id: string, identifier: string, quantity: number | null, quantityUnit: ShipperUnitType, purchaseOrder: string | null, description: string | null, weightPerUnit: number | null, weightUnit: WeightUnit | null, sku: string | null, lpn: string | null }> };

export type GetUnlinkedShipmentsQueryVariables = Exact<{
  filter: UnlinkedShipmentsFilter;
}>;


export type GetUnlinkedShipmentsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', unlinkedShipments: { __typename?: 'UnlinkedShipmentsResult', scheduledShipments: Array<{ __typename?: 'UnlinkedScheduledShipment', shipmentId: number, scheduledAt: string, expectedArrivalAt: string | null, atFacilityAt: string | null, doorAssignedAt: string | null, direction: ShippingDirection, expectedDockDisplayName: string | null, customerShipmentNumber: string, status: string }>, observedShipments: Array<{ __typename?: 'UnlinkedObservedShipment', shipmentId: number, arrivedAt: string, dockDisplayName: string }> } } };

export type LinkShipmentsMutationVariables = Exact<{
  shipmentId1: Scalars['Int'];
  shipmentId2: Scalars['Int'];
}>;


export type LinkShipmentsMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', linkShipments: { __typename?: 'LinkShipmentsResult', success: boolean } } | null };

export type UnlinkShipmentsMutationVariables = Exact<{
  shipmentId1: Scalars['Int'];
  shipmentId2: Scalars['Int'];
}>;


export type UnlinkShipmentsMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', unlinkShipments: { __typename?: 'UnlinkShipmentsResult', success: boolean } } | null };

export type UpdateShipmentCarrierMutationVariables = Exact<{
  input: OpsUpdateShipmentInput;
}>;


export type UpdateShipmentCarrierMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updateShipment: { __typename?: 'OpsShipment', id: string, carrier: string | null } } | null };

export type ArchiveOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type ArchiveOrderMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', archiveOrder: { __typename?: 'OpsOrder', id: string } | null } | null };

export type AdminGetShipmentDocumentsDocumentFragment = { __typename?: 'OpsShipmentDocument', id: string, type: string | null, externalId: string, shipmentId: number, fileName: string, fileUrl: string, uploadedAt: string, ocrResultText: Array<string> | null, ocrProcessedAt: string | null };

export type GetShipmentExceptionsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetShipmentExceptionsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', flagMetadata: Array<{ __typename?: 'OpsFlagMetadata', issueType: string, description: string | null }>, shipment: { __typename?: 'OpsShipment', exceptions: Array<{ __typename?: 'OpsException', id: string, type: string, typeDisplayName: string, level: ExceptionLevel, category: ExceptionCategory, categoryDisplayName: string, displayToUser: boolean, occurredAt: string, updatedAt: string | null, status: ExceptionStatus, priority: ExceptionPriority, source: OpsExceptionSource, statuses: Array<{ __typename?: 'ExceptionStatusEvent', status: ExceptionStatus, occurredAt: string }>, owner: { __typename?: 'User', id: number, externalId: string, firstName: string, lastName: string, email: string } | null }> } | null } };

export type AddTruckShipmentExceptionMutationVariables = Exact<{
  input: TruckShipmentFlagInput;
}>;


export type AddTruckShipmentExceptionMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', addTruckShipmentFlag: boolean } | null };

export type HideExceptionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HideExceptionMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', hideException: boolean } | null };

export type LoadingEventsQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
}>;


export type LoadingEventsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', loadingEvents: { __typename?: 'OpsLoadingEvents', loadingEvents: Array<{ __typename?: 'OpsLoadingEvent', id: number, direction: string | null, endAt: string | null, items: string | null, occurredAt: string, palletCount: number | null, labelStatesAutoCheckedAt: string | null, startAt: string | null, pallets: Array<{ __typename?: 'OpsPallet', id: number, hasPalletClassLabel: boolean, hasPalletIdLabel: boolean, annotation: { __typename?: 'PalletAnnotation', missingLabelReason: { __typename?: 'PalletAnnotationMissingLabelReason', PALLET_CLASS_ANNOTATION: Array<PalletAnnotationRootCause> | null, PALLET_ID_ANNOTATION: Array<PalletAnnotationRootCause> | null } } | null }> }> } | null } };

export type LoadingEventEditLabelsPalletEditFragment = { __typename?: 'OpsLabelsAndImages', loadingEventId: number | null, direction: number | null, palletCount: number | null };

export type GetLoadingEventQueryVariables = Exact<{
  loadingEventId: Scalars['Int'];
}>;


export type GetLoadingEventQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', loadingEvent: { __typename?: 'OpsLoadingEvent', id: number, palletCount: number | null, direction: string | null } | null } };

export type EditLoadingEventTaskUpdateLoadingEventMutationVariables = Exact<{
  loadingEventId: Scalars['Int'];
  direction: ItemLoadingDirection;
  palletCount: Scalars['Int'];
  palletConfiguration?: InputMaybe<PalletConfigurationInput>;
}>;


export type EditLoadingEventTaskUpdateLoadingEventMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updateLoadingEvent: boolean } | null };

export type LoadingEventEditLabelsImagesListFragment = { __typename?: 'OpsPalletImages', id: number, brightness: number | null, imageUri: string, ocrLabelResultFormatted: string | null, cameraId: number | null, edgeId: number | null, eventType: string | null };

export type LoadingEventEditLabelsPalletInfoFragment = { __typename?: 'OpsLabelsAndImages', businessName: string, businessId: number, dockName: string, dockId: number, edgeIds: Array<number>, facilityName: string, facilityId: number, timestamps: Array<string>, cameraIds: Array<number> };

export type PalletAnnotationFragment = { __typename?: 'OpsPallet', id: number, hasPalletClassLabel: boolean, hasPalletIdLabel: boolean, annotation: { __typename?: 'PalletAnnotation', missingLabelReason: { __typename?: 'PalletAnnotationMissingLabelReason', PALLET_CLASS_ANNOTATION: Array<PalletAnnotationRootCause> | null, PALLET_ID_ANNOTATION: Array<PalletAnnotationRootCause> | null } } | null };

export type PalletListFragment = { __typename?: 'OpsPallet', id: number, hasPalletClassLabel: boolean, hasPalletIdLabel: boolean, shipmentId: number | null, loadingEventId: number | null, flags: Array<ShippingItemFlag>, annotation: { __typename?: 'PalletAnnotation', missingLabelReason: { __typename?: 'PalletAnnotationMissingLabelReason', PALLET_CLASS: PalletAnnotationRootCause | null, PALLET_ID: PalletAnnotationRootCause | null } } | null };

export type AdminGetShipmentOrdersOrderFragment = { __typename?: 'OpsOrder', id: string, orderNumber: string, consigneeName: string | null, status: OrderStatus, direction: OrderDirection, archived: boolean, expectedQuantity: number | null, items: Array<{ __typename?: 'OpsOrderItem', id: string, quantity: number | null, sku: string | null, lpn: string | null }> };

export type MergeShipmentsMutationVariables = Exact<{
  input: MergeShipmentsInput;
}>;


export type MergeShipmentsMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', mergeShipments: { __typename?: 'MergeShipmentsResult', success: boolean, message: string } } | null };

export type SplitShipmentMutationVariables = Exact<{
  input: SplitShipmentInput;
}>;


export type SplitShipmentMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', splitShipment: { __typename?: 'SplitShipmentResult', success: boolean, message: string } } | null };

export type TaskSummaryViewListFragment = { __typename?: 'OpsTaskSummary', businessId: string, businessSlug: string, facilityId: string, facilitySlug: string, taskType: OpsTaskType, taskStatus: OpsTaskStatus, count: number, oldestIncomplete: string | null };

export type AvailableFiltersQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type AvailableFiltersQuery = { __typename?: 'Query', analytics: { __typename?: 'AnalyticsRoot', getAnalyticsAvailableFilters: { __typename?: 'AnalyticsAvailableFiltersResult', availableFilters: Array<{ __typename?: 'AnalyticsAvailableFilter', displayName: string, fieldName: string, values: Array<string> }> } } };

export type AnalyticsLineChartFragment = { __typename?: 'AnalyticsReportResult', result: Array<{ __typename?: 'AnalyticsResultEntry', label: string, breakDowns: Array<{ __typename?: 'AnalyticsBreakDownEntries', label: string, value: number }> }> };

export type ExceptionsActivitiesFragment = { __typename?: 'Exception', id: string, activities: Array<{ __typename?: 'ExceptionActivityCreated', id: string, occurredAt: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityDeletedDocumentUploaded', id: string, occurredAt: string, documentName: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityDocumentDeleted', id: string, occurredAt: string, documentName: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityDocumentUploaded', id: string, occurredAt: string, document: { __typename?: 'ExceptionDocument', id: string, type: string | null, fileName: string, fileUrl: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string } | null }, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityIssueTypeUpdated', id: string, occurredAt: string, fromIssueType: string | null, toIssueType: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityLevelUpdated', id: string, occurredAt: string, fromLevel: ExceptionLevel | null, toLevel: ExceptionLevel, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityOwnerUpdated', id: string, occurredAt: string, previousOwner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, newOwner: { __typename?: 'User', id: number, firstName: string, lastName: string }, changedByUser: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityPriorityUpdated', id: string, occurredAt: string, fromPriority: ExceptionPriority | null, toPriority: ExceptionPriority, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivitySharedWithUsersAdded', id: string, occurredAt: string, sharedWithUsersAdded: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }>, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivitySharedWithUsersDeleted', id: string, occurredAt: string, sharedWithUsersDeleted: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }>, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityStatusUpdated', id: string, occurredAt: string, fromStatus: ExceptionStatus | null, toStatus: ExceptionStatus, systemAction: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null }> };

export type ExceptionActivityCreatedFragment = { __typename?: 'ExceptionActivityCreated', id: string, occurredAt: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityDeletedDocumentUploadedFragment = { __typename?: 'ExceptionActivityDeletedDocumentUploaded', id: string, occurredAt: string, documentName: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityDocumentDeletedFragment = { __typename?: 'ExceptionActivityDocumentDeleted', id: string, occurredAt: string, documentName: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityDocumentUploadedFragment = { __typename?: 'ExceptionActivityDocumentUploaded', id: string, occurredAt: string, document: { __typename?: 'ExceptionDocument', id: string, type: string | null, fileName: string, fileUrl: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string } | null }, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityIssueTypeUpdatedFragment = { __typename?: 'ExceptionActivityIssueTypeUpdated', id: string, occurredAt: string, fromIssueType: string | null, toIssueType: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityLevelUpdatedFragment = { __typename?: 'ExceptionActivityLevelUpdated', id: string, occurredAt: string, fromLevel: ExceptionLevel | null, toLevel: ExceptionLevel, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityOwnerUpdatedFragment = { __typename?: 'ExceptionActivityOwnerUpdated', id: string, occurredAt: string, previousOwner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, newOwner: { __typename?: 'User', id: number, firstName: string, lastName: string }, changedByUser: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityPriorityUpdatedFragment = { __typename?: 'ExceptionActivityPriorityUpdated', id: string, occurredAt: string, fromPriority: ExceptionPriority | null, toPriority: ExceptionPriority, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivitySharedWithUsersAddedFragment = { __typename?: 'ExceptionActivitySharedWithUsersAdded', id: string, occurredAt: string, sharedWithUsersAdded: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }>, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivitySharedWithUsersDeletedFragment = { __typename?: 'ExceptionActivitySharedWithUsersDeleted', id: string, occurredAt: string, sharedWithUsersDeleted: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }>, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionActivityStatusUpdatedFragment = { __typename?: 'ExceptionActivityStatusUpdated', id: string, occurredAt: string, fromStatus: ExceptionStatus | null, toStatus: ExceptionStatus, systemAction: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionsDocumentsFragment = { __typename?: 'Exception', id: string, documents: Array<{ __typename?: 'ExceptionDocument', id: string, fileName: string, fileUrl: string, type: string | null, uploadedAt: string }> };

export type ExceptionsDetailsViewHeaderFragment = { __typename?: 'Exception', id: string, occurredAt: string, statuses: Array<{ __typename?: 'ExceptionStatusEvent', status: ExceptionStatus }> };

export type ExceptionsDetailsViewDeleteExceptionConfirmationMutationVariables = Exact<{
  input: DeleteExceptionInput;
}>;


export type ExceptionsDetailsViewDeleteExceptionConfirmationMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteException: boolean } | null };

export type ExceptionsDetailsViewDeleteExceptionConfirmationFragment = { __typename?: 'Exception', id: string };

export type ExceptionsDetailsViewMoreActionsFragment = { __typename?: 'Exception', id: string, statuses: Array<{ __typename?: 'ExceptionStatusEvent', status: ExceptionStatus }> };

export type ExceptionsDetailsViewReopenExceptionConfirmationMutationVariables = Exact<{
  input: UpdateExceptionStatusInput;
}>;


export type ExceptionsDetailsViewReopenExceptionConfirmationMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionStatus: { __typename?: 'Exception', id: string } } | null };

export type ExceptionsDetailsViewReopenExceptionConfirmationFragment = { __typename?: 'Exception', id: string };

export type ExceptionsDetailsOverviewLeftFragment = { __typename?: 'Exception', id: string, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, sharedWithUsers: Array<{ __typename?: 'User', id: number, externalId: string, firstName: string, lastName: string }> };

export type ExceptionsDetailsOverviewUpdateExceptionsOwnerMutationVariables = Exact<{
  input: UpdateExceptionOwnerInput;
}>;


export type ExceptionsDetailsOverviewUpdateExceptionsOwnerMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionOwner: { __typename?: 'Exception', owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } } | null };

export type ExceptionsDetailsOverviewInfoItemOwnerFragment = { __typename?: 'Exception', id: string, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionsDetailsAddSharedWithUserMutationVariables = Exact<{
  input: UpdateExceptionSharedWithUsersInput;
}>;


export type ExceptionsDetailsAddSharedWithUserMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', addExceptionSharedWithUsers: { __typename?: 'Exception', id: string, sharedWithUsers: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> } } | null };

export type ExceptionsDetailsDeleteSharedWithUserMutationVariables = Exact<{
  input: UpdateExceptionSharedWithUsersInput;
}>;


export type ExceptionsDetailsDeleteSharedWithUserMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteExceptionSharedWithUsers: { __typename?: 'Exception', id: string, sharedWithUsers: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }> } } | null };

export type ExceptionsDetailsOverviewInfoItemSharedWithFragment = { __typename?: 'Exception', id: string, sharedWithUsers: Array<{ __typename?: 'User', id: number, externalId: string, firstName: string, lastName: string }> };

export type ExceptionsDetailsOverviewMainFragment = { __typename?: 'Exception', id: string, level: ExceptionLevel, categoryDisplayName: string, title: string, description: string, type: string, priority: ExceptionPriority, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null };

export type ExceptionsDetailsOverviewInfoItemLinkFragment = { __typename?: 'Exception', id: string, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null };

export type ExceptionsDetailsUpdatePriorityMutationVariables = Exact<{
  input: UpdateExceptionPriorityInput;
}>;


export type ExceptionsDetailsUpdatePriorityMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionPriority: { __typename?: 'Exception', id: string, priority: ExceptionPriority } } | null };

export type ExceptionsDetailsOverviewInfoItemPriorityFragment = { __typename?: 'Exception', id: string, priority: ExceptionPriority };

export type ExceptionsDetailsUpdateIssueTypeMutationVariables = Exact<{
  input: UpdateExceptionIssueTypeInput;
}>;


export type ExceptionsDetailsUpdateIssueTypeMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionIssueType: { __typename?: 'Exception', id: string, categoryDisplayName: string, title: string, description: string } } | null };

export type ExceptionsDetailsOverviewInfoItemTypeFragment = { __typename?: 'Exception', id: string, categoryDisplayName: string, title: string, description: string, type: string };

export type ExceptionsNoteItemFragment = { __typename?: 'ExceptionNote', id: string, isHidden: boolean, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ExceptionNoteContent', text: string } };

export type ExceptionsNoteItemHiddenFragment = { __typename?: 'ExceptionNote', id: string, createdAt: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } };

export type ExceptionsNoteItemVisibleFragment = { __typename?: 'ExceptionNote', id: string, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ExceptionNoteContent', text: string } };

export type ExceptionsDetailsViewStatusTimelineResolveExceptionMutationVariables = Exact<{
  input: UpdateExceptionStatusInput;
}>;


export type ExceptionsDetailsViewStatusTimelineResolveExceptionMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionStatus: { __typename?: 'Exception', id: string, statuses: Array<{ __typename?: 'ExceptionStatusEvent', status: ExceptionStatus, occurredAt: string }>, link: { __typename?: 'DockDoorExceptionLink' } | { __typename?: 'ShipmentExceptionLink', shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink' } | null } } | null };

export type ExceptionsDetailsViewStatusTimelineFragment = { __typename?: 'Exception', id: string, statuses: Array<{ __typename?: 'ExceptionStatusEvent', status: ExceptionStatus, occurredAt: string }>, link: { __typename?: 'DockDoorExceptionLink' } | { __typename?: 'ShipmentExceptionLink', shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink' } | null };

export type ExceptionsDetailsViewTabsFragment = { __typename?: 'Exception', id: string, link: { __typename?: 'DockDoorExceptionLink' } | { __typename?: 'ShipmentExceptionLink', shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink' } | null };

export type ExceptionsFooterBatchActionsStatusMutationVariables = Exact<{
  input: UpdateExceptionsStatusesInput;
}>;


export type ExceptionsFooterBatchActionsStatusMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionsStatuses: Array<{ __typename?: 'Exception', id: string }> } | null };

export type ExceptionsFooterBatchActionsDeleteMutationVariables = Exact<{
  input: DeleteExceptionsInput;
}>;


export type ExceptionsFooterBatchActionsDeleteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteExceptions: boolean } | null };

export type ExceptionsFooterBatchActionsFragment = { __typename?: 'Exception', id: string, status: ExceptionStatus };

export type ExceptionsFooterBatchActionsReassignOwnerMutationVariables = Exact<{
  input: UpdateExceptionsOwnerInput;
}>;


export type ExceptionsFooterBatchActionsReassignOwnerMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionsOwner: Array<{ __typename?: 'Exception', id: string }> } | null };

export type ExceptionsBatchActionReassignOwnerFragment = { __typename?: 'Exception', id: string };

export type ExceptionsListItemIdFragment = { __typename?: 'Exception', id: string, priority: ExceptionPriority };

export type ExceptionsListItemLinkedToFragment = { __typename?: 'Exception', id: string, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null };

export type ExceptionsListViewListFragment = { __typename?: 'Exception', id: string, occurredAt: string, updatedAt: string | null, title: string, categoryDisplayName: string, status: ExceptionStatus, priority: ExceptionPriority, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null };

export type ExceptionsSettingsConfigurationTableFragment = { __typename?: 'ExceptionsSettingsConfigs', title: string, issueType: string, categoryDisplayName: string, sharedWithUsers: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string, externalId: string }>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionsSettingsOwnerCellMutationVariables = Exact<{
  input: UpdateDefaultExceptionOwnerInput;
}>;


export type ExceptionsSettingsOwnerCellMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateDefaultExceptionOwner: { __typename?: 'User', id: number } } | null };

export type ExceptionsSettingsOwnerCellFragment = { __typename?: 'ExceptionsSettingsConfigs', issueType: string, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ExceptionsSettingsSharedWithCellMutationVariables = Exact<{
  input: UpdateDefaultExceptionSharedWithUsersInput;
}>;


export type ExceptionsSettingsSharedWithCellMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateDefaultExceptionSharedWithUsers: Array<{ __typename?: 'User', id: number }> } | null };

export type ExceptionsSettingsSharedWithCellFragment = { __typename?: 'ExceptionsSettingsConfigs', issueType: string, sharedWithUsers: Array<{ __typename?: 'User', id: number, externalId: string, firstName: string, lastName: string }> };

export type ExceptionsBannerFragment = { __typename?: 'Exception', id: string, description: string };

export type ExceptionsMetadataSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ExceptionsMetadataSelectQuery = { __typename?: 'Query', exceptionsMetadata: Array<{ __typename?: 'ExceptionsMetadata', categoryDisplayName: string, issueType: string, title: string }> };

export type ExceptionsMetadataSelectFragment = { __typename?: 'ExceptionsMetadata', categoryDisplayName: string, issueType: string, title: string };

export type ExceptionsListViewFiltersOwnerQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
}>;


export type ExceptionsListViewFiltersOwnerQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, users: Array<{ __typename?: 'FacilityUser', id: string, firstName: string, lastName: string }> } } };

export type ExceptionsDetailsViewOwnerQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
}>;


export type ExceptionsDetailsViewOwnerQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, users: Array<{ __typename?: 'FacilityUser', id: string, firstName: string, lastName: string }> } } };

export type ExceptionsUserSearchFragment = { __typename?: 'FacilityUser', id: string, firstName: string, lastName: string };

export type FacilityHoverableMapFragment = { __typename?: 'Dock', id: number, displayName: string, type: DockType, kargoDock: boolean, currentTruckShipment: { __typename?: 'TruckShipment', status: ShipmentStatus | null, direction: TruckDirection | null, id: number, arrivedAt: string | null, customerShipmentIdentifier: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, equipmentType: EquipmentType | null, trailerNumber: string | null, orders: Array<{ __typename?: 'Order', id: string, consigneeName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', quantity: number | null }> }>, exceptions: Array<{ __typename?: 'Exception', id: string, type: string }> } | null };

export type FacilityDockItemFragment = { __typename?: 'Dock', id: number, type: DockType, kargoDock: boolean, displayName: string, currentTruckShipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null, customerShipmentIdentifier: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, status: ShipmentStatus | null, equipmentType: EquipmentType | null, trailerNumber: string | null, orders: Array<{ __typename?: 'Order', id: string, consigneeName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', quantity: number | null }> }>, exceptions: Array<{ __typename?: 'Exception', id: string, type: string }> } | null };

export type FacilityDocksFragment = { __typename?: 'Dock', id: number, type: DockType, kargoDock: boolean, displayName: string, currentTruckShipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null, customerShipmentIdentifier: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, status: ShipmentStatus | null, equipmentType: EquipmentType | null, trailerNumber: string | null, orders: Array<{ __typename?: 'Order', id: string, consigneeName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', quantity: number | null }> }>, exceptions: Array<{ __typename?: 'Exception', id: string, type: string }> } | null };

export type FacilityLightsFragment = { __typename?: 'Facility', id: number, devices: Array<{ __typename?: 'DockDevice', isLightOn: boolean }> };

export type FacilityDockFilterUtilsFragment = { __typename?: 'Dock', id: number, type: DockType, kargoDock: boolean, currentTruckShipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, exceptions: Array<{ __typename?: 'Exception', id: string }> } | null };

export type FacilityDockInputFilterUtilsFragment = { __typename?: 'Dock', id: number, displayName: string, currentTruckShipment: { __typename?: 'TruckShipment', id: number, customerShipmentIdentifier: string | null, trailerNumber: string | null } | null };

export type FacilityDockSortCriteriaUtilsFragment = { __typename?: 'Dock', id: number, currentTruckShipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, trailerNumber: string | null, customerShipmentIdentifier: string | null, carrier: string | null, carrierId: string | null, orders: Array<{ __typename?: 'Order', id: string, consigneeName: string | null }> } | null };

export type KargoAvatarFragment = { __typename?: 'User', id: number, firstName: string, lastName: string };

export type OrdersListViewListDirectionFragment = { __typename?: 'Order', id: string, direction: OrderDirection };

export type OrdersListViewListFragment = { __typename?: 'Order', id: string, expectedQuantity: number | null, externalId: string, orderNumber: string, bolNumber: string | null, requestedShipDate: string | null, consigneeName: string | null, status: OrderStatus, shipmentId: number | null, direction: OrderDirection, items: Array<{ __typename?: 'OrderItem', quantity: number | null, quantityUnit: ShipperUnitType }> };

export type OrdersListViewListQuantityFragment = { __typename?: 'Order', id: string, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', quantity: number | null, quantityUnit: ShipperUnitType }> };

export type AcceptUserInviteMutationVariables = Exact<{
  input: AcceptUserInviteInput;
}>;


export type AcceptUserInviteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', acceptUserInvite: { __typename?: 'AcceptUserInviteResult', success: boolean } } | null };

export type CvRunDatapoolQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type CvRunDatapoolQuery = { __typename?: 'Query', cv: { __typename?: 'CvRoot', runDatapoolQuery: { __typename?: 'DatapoolResult', items: Array<{ __typename?: 'DatapoolItem', imageUri: string | null, id: number }> } } };

export type CreateDatasetMutationVariables = Exact<{
  input: CreateDatasetInput;
}>;


export type CreateDatasetMutation = { __typename?: 'Mutation', cv: { __typename?: 'CvMutation', createDataset: string } | null };

export type ListS3ObjectsQueryVariables = Exact<{
  input: ListS3ObjectsInput;
}>;


export type ListS3ObjectsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', s3Objects: { __typename?: 'S3Listing', commonPrefixes: Array<string | null>, objects: Array<{ __typename?: 'S3Object', key: string, lastModifiedAt: string | null, uri: string | null }> } } };

export type GetShipperRequestFormBySlugQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  formType: ShipperRequestFormType;
}>;


export type GetShipperRequestFormBySlugQuery = { __typename?: 'Query', shipperRequestFormBySlug: { __typename?: 'ShipperRequestForm', businessId: number, facilityId: number, facilityName: string, facilityAddress: string, facilityPhone: string, form: { __typename?: 'Form', formVersion: string, sections: Array<{ __typename?: 'FormSection', title: string | null, fields: Array<{ __typename: 'DropdownFormField', fieldDisplayName: string, fieldName: string, required: boolean, dropdownOptions: Array<{ __typename?: 'DropdownOption', displayName: string, value: string }> } | { __typename: 'FieldListFormField', displayAsList: boolean | null, fieldDisplayName: string, fieldName: string, required: boolean, fields: Array<{ __typename: 'DropdownFormField', fieldDisplayName: string, fieldName: string, required: boolean, dropdownOptions: Array<{ __typename?: 'DropdownOption', displayName: string, value: string }> } | { __typename: 'FieldListFormField', fieldDisplayName: string, fieldName: string, required: boolean } | { __typename: 'NumericFormField', min: number | null, max: number | null, fieldDisplayName: string, fieldName: string, required: boolean } | { __typename: 'StringFormField', validation: StringValidation | null, multiline: boolean | null, fieldDisplayName: string, fieldName: string, required: boolean }> } | { __typename: 'NumericFormField', required: boolean, min: number | null, max: number | null, fieldDisplayName: string, fieldName: string } | { __typename: 'StringFormField', validation: StringValidation | null, multiline: boolean | null, fieldDisplayName: string, fieldName: string, required: boolean }> }> } } };

export type ShipperRequestFormMutationVariables = Exact<{
  submitShipperRequestFormInput: ShipperRequestFormInput;
}>;


export type ShipperRequestFormMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', submitShipperRequestForm: boolean } | null };

export type GetFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFacilitiesQuery = { __typename?: 'Query', businesses: Array<{ __typename?: 'Business', id: number, name: string | null, slug: string | null, facilities: Array<{ __typename?: 'Facility', id: number, name: string | null, slug: string, timezone: { __typename?: 'FacilityTimezone', name: string } | null, address: { __typename?: 'Address', city: string, state: string } | null, location: { __typename?: 'Location', lat: number, lng: number } | null }> }> };

export type GetBusinessSettingsPermissionsQueryVariables = Exact<{
  businessId: Scalars['Int'];
}>;


export type GetBusinessSettingsPermissionsQuery = { __typename?: 'Query', business: { __typename?: 'Business', users: { __typename?: 'BusinessUsers', hasPermission: boolean } } };

export type OrdersManifestItemFragment = { __typename?: 'OrderItem', id: string, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string, description: string | null };

export type OrdersManifestFragment = { __typename?: 'Order', id: string, shipmentId: number | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string, description: string | null }> };

export type OrdersFragment = { __typename?: 'Order', externalId: string, orderNumber: string, bolNumber: string | null, requestedShipDate: string | null, carrier: string | null, consigneeName: string | null, direction: OrderDirection, sealNumber: string | null, status: OrderStatus, shipmentId: number | null, id: string, expectedQuantity: number | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, facility: { __typename?: 'Facility', id: number, name: string | null, businessId: number }, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string, description: string | null }> };

export type GetOrderQueryVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type GetOrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', externalId: string, orderNumber: string, bolNumber: string | null, requestedShipDate: string | null, carrier: string | null, consigneeName: string | null, direction: OrderDirection, sealNumber: string | null, status: OrderStatus, shipmentId: number | null, id: string, expectedQuantity: number | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, facility: { __typename?: 'Facility', id: number, name: string | null, businessId: number }, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string, description: string | null }> } };

export type UpdateShipmentOrderItemsMutationVariables = Exact<{
  input: UpdateShipmentOrderItemsInput;
}>;


export type UpdateShipmentOrderItemsMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateShipmentOrderItems: { __typename?: 'Order', externalId: string, orderNumber: string, bolNumber: string | null, requestedShipDate: string | null, carrier: string | null, consigneeName: string | null, direction: OrderDirection, sealNumber: string | null, status: OrderStatus, shipmentId: number | null, id: string, expectedQuantity: number | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, facility: { __typename?: 'Facility', id: number, name: string | null, businessId: number }, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string, description: string | null }> } } | null };

export type GetUsersQueryVariables = Exact<{
  businessId: Scalars['Int'];
}>;


export type GetUsersQuery = { __typename?: 'Query', business: { __typename?: 'Business', users: { __typename?: 'BusinessUsers', users: Array<{ __typename?: 'BusinessUser', email: string, firstName: string | null, lastName: string | null, pendingInvite: boolean, role: BusinessUserRole, canResendInvite: boolean }> } } };

export type InviteUserMutationVariables = Exact<{
  users: Array<InviteUserInput> | InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', inviteUser: { __typename?: 'InviteUserResult', success: boolean } } | null };

export type DeleteUserMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteUser: { __typename?: 'DeleteUserResult', success: boolean } } | null };

export type GetCSVQueryVariables = Exact<{
  shipmentIds: Array<Scalars['Int']> | Scalars['Int'];
  format: ShipmentsCsvFileFormat;
  facilityId: Scalars['Int'];
  businessId: Scalars['Int'];
}>;


export type GetCSVQuery = { __typename?: 'Query', business: { __typename?: 'Business', facility: { __typename?: 'Facility', shipmentsCsvFile: string } } };

export type HideShipmentMutationVariables = Exact<{
  id: Scalars['Int'];
  hidden: Scalars['Boolean'];
}>;


export type HideShipmentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', hideShipment: { __typename?: 'HideShipmentResult', success: boolean } } | null };

export type ShipmentDockSelectorItemFragment = { __typename?: 'Dock', id: number, displayName: string, slug: string };

export type GetDocksForAssignmentQueryVariables = Exact<{
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  filter?: InputMaybe<DockFilter>;
}>;


export type GetDocksForAssignmentQuery = { __typename?: 'Query', business: { __typename?: 'Business', id: number, facility: { __typename?: 'Facility', id: number, docks: Array<{ __typename?: 'Dock', id: number, displayName: string, slug: string }> } } };

export type ShipmentDockSelectorFragment = { __typename?: 'TruckShipment', direction: TruckDirection | null, dock: { __typename?: 'Dock', id: number, displayName: string, slug: string } | null };

export type ShipmentStatusPanelFragment = { __typename?: 'TruckShipment', id: number, customerShipmentIdentifier: string | null, direction: TruckDirection | null, status: ShipmentStatus | null, processing: boolean, dock: { __typename?: 'Dock', id: number, kargoDock: boolean, displayName: string, slug: string } | null, statusEvents: Array<{ __typename?: 'ShipmentStatusEvent', displayName: string, status: ShipmentStatus, completed: boolean, completedAt: string | null }> };

export type ShipmentStatusPanelUpdateShipmentMutationVariables = Exact<{
  input: UpdateShipmentInput;
}>;


export type ShipmentStatusPanelUpdateShipmentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateShipment: { __typename?: 'UpdateShipmentResult', id: number, success: boolean } } | null };

export type ShipmentStatusTimelineFragment = { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, status: ShipmentStatus | null, processing: boolean, dock: { __typename?: 'Dock', id: number, kargoDock: boolean } | null, statusEvents: Array<{ __typename?: 'ShipmentStatusEvent', displayName: string, status: ShipmentStatus, completed: boolean, completedAt: string | null }> };

export type AppointmentTimeUpdateShipmentMutationVariables = Exact<{
  input: UpdateShipmentInput;
}>;


export type AppointmentTimeUpdateShipmentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateShipment: { __typename?: 'UpdateShipmentResult', success: boolean, id: number } } | null };

export type ShipmentDetailsOverviewAddressInfoFragment = { __typename?: 'TruckShipment', id: number, carrier: string | null, carrierService: string | null, carrierId: string | null, direction: TruckDirection | null, shipFromAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, shipToAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, orders: Array<{ __typename?: 'Order', consigneeName: string | null, shipperName: string | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null }> };

export type ShipmentDetailsOverviewLeftPaneInfoFragment = { __typename?: 'TruckShipment', id: number, driverName: string | null, driverEmailAddress: string | null, driverLicenseNumber: string | null, driverLicensePlate: string | null, equipmentType: EquipmentType | null, serviceType: ServiceType | null, trailerNumber: string | null, sealNumber: string | null, carrier: string | null, carrierService: string | null, carrierId: string | null, direction: TruckDirection | null, facility: { __typename?: 'Facility', id: number, possibleCarrierServices: Array<string> | null, possibleEquipmentTypes: Array<{ __typename?: 'EquipmentTypeOption', value: EquipmentType, displayName: string }>, possibleServiceTypes: Array<{ __typename?: 'ServiceTypeOption', value: ServiceType, displayName: string }> }, shipFromAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, shipToAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, orders: Array<{ __typename?: 'Order', consigneeName: string | null, shipperName: string | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null }> };

export type ShipmentDetailsOverviewTabNotesFragment = { __typename?: 'TruckShipment', id: number, notes: Array<{ __typename?: 'ShipmentNote', id: string, isHidden: boolean, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ShipmentNoteContent', text: string } | null }>, facility: { __typename?: 'Facility', id: number, timezone: { __typename?: 'FacilityTimezone', name: string } | null } };

export type OverviewTabNoteItemFragment = { __typename?: 'ShipmentNote', id: string, isHidden: boolean, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ShipmentNoteContent', text: string } | null };

export type OverviewTabNoteItemHiddenFragment = { __typename?: 'ShipmentNote', id: string, createdAt: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } };

export type OverviewTabNoteItemVisibleFragment = { __typename?: 'ShipmentNote', id: string, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ShipmentNoteContent', text: string } | null };

export type AddShipmentNoteMutationVariables = Exact<{
  input: AddShipmentNoteInput;
}>;


export type AddShipmentNoteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', addShipmentNote: { __typename?: 'ShipmentNote', id: string, createdAt: string | null, editedAt: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string }, content: { __typename?: 'ShipmentNoteContent', text: string } | null } } | null };

export type UpdateShipmentNoteMutationVariables = Exact<{
  input: UpdateShipmentNoteInput;
}>;


export type UpdateShipmentNoteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateShipmentNote: { __typename?: 'ShipmentNote', id: string, createdAt: string | null, editedAt: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string }, content: { __typename?: 'ShipmentNoteContent', text: string } | null } } | null };

export type DeleteShipmentNoteMutationVariables = Exact<{
  input: DeleteShipmentNoteInput;
}>;


export type DeleteShipmentNoteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteShipmentNote: { __typename?: 'ShipmentNote', id: string } } | null };

export type ShipmentScheduleUpdateShipmentMutationVariables = Exact<{
  input: UpdateShipmentInput;
}>;


export type ShipmentScheduleUpdateShipmentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateShipment: { __typename?: 'UpdateShipmentResult', success: boolean, id: number } } | null };

export type ActivityTabEventListDocumentDeletedFragment = { __typename?: 'ShipmentActivityDocumentDeleted', occurredAt: string, documentName: string, systemAction: boolean };

export type ActivityTabEventListDocumentItemFragment = { __typename?: 'ShipmentActivityDocumentUpload', occurredAt: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string }, document: { __typename?: 'ShipmentDocument', fileName: string, fileUrl: string } };

export type ActivityTabEventListDoorEventFragment = { __typename?: 'ShipmentActivityDoorEvent', id: string, occurredAt: string, opened: boolean, videoUri: string };

export type ShipmentsActivityExceptionCreatedFragment = { __typename?: 'ShipmentActivityExceptionCreated', id: string, occurredAt: string, exceptionId: string, title: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

type ActivityTabEventListFragment_ShipmentActivityDocumentDeleted_ = { __typename?: 'ShipmentActivityDocumentDeleted', occurredAt: string, documentName: string, systemAction: boolean };

type ActivityTabEventListFragment_ShipmentActivityDocumentUpload_ = { __typename?: 'ShipmentActivityDocumentUpload', occurredAt: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string }, document: { __typename?: 'ShipmentDocument', fileName: string, fileUrl: string } };

type ActivityTabEventListFragment_ShipmentActivityDoorEvent_ = { __typename?: 'ShipmentActivityDoorEvent', id: string, occurredAt: string, opened: boolean, videoUri: string };

type ActivityTabEventListFragment_ShipmentActivityExceptionCreated_ = { __typename?: 'ShipmentActivityExceptionCreated', id: string, occurredAt: string, exceptionId: string, title: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

type ActivityTabEventListFragment_ShipmentActivityItemsLoaded_ = { __typename?: 'ShipmentActivityItemsLoaded', id: string, occurredAt: string, direction: ItemLoadingDirection, items: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> };

type ActivityTabEventListFragment_ShipmentActivityOrderUpdated_ = { __typename?: 'ShipmentActivityOrderUpdated', id: string, orderId: string, occurredAt: string, orderNumber: string, orderItems: Array<string> };

type ActivityTabEventListFragment_ShipmentActivityStatusUpdated_ = { __typename?: 'ShipmentActivityStatusUpdated', occurredAt: string, systemAction: boolean, toStatus: ShipmentStatus, fromStatus: ShipmentStatus | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, fromDock: { __typename?: 'Dock', id: number, displayName: string } | null, toDock: { __typename?: 'Dock', id: number, displayName: string } | null };

type ActivityTabEventListFragment_ShipmentActivityStringFieldUpdated_ = { __typename?: 'ShipmentActivityStringFieldUpdated', occurredAt: string, systemAction: boolean, fieldName: string, toValue: string | null, fromValue: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ActivityTabEventListFragment = ActivityTabEventListFragment_ShipmentActivityDocumentDeleted_ | ActivityTabEventListFragment_ShipmentActivityDocumentUpload_ | ActivityTabEventListFragment_ShipmentActivityDoorEvent_ | ActivityTabEventListFragment_ShipmentActivityExceptionCreated_ | ActivityTabEventListFragment_ShipmentActivityItemsLoaded_ | ActivityTabEventListFragment_ShipmentActivityOrderUpdated_ | ActivityTabEventListFragment_ShipmentActivityStatusUpdated_ | ActivityTabEventListFragment_ShipmentActivityStringFieldUpdated_;

export type ActivityTabEventListItemsLoadedFragment = { __typename?: 'ShipmentActivityItemsLoaded', id: string, occurredAt: string, direction: ItemLoadingDirection, items: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> };

export type ActivityTabEventListOrderItemFragment = { __typename?: 'ShipmentActivityOrderUpdated', id: string, orderId: string, occurredAt: string, orderNumber: string, orderItems: Array<string> };

export type ActivityTabEventListStatusUpdateItemFragment = { __typename?: 'ShipmentActivityStatusUpdated', occurredAt: string, systemAction: boolean, toStatus: ShipmentStatus, fromStatus: ShipmentStatus | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, fromDock: { __typename?: 'Dock', id: number, displayName: string } | null, toDock: { __typename?: 'Dock', id: number, displayName: string } | null };

export type ActivityTabEventListStringFieldUpdateItemFragment = { __typename?: 'ShipmentActivityStringFieldUpdated', occurredAt: string, systemAction: boolean, fieldName: string, toValue: string | null, fromValue: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ShipmentActivityDocumentDeletedFilterFragment = { __typename?: 'ShipmentActivityDocumentDeleted', documentName: string, systemAction: boolean };

export type ShipmentActivityInputFilterDocumentItemFragment = { __typename?: 'ShipmentActivityDocumentUpload', uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string }, document: { __typename?: 'ShipmentDocument', fileName: string, fileUrl: string } };

export type ShipmentActivityInputFilterDoorEventFragment = { __typename?: 'ShipmentActivityDoorEvent', id: string, opened: boolean };

export type ShipmentActivityInputFilterExceptionCreatedFragment = { __typename?: 'ShipmentActivityExceptionCreated', id: string, title: string, user: { __typename?: 'User', firstName: string, lastName: string } | null };

type ShipmentActivityInputFilterFragment_ShipmentActivityDocumentDeleted_ = { __typename?: 'ShipmentActivityDocumentDeleted', occurredAt: string, documentName: string, systemAction: boolean };

type ShipmentActivityInputFilterFragment_ShipmentActivityDocumentUpload_ = { __typename?: 'ShipmentActivityDocumentUpload', occurredAt: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string }, document: { __typename?: 'ShipmentDocument', fileName: string, fileUrl: string } };

type ShipmentActivityInputFilterFragment_ShipmentActivityDoorEvent_ = { __typename?: 'ShipmentActivityDoorEvent', occurredAt: string, id: string, opened: boolean };

type ShipmentActivityInputFilterFragment_ShipmentActivityExceptionCreated_ = { __typename?: 'ShipmentActivityExceptionCreated', occurredAt: string };

type ShipmentActivityInputFilterFragment_ShipmentActivityItemsLoaded_ = { __typename?: 'ShipmentActivityItemsLoaded', occurredAt: string, id: string, direction: ItemLoadingDirection, items: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> };

type ShipmentActivityInputFilterFragment_ShipmentActivityOrderUpdated_ = { __typename?: 'ShipmentActivityOrderUpdated', occurredAt: string, id: string, orderId: string, orderNumber: string, orderItems: Array<string> };

type ShipmentActivityInputFilterFragment_ShipmentActivityStatusUpdated_ = { __typename?: 'ShipmentActivityStatusUpdated', occurredAt: string, systemAction: boolean, toStatus: ShipmentStatus, fromStatus: ShipmentStatus | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, fromDock: { __typename?: 'Dock', id: number, displayName: string } | null, toDock: { __typename?: 'Dock', id: number, displayName: string } | null };

type ShipmentActivityInputFilterFragment_ShipmentActivityStringFieldUpdated_ = { __typename?: 'ShipmentActivityStringFieldUpdated', occurredAt: string, systemAction: boolean, fieldName: string, toValue: string | null, fromValue: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ShipmentActivityInputFilterFragment = ShipmentActivityInputFilterFragment_ShipmentActivityDocumentDeleted_ | ShipmentActivityInputFilterFragment_ShipmentActivityDocumentUpload_ | ShipmentActivityInputFilterFragment_ShipmentActivityDoorEvent_ | ShipmentActivityInputFilterFragment_ShipmentActivityExceptionCreated_ | ShipmentActivityInputFilterFragment_ShipmentActivityItemsLoaded_ | ShipmentActivityInputFilterFragment_ShipmentActivityOrderUpdated_ | ShipmentActivityInputFilterFragment_ShipmentActivityStatusUpdated_ | ShipmentActivityInputFilterFragment_ShipmentActivityStringFieldUpdated_;

export type ShipmentActivityInputFilterItemsLoadedFragment = { __typename?: 'ShipmentActivityItemsLoaded', id: string, direction: ItemLoadingDirection, items: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> };

export type ShipmentActivityInputFilterOrderItemFragment = { __typename?: 'ShipmentActivityOrderUpdated', id: string, orderId: string, orderNumber: string, orderItems: Array<string> };

export type ShipmentActivityInputFilterStatusUpdateItemFragment = { __typename?: 'ShipmentActivityStatusUpdated', systemAction: boolean, toStatus: ShipmentStatus, fromStatus: ShipmentStatus | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, fromDock: { __typename?: 'Dock', id: number, displayName: string } | null, toDock: { __typename?: 'Dock', id: number, displayName: string } | null };

export type ShipmentActivityInputFilterStringFieldUpdateItemFragment = { __typename?: 'ShipmentActivityStringFieldUpdated', systemAction: boolean, fieldName: string, toValue: string | null, fromValue: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ShipmentsDocumentsListViewListFragment = { __typename?: 'ShipmentDocument', id: string, type: string | null, externalId: string, fileName: string, fileUrl: string, uploadedAt: string };

export type ShipmentOrdersListViewListFragment = { __typename?: 'Order', id: string, expectedQuantity: number | null, externalId: string, orderNumber: string, consigneeName: string | null, requestedShipDate: string | null, status: OrderStatus, items: Array<{ __typename?: 'OrderItem', description: string | null, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string }> };

export type ShipmentsDetailsOverviewLeftPaneFragment = { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, carrier: string | null, carrierId: string | null, carrierService: string | null, driverName: string | null, driverEmailAddress: string | null, driverLicenseNumber: string | null, driverLicensePlate: string | null, shipFromAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, shipToAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, orders: Array<{ __typename?: 'Order', consigneeName: string | null, shipperName: string | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null }>, facility: { __typename?: 'Facility', id: number, possibleCarrierServices: Array<string> | null } };

export type ShipmentsDetailsOverviewInfoItemAddressFieldFragment = { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string };

export type ShipmentsDetailsOverviewInfoItemAddressesFragment = { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, shipFromAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, shipToAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, orders: Array<{ __typename?: 'Order', consigneeName: string | null, shipperName: string | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null }> };

export type ShipmentsDetailsOverviewInfoItemCarrierInfoFragment = { __typename?: 'TruckShipment', id: number, carrier: string | null, carrierId: string | null, carrierService: string | null, facility: { __typename?: 'Facility', id: number, possibleCarrierServices: Array<string> | null } };

export type ShipmentsDetailsOverviewInfoItemDriverInfoFragment = { __typename?: 'TruckShipment', id: number, driverName: string | null, driverEmailAddress: string | null, driverLicenseNumber: string | null, driverLicensePlate: string | null };

export type ShipmentsDetailsOverviewMainFragment = { __typename?: 'TruckShipment', id: number };

export type ShipmentsListViewArrivedAtFragment = { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, expectedArrivalAt: string | null, arrivedAt: string | null, status: ShipmentStatus | null, statusEvent: { __typename?: 'ShipmentStatusEvent', completedAt: string | null, displayName: string, status: ShipmentStatus } | null };

export type ShipmentsListViewCarrierFragment = { __typename?: 'TruckShipment', id: number, carrier: string | null, carrierService: string | null };

export type ShipmentsListViewDepartedAtFragment = { __typename?: 'TruckShipment', id: number, departedAt: string | null };

export type ShipmentsListViewDockIdFragment = { __typename?: 'TruckShipment', direction: TruckDirection | null, dock: { __typename?: 'Dock', id: number, displayName: string, kargoDock: boolean } | null };

export type ShipmentsListViewExceptionsFragment = { __typename?: 'TruckShipment', id: number, exceptions: Array<{ __typename?: 'Exception', id: string, description: string }> };

export type ShipmentsPageFilteredShipmentsFragment = { __typename?: 'TruckShipment', id: number, loadingStartAt: string | null, loadingEndAt: string | null, driverName: string | null, driverLicenseNumber: string | null, driverLicensePlate: string | null, direction: TruckDirection | null, carrier: string | null, carrierService: string | null, customerShipmentIdentifier: string | null, expectedArrivalAt: string | null, arrivedAt: string | null, status: ShipmentStatus | null, departedAt: string | null, documents: Array<{ __typename?: 'ShipmentDocument', fileName: string }>, notes: Array<{ __typename?: 'ShipmentNote', id: string }>, dock: { __typename?: 'Dock', id: number, displayName: string, kargoDock: boolean } | null, orders: Array<{ __typename?: 'Order', id: string, shipperName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', partID: string | null, quantity: number | null }> }>, statusEvent: { __typename?: 'ShipmentStatusEvent', completedAt: string | null, displayName: string, status: ShipmentStatus } | null, exceptions: Array<{ __typename?: 'Exception', id: string, description: string }> };

export type ShipmentsListViewKargoIdFragment = { __typename?: 'TruckShipment', id: number, documents: Array<{ __typename?: 'ShipmentDocument', fileName: string }>, notes: Array<{ __typename?: 'ShipmentNote', id: string }> };

export type ShipmentsListViewPalletCountFragment = { __typename?: 'TruckShipment', cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', partID: string | null, quantity: number | null }> }>, orders: Array<{ __typename?: 'Order', id: string, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }> };

export type ShipmentsListViewShipmentNumberFragment = { __typename?: 'TruckShipment', id: number, customerShipmentIdentifier: string | null, direction: TruckDirection | null, orders: Array<{ __typename?: 'Order', id: string, shipperName: string | null }> };

export type MediaDoorEventItemFragment = { __typename?: 'ShipmentActivityDoorEvent', id: string, occurredAt: string, videoUri: string, videoThumbnailUri: string | null, opened: boolean };

export type MediaDoorEventVideoFragment = { __typename?: 'ShipmentActivityDoorEvent', id: string, videoUri: string };

export type MediaPalletImagesViewerFragment = { __typename?: 'TaggedImage', url: string, brightness: number | null };

export type MediaPalletInfoCardFragment = { __typename?: 'ShippingItem', partID: string, layerCount: number | null, orientation: PalletOrientation | null, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } };

export type MediaPalletVideoCardFragment = { __typename?: 'PalletMotionVideo', videoUri: string, videoThumbnailUri: string | null };

export type MediaPalletVideoCardActivityFragment = { __typename?: 'ShipmentActivityItemsLoaded', id: string, direction: ItemLoadingDirection, forkliftId: string | null, occurredAt: string, items: Array<{ __typename?: 'ShippingItem', flags: Array<ShippingItemFlag> }> };

type MediaTimelineHeaderFragment_ShipmentActivityDocumentDeleted_ = { __typename?: 'ShipmentActivityDocumentDeleted' };

type MediaTimelineHeaderFragment_ShipmentActivityDocumentUpload_ = { __typename?: 'ShipmentActivityDocumentUpload' };

type MediaTimelineHeaderFragment_ShipmentActivityDoorEvent_ = { __typename?: 'ShipmentActivityDoorEvent', id: string, occurredAt: string, opened: boolean };

type MediaTimelineHeaderFragment_ShipmentActivityExceptionCreated_ = { __typename?: 'ShipmentActivityExceptionCreated' };

type MediaTimelineHeaderFragment_ShipmentActivityItemsLoaded_ = { __typename?: 'ShipmentActivityItemsLoaded', id: string, occurredAt: string, direction: ItemLoadingDirection, itemQuantity: number };

type MediaTimelineHeaderFragment_ShipmentActivityOrderUpdated_ = { __typename?: 'ShipmentActivityOrderUpdated' };

type MediaTimelineHeaderFragment_ShipmentActivityStatusUpdated_ = { __typename?: 'ShipmentActivityStatusUpdated' };

type MediaTimelineHeaderFragment_ShipmentActivityStringFieldUpdated_ = { __typename?: 'ShipmentActivityStringFieldUpdated' };

export type MediaTimelineHeaderFragment = MediaTimelineHeaderFragment_ShipmentActivityDocumentDeleted_ | MediaTimelineHeaderFragment_ShipmentActivityDocumentUpload_ | MediaTimelineHeaderFragment_ShipmentActivityDoorEvent_ | MediaTimelineHeaderFragment_ShipmentActivityExceptionCreated_ | MediaTimelineHeaderFragment_ShipmentActivityItemsLoaded_ | MediaTimelineHeaderFragment_ShipmentActivityOrderUpdated_ | MediaTimelineHeaderFragment_ShipmentActivityStatusUpdated_ | MediaTimelineHeaderFragment_ShipmentActivityStringFieldUpdated_;

type MediaHorizontalTimelineFragment_ShipmentActivityDocumentDeleted_ = { __typename?: 'ShipmentActivityDocumentDeleted' };

type MediaHorizontalTimelineFragment_ShipmentActivityDocumentUpload_ = { __typename?: 'ShipmentActivityDocumentUpload' };

type MediaHorizontalTimelineFragment_ShipmentActivityDoorEvent_ = { __typename?: 'ShipmentActivityDoorEvent', id: string, opened: boolean, occurredAt: string };

type MediaHorizontalTimelineFragment_ShipmentActivityExceptionCreated_ = { __typename?: 'ShipmentActivityExceptionCreated' };

type MediaHorizontalTimelineFragment_ShipmentActivityItemsLoaded_ = { __typename?: 'ShipmentActivityItemsLoaded', id: string, direction: ItemLoadingDirection, itemQuantity: number, occurredAt: string };

type MediaHorizontalTimelineFragment_ShipmentActivityOrderUpdated_ = { __typename?: 'ShipmentActivityOrderUpdated' };

type MediaHorizontalTimelineFragment_ShipmentActivityStatusUpdated_ = { __typename?: 'ShipmentActivityStatusUpdated' };

type MediaHorizontalTimelineFragment_ShipmentActivityStringFieldUpdated_ = { __typename?: 'ShipmentActivityStringFieldUpdated' };

export type MediaHorizontalTimelineFragment = MediaHorizontalTimelineFragment_ShipmentActivityDocumentDeleted_ | MediaHorizontalTimelineFragment_ShipmentActivityDocumentUpload_ | MediaHorizontalTimelineFragment_ShipmentActivityDoorEvent_ | MediaHorizontalTimelineFragment_ShipmentActivityExceptionCreated_ | MediaHorizontalTimelineFragment_ShipmentActivityItemsLoaded_ | MediaHorizontalTimelineFragment_ShipmentActivityOrderUpdated_ | MediaHorizontalTimelineFragment_ShipmentActivityStatusUpdated_ | MediaHorizontalTimelineFragment_ShipmentActivityStringFieldUpdated_;

export type ShipmentsContentLabelListItemFragment = { __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, shipmentActivityItemsLoadedId: string, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } };

export type ShipmentsContentLabelListFragment = { __typename?: 'ShipmentContentItem', sourceItems: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, shipmentActivityItemsLoadedId: string, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> };

export type ShipmentsContentTableDescriptionCellFragment = { __typename?: 'ShipmentContentItem', description: string | null };

export type ShipmentContentTableFragment = { __typename?: 'ShipmentContent', itemIdentifierColumnName: string, items: Array<{ __typename?: 'ShipmentContentItem', identifier: string, orderQuantity: number | null, actualQuantity: number | null, description: string | null, sourceItems: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, shipmentActivityItemsLoadedId: string, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> }> };

export type ShipmentsPageStatusBadgeFragment = { __typename?: 'ShipmentStatusEvent', displayName: string, status: ShipmentStatus };

export type AdminBusinessFragment = { __typename?: 'OpsBusiness', id: string, name: string, slug: string, facilities: Array<{ __typename?: 'OpsFacility', id: string, name: string | null, slug: string, timeZone: string | null, officialName: string | null, docks: Array<{ __typename?: 'OpsDock', id: string, businessId: number, displayName: string, dockId: number, facilityId: number, isHidden: boolean, isKargoDock: boolean, slug: string, type: DockType }> }> };

export type AdminGetBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetBusinessesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', businesses: Array<{ __typename?: 'OpsBusiness', id: string, name: string, slug: string, facilities: Array<{ __typename?: 'OpsFacility', id: string, name: string | null, slug: string, timeZone: string | null, officialName: string | null, docks: Array<{ __typename?: 'OpsDock', id: string, businessId: number, displayName: string, dockId: number, facilityId: number, isHidden: boolean, isKargoDock: boolean, slug: string, type: DockType }> }> }> } };

export type DockEventsContainerGetOpsDockEventsQueryVariables = Exact<{
  input: DockEventsInput;
}>;


export type DockEventsContainerGetOpsDockEventsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', dockEvents: Array<{ __typename?: 'OpsDockEvent', at: string | null, details: string | null, dockId: number | null, type: string | null, videoUri: string | null, videoExternalId: string | null }> } };

export type AdminDeviceFragment = { __typename?: 'OpsDockDevice', id: string, businessId: number | null, dockId: number | null, edgeId: number | null, facilityId: number | null, isLightOn: boolean, model: string, partNumber: string | null, version: string, tunnel: { __typename?: 'OpsDeviceTunnel', host: string, port: number } | null };

export type AdminGetFacilityDevicesQueryVariables = Exact<{
  facilityId: Scalars['Int'];
}>;


export type AdminGetFacilityDevicesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', devicesByFacilityId: Array<{ __typename?: 'OpsDockDevice', id: string, businessId: number | null, dockId: number | null, edgeId: number | null, facilityId: number | null, isLightOn: boolean, model: string, partNumber: string | null, version: string, tunnel: { __typename?: 'OpsDeviceTunnel', host: string, port: number } | null }> } };

export type AdminGetLabelReadingTemplateFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetLabelReadingTemplateFieldsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', labelReadingTemplateFields: Array<{ __typename?: 'OpsLabelReadingTemplateField', id: string, name: string, defaultRegex: string }> } };

export type AdminLabelReadingTemplateFieldFragment = { __typename?: 'OpsLabelReadingTemplateField', id: string, name: string, defaultRegex: string };

export type PalletLabelImageFragment = { __typename?: 'OpsPalletLabelImage', externalId: string, businessId: number, facilityId: number, ocrLabelResult: Array<{ __typename?: 'OcrLabelResultItem', text: string, boundingPoly: Array<Array<number>> }> };

export type OcrLabelResultItemFragment = { __typename?: 'OcrLabelResultItem', text: string, boundingPoly: Array<Array<number>> };

export type GetPalletLabelImageQueryVariables = Exact<{
  palletLabelImageExternalId: Scalars['ID'];
}>;


export type GetPalletLabelImageQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', palletLabelImage: { __typename?: 'OpsPalletLabelImage', externalId: string, businessId: number, facilityId: number, ocrLabelResult: Array<{ __typename?: 'OcrLabelResultItem', text: string, boundingPoly: Array<Array<number>> }> } | null } };

export type CreateLabelReadingTemplateMutationVariables = Exact<{
  input: CreateLabelReadingTemplateInput;
}>;


export type CreateLabelReadingTemplateMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', createLabelReadingTemplate: { __typename?: 'CreateLabelReadingTemplateResult', success: boolean } } | null };

export type AdminTemplateCreatorGetLabelReadingTemplateFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminTemplateCreatorGetLabelReadingTemplateFieldsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', labelReadingTemplateFields: Array<{ __typename?: 'OpsLabelReadingTemplateField', id: string, name: string, defaultRegex: string }> } };

export type OpsLabelReadingTemplateFragment = { __typename?: 'OpsLabelReadingTemplate', id: string, businessId: number, facilityId: number, anchorVersion: string, imageUrl: string, templateState: LabelReadingTemplateState | null, templateReadLocations: Array<{ __typename?: 'TemplateReadLocation', fieldName: string, locationItem: { __typename?: 'TemplateReadLocationItem', identifierType: string | null, fieldType: OpsLabelReadingTemplateFieldType | null, regex: string | null } }> };

export type GetLabelReadingTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLabelReadingTemplatesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', labelReadingTemplates: Array<{ __typename?: 'OpsLabelReadingTemplate', id: string, businessId: number, facilityId: number, anchorVersion: string, imageUrl: string, templateState: LabelReadingTemplateState | null, templateReadLocations: Array<{ __typename?: 'TemplateReadLocation', fieldName: string, locationItem: { __typename?: 'TemplateReadLocationItem', identifierType: string | null, fieldType: OpsLabelReadingTemplateFieldType | null, regex: string | null } }> }> } };

export type UpdateLabelReadingTemplateStateMutationVariables = Exact<{
  input: UpdateLabelReadingTemplateInput;
}>;


export type UpdateLabelReadingTemplateStateMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updateLabelReadingTemplate: { __typename?: 'OpsLabelReadingTemplate', id: string, templateState: LabelReadingTemplateState | null } } | null };

export type AdminLabelerFragment = { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string, email: string, firstName: string, lastName: string } };

export type AdminLabelerBusinessFragment = { __typename?: 'OpsBusiness', id: string, slug: string, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string }> };

export type AdminLabelersFacilitiesFragment = { __typename?: 'OpsUser', facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, business: { __typename?: 'OpsBusiness', id: string, slug: string } }>, user: { __typename?: 'User', externalId: string, email: string, firstName: string, lastName: string } };

export type DeleteLabelerFromFacilityMutationVariables = Exact<{
  userId: Scalars['ID'];
  facilityId: Scalars['Int'];
}>;


export type DeleteLabelerFromFacilityMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', deleteOpsUserFromFacility: { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string } } } | null };

export type AddLabelerToFacilityMutationVariables = Exact<{
  userId: Scalars['ID'];
  facilityId: Scalars['Int'];
}>;


export type AddLabelerToFacilityMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', addOpsUserToFacility: { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string } } } | null };

export type InviteLabelersMutationVariables = Exact<{
  users: Array<InviteOpsUserInput> | InviteOpsUserInput;
}>;


export type InviteLabelersMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', inviteOpsUsers: { __typename?: 'InviteOpsUsersOutput', count: number } } | null };

export type AdminLabelersGetFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLabelersGetFacilitiesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', businesses: Array<{ __typename?: 'OpsBusiness', id: string, slug: string, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string }> }> } };

export type AdminLabelersFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminLabelersFacilitiesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', labelerUsers: Array<{ __typename?: 'OpsUser', facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, business: { __typename?: 'OpsBusiness', id: string, slug: string } }>, user: { __typename?: 'User', externalId: string, email: string, firstName: string, lastName: string } }> } };

export type PalletLabelFragment = { __typename?: 'OpsPallet', label: { __typename?: 'OpsPalletLabel', contentAggregationState: OpsPalletAggregationState | null, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }>, images: Array<{ __typename?: 'TaggedImage', url: string, brightness: number | null, identifier: string | null }> }, licensePlateNumbers: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, alternativeLpnList: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, palletContentIds: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, fields: Array<{ __typename?: 'OpsPalletLabelFieldSegment', name: string, value: string, imageIds: Array<number> }> } };

export type GetPalletLabelQueryVariables = Exact<{
  palletEventId: Scalars['Int'];
}>;


export type GetPalletLabelQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', palletEvent: { __typename?: 'OpsPallet', id: number, loadingEventId: number | null, shipmentId: number | null, label: { __typename?: 'OpsPalletLabel', contentAggregationState: OpsPalletAggregationState | null, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }>, images: Array<{ __typename?: 'TaggedImage', url: string, brightness: number | null, identifier: string | null }> }, licensePlateNumbers: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, alternativeLpnList: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, palletContentIds: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, fields: Array<{ __typename?: 'OpsPalletLabelFieldSegment', name: string, value: string, imageIds: Array<number> }> } } | null } };

export type UpdatePalletLabelMutationVariables = Exact<{
  input: UpdatePalletLabelInput;
}>;


export type UpdatePalletLabelMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updatePalletLabel: { __typename?: 'OpsPallet', id: number, label: { __typename?: 'OpsPalletLabel', contentAggregationState: OpsPalletAggregationState | null, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }>, images: Array<{ __typename?: 'TaggedImage', url: string, brightness: number | null, identifier: string | null }> }, licensePlateNumbers: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, alternativeLpnList: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, palletContentIds: Array<{ __typename?: 'OpsPalletLabelSegment', type: string, identifier: string, displayName: string | null, imageIds: Array<number> }>, fields: Array<{ __typename?: 'OpsPalletLabelFieldSegment', name: string, value: string, imageIds: Array<number> }> } } } | null };

export type LoadingEventFragment = { __typename?: 'OpsLoadingEvent', id: number, direction: string | null, endAt: string | null, items: string | null, occurredAt: string, palletCount: number | null, labelStatesAutoCheckedAt: string | null, startAt: string | null, pallets: Array<{ __typename?: 'OpsPallet', id: number, hasPalletClassLabel: boolean, hasPalletIdLabel: boolean, annotation: { __typename?: 'PalletAnnotation', missingLabelReason: { __typename?: 'PalletAnnotationMissingLabelReason', PALLET_CLASS_ANNOTATION: Array<PalletAnnotationRootCause> | null, PALLET_ID_ANNOTATION: Array<PalletAnnotationRootCause> | null } } | null }> };

export type LoadingEventConfigurationFragment = { __typename?: 'OpsLoadingEvent', configuration: { __typename?: 'TwoPalletConfiguration', configurationType: ConfigurationType, doublePalletConfiguration: PalletConfigurationDouble } | null };

export type GetShipmentInfoQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
}>;


export type GetShipmentInfoQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', shipment: { __typename?: 'OpsShipment', business: { __typename?: 'OpsBusiness', slug: string }, facility: { __typename?: 'OpsFacility', slug: string }, dock: { __typename?: 'OpsDock', id: string, slug: string } | null } | null } };

export type LoadingEventQueryVariables = Exact<{
  loadingEventId: Scalars['Int'];
}>;


export type LoadingEventQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', loadingEvent: { __typename?: 'OpsLoadingEvent', id: number, direction: string | null, endAt: string | null, items: string | null, occurredAt: string, palletCount: number | null, labelStatesAutoCheckedAt: string | null, startAt: string | null, pallets: Array<{ __typename?: 'OpsPallet', id: number, hasPalletClassLabel: boolean, hasPalletIdLabel: boolean, shipmentId: number | null, loadingEventId: number | null, flags: Array<ShippingItemFlag>, annotation: { __typename?: 'PalletAnnotation', missingLabelReason: { __typename?: 'PalletAnnotationMissingLabelReason', PALLET_CLASS: PalletAnnotationRootCause | null, PALLET_ID: PalletAnnotationRootCause | null, PALLET_CLASS_ANNOTATION: Array<PalletAnnotationRootCause> | null, PALLET_ID_ANNOTATION: Array<PalletAnnotationRootCause> | null } } | null }>, configuration: { __typename?: 'TwoPalletConfiguration', configurationType: ConfigurationType, doublePalletConfiguration: PalletConfigurationDouble } | null } | null } };

export type LoadingEventPalletListFragment = { __typename?: 'OpsPallet', id: number, hasPalletClassLabel: boolean, hasPalletIdLabel: boolean, annotation: { __typename?: 'PalletAnnotation', missingLabelReason: { __typename?: 'PalletAnnotationMissingLabelReason', PALLET_CLASS_ANNOTATION: Array<PalletAnnotationRootCause> | null, PALLET_ID_ANNOTATION: Array<PalletAnnotationRootCause> | null } } | null };

export type LoadingEventVideoContainerFragment = { __typename?: 'OpsShipmentActivityItemsLoaded', id: string };

export type LoadingEventGetFacilityInfoFromShipmentQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
}>;


export type LoadingEventGetFacilityInfoFromShipmentQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', shipment: { __typename?: 'OpsShipment', id: string, facility: { __typename?: 'OpsFacility', id: string, timeZone: string | null } } | null } };

export type LoadingEventVideoContainerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoadingEventVideoContainerQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', opsShipmentActivityItemsLoaded: { __typename?: 'OpsShipmentActivityItemsLoaded', id: string, videos: Array<{ __typename?: 'OpsPalletMotionVideo', videoUri: string, videoThumbnailUri: string | null, occurredAt: string | null, cameraLocation: string | null, startAt: string | null, endAt: string | null }> } } };

export type LoadingEventVideoFragment = { __typename?: 'OpsPalletMotionVideo', videoUri: string, videoThumbnailUri: string | null, occurredAt: string | null, cameraLocation: string | null, startAt: string | null, endAt: string | null };

export type AdminUserFragment = { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string, email: string, firstName: string, lastName: string } };

export type AdminOpsBusinessFragment = { __typename?: 'OpsBusiness', id: string, slug: string, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string }> };

export type AdminOpsUsersFacilitiesFragment = { __typename?: 'OpsUser', facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, business: { __typename?: 'OpsBusiness', id: string, slug: string } }>, user: { __typename?: 'User', externalId: string, email: string, firstName: string, lastName: string } };

export type DeleteUserFromFacilityMutationVariables = Exact<{
  userId: Scalars['ID'];
  facilityId: Scalars['Int'];
}>;


export type DeleteUserFromFacilityMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', deleteOpsUserFromFacility: { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string } } } | null };

export type AddOpsUserToFacilityMutationVariables = Exact<{
  userId: Scalars['ID'];
  facilityId: Scalars['Int'];
}>;


export type AddOpsUserToFacilityMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', addOpsUserToFacility: { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string } } } | null };

export type AdminOpsGetFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOpsGetFacilitiesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', businesses: Array<{ __typename?: 'OpsBusiness', id: string, slug: string, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string }> }> } };

export type AdminOpsUsersFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOpsUsersFacilitiesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', opsUsers: Array<{ __typename?: 'OpsUser', facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, business: { __typename?: 'OpsBusiness', id: string, slug: string } }>, user: { __typename?: 'User', externalId: string, email: string, firstName: string, lastName: string } }> } };

export type AdminGetOrderQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type AdminGetOrderQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', order: { __typename?: 'OpsOrder', id: string, businessSlug: string, facilitySlug: string, orderNumber: string, direction: OrderDirection, orderType: string | null, purchaseOrder: string | null, requestedShipDate: string | null, requestedDeliveryDate: string | null, shipperName: string | null, shipperEmail: string | null, consigneeName: string | null, consigneePhoneNumber: string | null, carrierService: string | null, carrier: string | null, bolNumber: string | null, sealNumber: string | null, status: OrderStatus, shipmentId: number | null, expectedQuantity: number | null, shipperAddress: { __typename?: 'OpsOrderAddress', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, items: Array<{ __typename?: 'OpsOrderItem', id: string, identifier: string, quantity: number | null, quantityUnit: ShipperUnitType, purchaseOrder: string | null, description: string | null, weightPerUnit: number | null, weightUnit: WeightUnit | null, sku: string | null, lpn: string | null }> } | null } };

export type SinglePalletViewLoadingEventIdentifiedLabelsQueryVariables = Exact<{
  loadingEventId: Scalars['Int'];
}>;


export type SinglePalletViewLoadingEventIdentifiedLabelsQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', loadingEventIdentifiedLabels: { __typename?: 'OpsLabelsAndImages', images: Array<{ __typename?: 'OpsPalletImages', id: number, brightness: number | null, imageUri: string, ocrLabelResultFormatted: string | null, cameraId: number | null, edgeId: number | null, eventType: string | null }> } | null } };

export type PalletAnnotationTaskLoadingEventQueryVariables = Exact<{
  loadingEventId: Scalars['Int'];
}>;


export type PalletAnnotationTaskLoadingEventQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', loadingEvent: { __typename?: 'OpsLoadingEvent', id: number, palletCount: number | null, pallets: Array<{ __typename?: 'OpsPallet', id: number, flags: Array<ShippingItemFlag>, orientation: PalletOrientation | null, hasPalletClassLabel: boolean, hasPalletIdLabel: boolean, annotation: { __typename?: 'PalletAnnotation', missingLabelReason: { __typename?: 'PalletAnnotationMissingLabelReason', PALLET_CLASS_ANNOTATION: Array<PalletAnnotationRootCause> | null, PALLET_ID_ANNOTATION: Array<PalletAnnotationRootCause> | null } } | null }> } | null } };

export type UpsertPalletEventAnnotationMutationVariables = Exact<{
  input: PalletAnnotationInput;
}>;


export type UpsertPalletEventAnnotationMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', upsertPalletEventAnnotation: { __typename?: 'OpsPallet', id: number, annotation: { __typename?: 'PalletAnnotation', reasons: Array<{ __typename?: 'PalletAnnotationReason', rootCause: PalletAnnotationRootCause, category: PalletAnnotationCategory }> } | null } } | null };

export type PalletLayerTaskLoadingEventQueryVariables = Exact<{
  loadingEventId: Scalars['Int'];
}>;


export type PalletLayerTaskLoadingEventQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', loadingEvent: { __typename?: 'OpsLoadingEvent', id: number, palletCount: number | null, pallets: Array<{ __typename?: 'OpsPallet', id: number, shipmentId: number | null, flags: Array<ShippingItemFlag>, layerCount: number | null, orientation: PalletOrientation | null }> } | null } };

export type LoadingEventUpdateShippingItemFlagsMutationVariables = Exact<{
  input: UpdateShippingItemFlagsInput;
}>;


export type LoadingEventUpdateShippingItemFlagsMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updatePalletFlags: { __typename?: 'UpdateShippingItemFlagsResult', success: boolean } } | null };

export type UpdatePalletLayerCountMutationVariables = Exact<{
  input: UpdatePalletLayerCountInput;
}>;


export type UpdatePalletLayerCountMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updatePalletLayerCount: { __typename?: 'OpsPallet', id: number } } | null };

export type GetOpsPendingInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpsPendingInvitesQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', pendingInvites: Array<{ __typename?: 'PendingInvite', createdAt: string, expiresAt: string, email: string, inviteUrl: string, role: string }> } };

export type TruckShipmentSummaryFragment = { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, expectedArrivalAt: string | null, arrivedAt: string | null, departedAt: string | null, loadingStartAt: string | null, loadingEndAt: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, customerShipmentIdentifier: string | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, facility: { __typename?: 'Facility', id: number, name: string | null }, flags: Array<{ __typename?: 'TruckShipmentFlag', id: number, type: string, title: string, description: string | null, occurredAt: string }> };

export type GetTruckShipmentSummaryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTruckShipmentSummaryQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, expectedArrivalAt: string | null, arrivedAt: string | null, departedAt: string | null, loadingStartAt: string | null, loadingEndAt: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, customerShipmentIdentifier: string | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, facility: { __typename?: 'Facility', id: number, name: string | null }, flags: Array<{ __typename?: 'TruckShipmentFlag', id: number, type: string, title: string, description: string | null, occurredAt: string }> } };

export type AdminGetShipmentOrdersFragment = { __typename?: 'OpsShipment', id: string, business: { __typename?: 'OpsBusiness', slug: string }, dock: { __typename?: 'OpsDock', slug: string } | null, facility: { __typename?: 'OpsFacility', slug: string }, orders: Array<{ __typename?: 'OpsOrder', id: string, businessSlug: string, archived: boolean, facilitySlug: string, orderNumber: string, direction: OrderDirection, orderType: string | null, purchaseOrder: string | null, requestedShipDate: string | null, requestedDeliveryDate: string | null, shipperName: string | null, status: OrderStatus, consigneeName: string | null, shipperEmail: string | null, consigneePhoneNumber: string | null, carrier: string | null, carrierService: string | null, bolNumber: string | null, sealNumber: string | null, shipmentId: number | null, expectedQuantity: number | null, shipperAddress: { __typename?: 'OpsOrderAddress', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, items: Array<{ __typename?: 'OpsOrderItem', identifier: string, id: string, quantity: number | null, quantityUnit: ShipperUnitType, description: string | null, purchaseOrder: string | null, upc: string | null, weightPerUnit: number | null, weightUnit: WeightUnit | null, height: number | null, length: number | null, dimensionUnit: DimensionUnit | null, lot: string | null, isDangerousGood: boolean | null, expirationDate: string | null, manufacturingDate: string | null, sku: string | null, lpn: string | null }> }> };

export type AdminGetShipmentDocumentsFragment = { __typename?: 'OpsShipment', id: string, business: { __typename?: 'OpsBusiness', slug: string }, dock: { __typename?: 'OpsDock', slug: string } | null, facility: { __typename?: 'OpsFacility', slug: string }, documents: Array<{ __typename?: 'OpsShipmentDocument', id: string, type: string | null, externalId: string, shipmentId: number, fileName: string, fileUrl: string, uploadedAt: string, ocrResultText: Array<string> | null, ocrProcessedAt: string | null }> };

export type AdminGetShipmentDocumentsOrdersFragment = { __typename?: 'OpsShipment', id: string, carrier: string | null, direction: TruckDirection | null, hasScheduledShipment: boolean, atFacilityAt: string | null, business: { __typename?: 'OpsBusiness', slug: string }, dock: { __typename?: 'OpsDock', slug: string } | null, facility: { __typename?: 'OpsFacility', slug: string }, documents: Array<{ __typename?: 'OpsShipmentDocument', id: string, type: string | null, externalId: string, shipmentId: number, fileName: string, fileUrl: string, uploadedAt: string, ocrResultText: Array<string> | null, ocrProcessedAt: string | null }>, orders: Array<{ __typename?: 'OpsOrder', id: string, businessSlug: string, archived: boolean, facilitySlug: string, orderNumber: string, direction: OrderDirection, orderType: string | null, purchaseOrder: string | null, requestedShipDate: string | null, requestedDeliveryDate: string | null, shipperName: string | null, status: OrderStatus, consigneeName: string | null, shipperEmail: string | null, consigneePhoneNumber: string | null, carrier: string | null, carrierService: string | null, bolNumber: string | null, sealNumber: string | null, shipmentId: number | null, expectedQuantity: number | null, shipperAddress: { __typename?: 'OpsOrderAddress', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, items: Array<{ __typename?: 'OpsOrderItem', identifier: string, id: string, quantity: number | null, quantityUnit: ShipperUnitType, description: string | null, purchaseOrder: string | null, upc: string | null, weightPerUnit: number | null, weightUnit: WeightUnit | null, height: number | null, length: number | null, dimensionUnit: DimensionUnit | null, lot: string | null, isDangerousGood: boolean | null, expirationDate: string | null, manufacturingDate: string | null, sku: string | null, lpn: string | null }> }> };

export type AdminGetShipmentDocumentsOrdersQueryVariables = Exact<{
  shipmentId: Scalars['Int'];
}>;


export type AdminGetShipmentDocumentsOrdersQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', shipment: { __typename?: 'OpsShipment', id: string, carrier: string | null, direction: TruckDirection | null, hasScheduledShipment: boolean, atFacilityAt: string | null, business: { __typename?: 'OpsBusiness', slug: string }, dock: { __typename?: 'OpsDock', slug: string } | null, facility: { __typename?: 'OpsFacility', slug: string }, documents: Array<{ __typename?: 'OpsShipmentDocument', id: string, type: string | null, externalId: string, shipmentId: number, fileName: string, fileUrl: string, uploadedAt: string, ocrResultText: Array<string> | null, ocrProcessedAt: string | null }>, orders: Array<{ __typename?: 'OpsOrder', id: string, businessSlug: string, archived: boolean, facilitySlug: string, orderNumber: string, direction: OrderDirection, orderType: string | null, purchaseOrder: string | null, requestedShipDate: string | null, requestedDeliveryDate: string | null, shipperName: string | null, status: OrderStatus, consigneeName: string | null, shipperEmail: string | null, consigneePhoneNumber: string | null, carrier: string | null, carrierService: string | null, bolNumber: string | null, sealNumber: string | null, shipmentId: number | null, expectedQuantity: number | null, shipperAddress: { __typename?: 'OpsOrderAddress', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, items: Array<{ __typename?: 'OpsOrderItem', identifier: string, id: string, quantity: number | null, quantityUnit: ShipperUnitType, description: string | null, purchaseOrder: string | null, upc: string | null, weightPerUnit: number | null, weightUnit: WeightUnit | null, height: number | null, length: number | null, dimensionUnit: DimensionUnit | null, lot: string | null, isDangerousGood: boolean | null, expirationDate: string | null, manufacturingDate: string | null, sku: string | null, lpn: string | null }> }> } | null } };

export type ShipmentTaskFragment = { __typename?: 'OpsTask', id: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, arrivedAt: string | null, departedAt: string | null, carrier: string | null, facility: { __typename?: 'Facility', name: string | null } } | null };

export type GetOpsTaskShipmentQueryVariables = Exact<{
  query: OpsTaskQuery;
}>;


export type GetOpsTaskShipmentQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', task: { __typename?: 'OpsTask', id: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, arrivedAt: string | null, departedAt: string | null, carrier: string | null, facility: { __typename?: 'Facility', name: string | null } } | null } } };

export type GetTasksSummaryOpsUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasksSummaryOpsUserQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', opsUser: { __typename?: 'OpsUser', facilities: Array<{ __typename?: 'OpsFacility', id: string }> } } };

export type GetTasksSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasksSummaryQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', tasksSummary: Array<{ __typename?: 'OpsTaskSummary', businessId: string, businessSlug: string, facilityId: string, facilitySlug: string, taskType: OpsTaskType, taskStatus: OpsTaskStatus, count: number, oldestIncomplete: string | null }> } };

export type GetNextTasksQueryVariables = Exact<{
  filter: OpsTaskFilter;
  after?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type GetNextTasksQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', tasks: { __typename?: 'OpsTasks', total: number, tasks: Array<{ __typename?: 'OpsTask', id: number }> } } };

export type UpdateTaskStatusMutationVariables = Exact<{
  input: UpdateTaskStatusInput;
}>;


export type UpdateTaskStatusMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', updateTaskStatus: { __typename?: 'UpdateTaskStatusResult', success: boolean, task: { __typename?: 'OpsTask', id: number, status: OpsTaskStatus, statusAt: string } | null } } | null };

export type UnassignTaskMutationVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type UnassignTaskMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', unassignTask: { __typename?: 'OpsTask', id: number, priority: number, createdAt: string, type: OpsTaskType, status: OpsTaskStatus, completedAt: string | null, statusAt: string, parentTask: { __typename?: 'OpsTask', id: number, type: OpsTaskType, status: OpsTaskStatus, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string } | null } | null, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string, email: string } | null, business: { __typename?: 'Business', id: number, slug: string | null } | null, facility: { __typename?: 'Facility', id: number, slug: string } | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, loadingEvent: { __typename?: 'OpsLoadingEvent', occurredAt: string } | null, shipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null } | null, details: { __typename?: 'OpsTaskLoadingEventDetails', shipmentId: string | null, loadingEventId: number } | { __typename?: 'OpsTaskPalletEventDetails', shipmentId: string | null, loadingEventId: number, palletEventId: number } | null } } | null };

export type GetLastCompletedTaskQueryVariables = Exact<{
  completedAt: Scalars['String'];
}>;


export type GetLastCompletedTaskQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', getLastCompletedTask: { __typename?: 'OpsTask', id: number, priority: number, createdAt: string, type: OpsTaskType, status: OpsTaskStatus, completedAt: string | null, statusAt: string, parentTask: { __typename?: 'OpsTask', id: number, type: OpsTaskType, status: OpsTaskStatus, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string } | null } | null, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string, email: string } | null, business: { __typename?: 'Business', id: number, slug: string | null } | null, facility: { __typename?: 'Facility', id: number, slug: string } | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, loadingEvent: { __typename?: 'OpsLoadingEvent', occurredAt: string } | null, shipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null } | null, details: { __typename?: 'OpsTaskLoadingEventDetails', shipmentId: string | null, loadingEventId: number } | { __typename?: 'OpsTaskPalletEventDetails', shipmentId: string | null, loadingEventId: number, palletEventId: number } | null } | null } };

export type GetOpsTaskQueryVariables = Exact<{
  query: OpsTaskQuery;
}>;


export type GetOpsTaskQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', task: { __typename?: 'OpsTask', id: number, priority: number, createdAt: string, completedAt: string | null, type: OpsTaskType, status: OpsTaskStatus, statusAt: string, parentTask: { __typename?: 'OpsTask', id: number, type: OpsTaskType, status: OpsTaskStatus, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string } | null } | null, assignedTo: { __typename?: 'User', externalId: string, firstName: string, lastName: string, email: string } | null, business: { __typename?: 'Business', id: number, slug: string | null } | null, facility: { __typename?: 'Facility', id: number, slug: string } | null, dock: { __typename?: 'Dock', id: number, displayName: string } | null, loadingEvent: { __typename?: 'OpsLoadingEvent', occurredAt: string } | null, shipment: { __typename?: 'TruckShipment', id: number, arrivedAt: string | null, direction: TruckDirection | null } | null, details: { __typename?: 'OpsTaskLoadingEventDetails', shipmentId: string | null, loadingEventId: number } | { __typename?: 'OpsTaskPalletEventDetails', shipmentId: string | null, loadingEventId: number, palletEventId: number } | null } } };

export type TaskDetailPageOpsUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskDetailPageOpsUserQuery = { __typename?: 'Query', ops: { __typename?: 'OpsRoot', opsUser: { __typename?: 'OpsUser', user: { __typename?: 'User', externalId: string, id: number }, facilities: Array<{ __typename?: 'OpsFacility', id: string, slug: string, officialName: string | null, business: { __typename?: 'OpsBusiness', id: string, slug: string } }> } } };

export type GetAnalyticsReportQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type GetAnalyticsReportQuery = { __typename?: 'Query', analytics: { __typename?: 'AnalyticsRoot', getAnalyticsReport: { __typename?: 'AnalyticsReportResult', result: Array<{ __typename?: 'AnalyticsResultEntry', label: string, breakDowns: Array<{ __typename?: 'AnalyticsBreakDownEntries', label: string, value: number }> }> } } };

export type ExceptionsListViewItemsFragment = { __typename?: 'Exception', id: string, occurredAt: string, updatedAt: string | null, title: string, categoryDisplayName: string, status: ExceptionStatus, priority: ExceptionPriority, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null };

export type ExceptionsListViewItemsQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  filter: FacilityExceptionsFilter;
}>;


export type ExceptionsListViewItemsQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, exceptions: { __typename?: 'FacilityExceptions', totalPages: number, results: Array<{ __typename?: 'Exception', id: string, occurredAt: string, updatedAt: string | null, title: string, categoryDisplayName: string, status: ExceptionStatus, priority: ExceptionPriority, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null }> } } } };

export type ExceptionsCreateShipmentTypeContainerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ExceptionsCreateShipmentTypeContainerQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, customerShipmentIdentifier: string | null } };

export type ExceptionsCreateShipmentTypeExceptionMutationVariables = Exact<{
  input: CreateExceptionInput;
}>;


export type ExceptionsCreateShipmentTypeExceptionMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', createException: { __typename?: 'CreateExceptionResult', exception: { __typename?: 'Exception', id: string } } } | null };

export type ExceptionsCreateShippingItemTypeContainerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ExceptionsCreateShippingItemTypeContainerQuery = { __typename?: 'Query', shippingItem: { __typename?: 'ShippingItem', partID: string } };

export type ExceptionsActivitiesQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  exceptionId: Scalars['ID'];
}>;


export type ExceptionsActivitiesQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, exception: { __typename?: 'Exception', id: string, activities: Array<{ __typename?: 'ExceptionActivityCreated', id: string, occurredAt: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityDeletedDocumentUploaded', id: string, occurredAt: string, documentName: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityDocumentDeleted', id: string, occurredAt: string, documentName: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityDocumentUploaded', id: string, occurredAt: string, document: { __typename?: 'ExceptionDocument', id: string, type: string | null, fileName: string, fileUrl: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string } | null }, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityIssueTypeUpdated', id: string, occurredAt: string, fromIssueType: string | null, toIssueType: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityLevelUpdated', id: string, occurredAt: string, fromLevel: ExceptionLevel | null, toLevel: ExceptionLevel, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityOwnerUpdated', id: string, occurredAt: string, previousOwner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, newOwner: { __typename?: 'User', id: number, firstName: string, lastName: string }, changedByUser: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityPriorityUpdated', id: string, occurredAt: string, fromPriority: ExceptionPriority | null, toPriority: ExceptionPriority, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivitySharedWithUsersAdded', id: string, occurredAt: string, sharedWithUsersAdded: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }>, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivitySharedWithUsersDeleted', id: string, occurredAt: string, sharedWithUsersDeleted: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string }>, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ExceptionActivityStatusUpdated', id: string, occurredAt: string, fromStatus: ExceptionStatus | null, toStatus: ExceptionStatus, systemAction: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null }> } } } };

export type ExceptionDocumentsQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  exceptionId: Scalars['ID'];
}>;


export type ExceptionDocumentsQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, exception: { __typename?: 'Exception', id: string, documents: Array<{ __typename?: 'ExceptionDocument', id: string, fileName: string, fileUrl: string, type: string | null, uploadedAt: string }> } } } };

export type UploadExceptionDocumentMutationVariables = Exact<{
  input: UploadExceptionDocumentInput;
  file: Scalars['Upload'];
}>;


export type UploadExceptionDocumentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', uploadExceptionDocument: { __typename?: 'ExceptionDocument', id: string } } | null };

export type DeleteExceptionDocumentMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type DeleteExceptionDocumentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteExceptionDocument: { __typename?: 'Exception', id: string } } | null };

export type AddExceptionsNoteMutationVariables = Exact<{
  input: AddExceptionNoteInput;
}>;


export type AddExceptionsNoteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', addExceptionNote: { __typename?: 'ExceptionNote', id: string, createdAt: string | null, editedAt: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string }, content: { __typename?: 'ExceptionNoteContent', text: string } } } | null };

export type UpdateExceptionsNoteMutationVariables = Exact<{
  input: UpdateExceptionNoteInput;
}>;


export type UpdateExceptionsNoteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateExceptionNote: { __typename?: 'ExceptionNote', id: string, createdAt: string | null, editedAt: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string }, content: { __typename?: 'ExceptionNoteContent', text: string } } } | null };

export type DeleteExceptionsNoteMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type DeleteExceptionsNoteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteExceptionNote: { __typename?: 'ExceptionNote', id: string } } | null };

export type ExceptionsNotesContainerFragment = { __typename?: 'Exception', id: string, notes: Array<{ __typename?: 'ExceptionNote', id: string, isHidden: boolean, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ExceptionNoteContent', text: string } }> };

export type ExceptionsDetailsOverviewExceptionQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  exceptionId: Scalars['ID'];
}>;


export type ExceptionsDetailsOverviewExceptionQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, exception: { __typename?: 'Exception', id: string, level: ExceptionLevel, categoryDisplayName: string, title: string, description: string, type: string, priority: ExceptionPriority, notes: Array<{ __typename?: 'ExceptionNote', id: string, isHidden: boolean, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ExceptionNoteContent', text: string } }>, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, sharedWithUsers: Array<{ __typename?: 'User', id: number, externalId: string, firstName: string, lastName: string }> } } } };

export type ExceptionsStatusTimelineQueryVariables = Exact<{
  facilitySlug: Scalars['String'];
  businessSlug: Scalars['String'];
  exceptionId: Scalars['ID'];
}>;


export type ExceptionsStatusTimelineQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, exception: { __typename?: 'Exception', id: string, statuses: Array<{ __typename?: 'ExceptionStatusEvent', status: ExceptionStatus, occurredAt: string }>, link: { __typename?: 'DockDoorExceptionLink' } | { __typename?: 'ShipmentExceptionLink', shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink' } | null } } } };

export type ExceptionsSettingsContainerConfigsQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
}>;


export type ExceptionsSettingsContainerConfigsQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, exceptionsSettingsConfigs: Array<{ __typename?: 'ExceptionsSettingsConfigs', title: string, issueType: string, categoryDisplayName: string, sharedWithUsers: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string, externalId: string }>, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null }> } } };

export type FacilityContainerDocksFragment = { __typename?: 'Dock', id: number, type: DockType, kargoDock: boolean, displayName: string, currentTruckShipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, arrivedAt: string | null, trailerNumber: string | null, customerShipmentIdentifier: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, status: ShipmentStatus | null, equipmentType: EquipmentType | null, exceptions: Array<{ __typename?: 'Exception', id: string, type: string }>, orders: Array<{ __typename?: 'Order', id: string, consigneeName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', quantity: number | null }> }> } | null };

export type GetDocksQueryVariables = Exact<{
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  filter?: InputMaybe<DockFilter>;
}>;


export type GetDocksQuery = { __typename?: 'Query', business: { __typename?: 'Business', id: number, facility: { __typename?: 'Facility', id: number, docks: Array<{ __typename?: 'Dock', id: number, type: DockType, kargoDock: boolean, displayName: string, currentTruckShipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, arrivedAt: string | null, trailerNumber: string | null, customerShipmentIdentifier: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, status: ShipmentStatus | null, equipmentType: EquipmentType | null, exceptions: Array<{ __typename?: 'Exception', id: string, type: string }>, orders: Array<{ __typename?: 'Order', id: string, consigneeName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', quantity: number | null }> }> } | null }>, devices: Array<{ __typename?: 'DockDevice', isLightOn: boolean }> } } };

export type UpdateFacilityLightsMutationVariables = Exact<{
  facilityId: Scalars['Int'];
  on: Scalars['Boolean'];
}>;


export type UpdateFacilityLightsMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateFacilityLights: { __typename?: 'UpdateFacilityLightsResult', success: boolean } } | null };

export type GetFacilityDocksForMapsQueryVariables = Exact<{
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  filter?: InputMaybe<DockFilter>;
}>;


export type GetFacilityDocksForMapsQuery = { __typename?: 'Query', business: { __typename?: 'Business', id: number, facility: { __typename?: 'Facility', id: number, docks: Array<{ __typename?: 'Dock', id: number, displayName: string, type: DockType, kargoDock: boolean, currentTruckShipment: { __typename?: 'TruckShipment', status: ShipmentStatus | null, direction: TruckDirection | null, id: number, arrivedAt: string | null, customerShipmentIdentifier: string | null, carrier: string | null, carrierId: string | null, carrierService: string | null, equipmentType: EquipmentType | null, trailerNumber: string | null, orders: Array<{ __typename?: 'Order', id: string, consigneeName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', quantity: number | null }> }>, exceptions: Array<{ __typename?: 'Exception', id: string, type: string }> } | null }> } } };

export type OrdersListViewQueryVariables = Exact<{
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  filter: OrdersFilter;
}>;


export type OrdersListViewQuery = { __typename?: 'Query', business: { __typename?: 'Business', id: number, facility: { __typename?: 'Facility', id: number, orders: Array<{ __typename?: 'Order', id: string, expectedQuantity: number | null, externalId: string, orderNumber: string, bolNumber: string | null, requestedShipDate: string | null, consigneeName: string | null, status: OrderStatus, shipmentId: number | null, direction: OrderDirection, items: Array<{ __typename?: 'OrderItem', quantity: number | null, quantityUnit: ShipperUnitType }> }> } } };

export type ShipmentsContainerGetFacilityTrucksQueryVariables = Exact<{
  businessId: Scalars['Int'];
  facilityId: Scalars['Int'];
  filter?: InputMaybe<ShipmentFilterInput>;
}>;


export type ShipmentsContainerGetFacilityTrucksQuery = { __typename?: 'Query', business: { __typename?: 'Business', id: number, facility: { __typename?: 'Facility', id: number, filteredTruckShipments: Array<{ __typename?: 'TruckShipment', id: number, loadingStartAt: string | null, loadingEndAt: string | null, driverName: string | null, driverLicenseNumber: string | null, driverLicensePlate: string | null, direction: TruckDirection | null, carrier: string | null, carrierService: string | null, customerShipmentIdentifier: string | null, expectedArrivalAt: string | null, arrivedAt: string | null, status: ShipmentStatus | null, departedAt: string | null, documents: Array<{ __typename?: 'ShipmentDocument', fileName: string }>, notes: Array<{ __typename?: 'ShipmentNote', id: string }>, dock: { __typename?: 'Dock', id: number, displayName: string, kargoDock: boolean } | null, orders: Array<{ __typename?: 'Order', id: string, shipperName: string | null, expectedQuantity: number | null, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number | null }> }>, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', partID: string | null, quantity: number | null }> }>, statusEvent: { __typename?: 'ShipmentStatusEvent', completedAt: string | null, displayName: string, status: ShipmentStatus } | null, exceptions: Array<{ __typename?: 'Exception', id: string, description: string }> }> } } };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityDocumentDeleted_ = { __typename?: 'ShipmentActivityDocumentDeleted', occurredAt: string, documentName: string, systemAction: boolean };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityDocumentUpload_ = { __typename?: 'ShipmentActivityDocumentUpload', occurredAt: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string }, document: { __typename?: 'ShipmentDocument', fileName: string, fileUrl: string } };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityDoorEvent_ = { __typename?: 'ShipmentActivityDoorEvent', occurredAt: string, id: string, opened: boolean, videoUri: string };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityExceptionCreated_ = { __typename?: 'ShipmentActivityExceptionCreated', occurredAt: string, id: string, exceptionId: string, title: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityItemsLoaded_ = { __typename?: 'ShipmentActivityItemsLoaded', occurredAt: string, id: string, direction: ItemLoadingDirection, items: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityOrderUpdated_ = { __typename?: 'ShipmentActivityOrderUpdated', occurredAt: string, id: string, orderId: string, orderNumber: string, orderItems: Array<string> };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityStatusUpdated_ = { __typename?: 'ShipmentActivityStatusUpdated', occurredAt: string, systemAction: boolean, toStatus: ShipmentStatus, fromStatus: ShipmentStatus | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, fromDock: { __typename?: 'Dock', id: number, displayName: string } | null, toDock: { __typename?: 'Dock', id: number, displayName: string } | null };

type ShipmentActivityContainerActivitiesFragment_ShipmentActivityStringFieldUpdated_ = { __typename?: 'ShipmentActivityStringFieldUpdated', occurredAt: string, systemAction: boolean, fieldName: string, toValue: string | null, fromValue: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null };

export type ShipmentActivityContainerActivitiesFragment = ShipmentActivityContainerActivitiesFragment_ShipmentActivityDocumentDeleted_ | ShipmentActivityContainerActivitiesFragment_ShipmentActivityDocumentUpload_ | ShipmentActivityContainerActivitiesFragment_ShipmentActivityDoorEvent_ | ShipmentActivityContainerActivitiesFragment_ShipmentActivityExceptionCreated_ | ShipmentActivityContainerActivitiesFragment_ShipmentActivityItemsLoaded_ | ShipmentActivityContainerActivitiesFragment_ShipmentActivityOrderUpdated_ | ShipmentActivityContainerActivitiesFragment_ShipmentActivityStatusUpdated_ | ShipmentActivityContainerActivitiesFragment_ShipmentActivityStringFieldUpdated_;

export type ShipmentActivityContainerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentActivityContainerQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, activities: Array<{ __typename?: 'ShipmentActivityDocumentDeleted', occurredAt: string, documentName: string, systemAction: boolean } | { __typename?: 'ShipmentActivityDocumentUpload', occurredAt: string, uploadedBy: { __typename?: 'User', id: number, firstName: string, lastName: string }, document: { __typename?: 'ShipmentDocument', fileName: string, fileUrl: string } } | { __typename?: 'ShipmentActivityDoorEvent', occurredAt: string, id: string, opened: boolean, videoUri: string } | { __typename?: 'ShipmentActivityExceptionCreated', occurredAt: string, id: string, exceptionId: string, title: string, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null } | { __typename?: 'ShipmentActivityItemsLoaded', occurredAt: string, id: string, direction: ItemLoadingDirection, items: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> } | { __typename?: 'ShipmentActivityOrderUpdated', occurredAt: string, id: string, orderId: string, orderNumber: string, orderItems: Array<string> } | { __typename?: 'ShipmentActivityStatusUpdated', occurredAt: string, systemAction: boolean, toStatus: ShipmentStatus, fromStatus: ShipmentStatus | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, fromDock: { __typename?: 'Dock', id: number, displayName: string } | null, toDock: { __typename?: 'Dock', id: number, displayName: string } | null } | { __typename?: 'ShipmentActivityStringFieldUpdated', occurredAt: string, systemAction: boolean, fieldName: string, toValue: string | null, fromValue: string | null, user: { __typename?: 'User', id: number, firstName: string, lastName: string } | null }> } };

export type ShipmentsContentContainerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentsContentContainerQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, content: { __typename?: 'ShipmentContent', itemIdentifierColumnName: string, items: Array<{ __typename?: 'ShipmentContentItem', identifier: string, orderQuantity: number | null, actualQuantity: number | null, description: string | null, sourceItems: Array<{ __typename?: 'ShippingItem', partID: string, flags: Array<ShippingItemFlag>, shipmentActivityItemsLoadedId: string, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> }> } } };

export type ShipmentsDocumentsContainerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentsDocumentsContainerQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, documents: Array<{ __typename?: 'ShipmentDocument', id: string, type: string | null, externalId: string, fileName: string, fileUrl: string, uploadedAt: string }> } };

export type UploadShipmentDocumentMutationVariables = Exact<{
  input: UploadShipmentDocumentInput;
  file: Scalars['Upload'];
}>;


export type UploadShipmentDocumentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', uploadShipmentDocument: { __typename?: 'UploadShipmentDocumentResult', success: boolean } } | null };

export type ShipmentsDocumentDeleteMutationVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type ShipmentsDocumentDeleteMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', deleteShipmentDocument: { __typename?: 'DeleteShipmentDocumentResult', success: boolean } } | null };

export type ShipmentsExceptionsContainerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentsExceptionsContainerQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, exceptions: Array<{ __typename?: 'Exception', id: string, occurredAt: string, updatedAt: string | null, title: string, categoryDisplayName: string, status: ExceptionStatus, priority: ExceptionPriority, owner: { __typename?: 'User', id: number, firstName: string, lastName: string } | null, link: { __typename?: 'DockDoorExceptionLink', dock: { __typename?: 'Dock', id: number } } | { __typename?: 'ShipmentExceptionLink', shipmentId: number, shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink', item: { __typename?: 'ShippingItem', partID: string } } | null }> } };

export type MediaLeftPaneCardsContainerLabelFragment = { __typename?: 'ShippingItem', partID: string, layerCount: number | null, orientation: PalletOrientation | null, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } };

export type MediaLeftPaneCardsContainerFragment = { __typename?: 'ShipmentActivityItemsLoaded', id: string, direction: ItemLoadingDirection, forkliftId: string | null, occurredAt: string, items: Array<{ __typename?: 'ShippingItem', flags: Array<ShippingItemFlag>, partID: string, layerCount: number | null, orientation: PalletOrientation | null, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> };

export type MediaLeftPanePanelContainerVideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MediaLeftPanePanelContainerVideoQuery = { __typename?: 'Query', shipmentActivityItemsLoaded: { __typename?: 'ShipmentActivityItemsLoaded', id: string, videos: Array<{ __typename?: 'PalletMotionVideo', videoUri: string, videoThumbnailUri: string | null }> } };

export type MediaPalletVideoViewerContainerFragment = { __typename?: 'ShipmentActivityItemsLoaded', id: string };

export type MediaPalletVideoViewerContainerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MediaPalletVideoViewerContainerQuery = { __typename?: 'Query', shipmentActivityItemsLoaded: { __typename?: 'ShipmentActivityItemsLoaded', id: string, videos: Array<{ __typename?: 'PalletMotionVideo', videoUri: string, videoThumbnailUri: string | null, cameraLocation: string | null, occurredAt: string | null }> } };

export type MediaViewerItemShippingItemFragment = { __typename?: 'ShippingItem', partID: string, layerCount: number | null, orientation: PalletOrientation | null, flags: Array<ShippingItemFlag>, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, images: Array<{ __typename?: 'TaggedImage', identifier: string | null, url: string, brightness: number | null }>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } };

export type ShipmentsMediaContainerShipmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentsMediaContainerShipmentQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, activities: Array<{ __typename?: 'ShipmentActivityDocumentDeleted' } | { __typename?: 'ShipmentActivityDocumentUpload' } | { __typename?: 'ShipmentActivityDoorEvent', id: string, occurredAt: string, videoUri: string, videoThumbnailUri: string | null, opened: boolean } | { __typename?: 'ShipmentActivityExceptionCreated' } | { __typename?: 'ShipmentActivityItemsLoaded', id: string, direction: ItemLoadingDirection, occurredAt: string, forkliftId: string | null, itemQuantity: number, items: Array<{ __typename?: 'ShippingItem', flags: Array<ShippingItemFlag>, partID: string, layerCount: number | null, orientation: PalletOrientation | null, aggregateLabel: { __typename?: 'AggregateLabel', identifiers: Array<string>, images: Array<{ __typename?: 'TaggedImage', identifier: string | null, url: string, brightness: number | null }>, fields: Array<{ __typename?: 'MultiValueDataField', displayName: string, values: Array<string> }> } }> } | { __typename?: 'ShipmentActivityOrderUpdated' } | { __typename?: 'ShipmentActivityStatusUpdated' } | { __typename?: 'ShipmentActivityStringFieldUpdated' }> } };

export type ShipmentsOrdersContainerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentsOrdersContainerQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, orders: Array<{ __typename?: 'Order', id: string, expectedQuantity: number | null, externalId: string, orderNumber: string, consigneeName: string | null, requestedShipDate: string | null, status: OrderStatus, items: Array<{ __typename?: 'OrderItem', description: string | null, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string }> }> } };

export type ShipmentsDetailsOverviewShipmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShipmentsDetailsOverviewShipmentQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, customerShipmentIdentifier: string | null, direction: TruckDirection | null, carrier: string | null, carrierId: string | null, carrierService: string | null, driverName: string | null, driverEmailAddress: string | null, driverLicenseNumber: string | null, driverLicensePlate: string | null, facility: { __typename?: 'Facility', id: number, possibleCarrierServices: Array<string> | null }, shipFromAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, shipToAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, orders: Array<{ __typename?: 'Order', consigneeName: string | null, shipperName: string | null, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null }> } };

export type ShipmentsDetailsOverviewUpdateShipmentMutationVariables = Exact<{
  input: UpdateShipmentInput;
}>;


export type ShipmentsDetailsOverviewUpdateShipmentMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateShipment: { __typename?: 'UpdateShipmentResult', success: boolean } } | null };

export type GetTruckShipmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTruckShipmentQuery = { __typename?: 'Query', truckShipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null, expectedArrivalAt: string | null, arrivedAt: string | null, departedAt: string | null, loadingStartAt: string | null, loadingEndAt: string | null, customerShipmentIdentifier: string | null, alertBannerText: string | null, driverName: string | null, driverEmailAddress: string | null, driverLicenseNumber: string | null, driverLicensePlate: string | null, equipmentType: EquipmentType | null, serviceType: ServiceType | null, trailerNumber: string | null, sealNumber: string | null, carrier: string | null, carrierService: string | null, carrierId: string | null, status: ShipmentStatus | null, processing: boolean, dock: { __typename?: 'Dock', id: number, displayName: string, kargoDock: boolean, slug: string } | null, facility: { __typename?: 'Facility', name: string | null, id: number, businessId: number, possibleCarrierServices: Array<string> | null, possibleEquipmentTypes: Array<{ __typename?: 'EquipmentTypeOption', value: EquipmentType, displayName: string }>, possibleServiceTypes: Array<{ __typename?: 'ServiceTypeOption', value: ServiceType, displayName: string }>, timezone: { __typename?: 'FacilityTimezone', name: string } | null }, cargo: Array<{ __typename?: 'ShippingUnit', manifest: Array<{ __typename?: 'ShippingItemAggregation', name: string | null, quantity: number | null }> }>, exceptions: Array<{ __typename?: 'Exception', id: string, description: string }>, orders: Array<{ __typename?: 'Order', expectedQuantity: number | null, externalId: string, orderNumber: string, requestedShipDate: string | null, status: OrderStatus, consigneeName: string | null, shipperName: string | null, items: Array<{ __typename?: 'OrderItem', description: string | null, quantity: number | null, quantityUnit: ShipperUnitType, identifier: string }>, shipperAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null }>, notes: Array<{ __typename?: 'ShipmentNote', id: string, isHidden: boolean, createdAt: string | null, editedAt: string | null, canModify: boolean, user: { __typename?: 'User', id: number, firstName: string, lastName: string }, content: { __typename?: 'ShipmentNoteContent', text: string } | null }>, shipFromAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, shipToAddress: { __typename?: 'Address', addressOne: string, addressTwo: string | null, city: string, state: string, zip: string } | null, statusEvents: Array<{ __typename?: 'ShipmentStatusEvent', displayName: string, status: ShipmentStatus, completed: boolean, completedAt: string | null }> } };

export type UpdateShipmentDetailsMutationVariables = Exact<{
  input: UpdateShipmentInput;
}>;


export type UpdateShipmentDetailsMutation = { __typename?: 'Mutation', dashboard: { __typename?: 'DashboardMutation', updateShipment: { __typename?: 'UpdateShipmentResult', id: number } } | null };

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureFlagsQuery = { __typename?: 'Query', me: { __typename?: 'Me', featureFlags: Array<{ __typename?: 'UserFeatureFlag', featureId: string, enabledVariantId: string, scopes: Array<{ __typename?: 'BusinessScopeFeatureFlag', businessId: number, enabledVariantId: string }> }> } };

export type ExceptionsDetailsViewLayoutQueryVariables = Exact<{
  businessSlug: Scalars['String'];
  facilitySlug: Scalars['String'];
  exceptionId: Scalars['ID'];
}>;


export type ExceptionsDetailsViewLayoutQuery = { __typename?: 'Query', businessBySlug: { __typename?: 'Business', id: number, facilityBySlug: { __typename?: 'Facility', id: number, exception: { __typename?: 'Exception', id: string, occurredAt: string, statuses: Array<{ __typename?: 'ExceptionStatusEvent', status: ExceptionStatus }>, link: { __typename?: 'DockDoorExceptionLink' } | { __typename?: 'ShipmentExceptionLink', shipment: { __typename?: 'TruckShipment', id: number, direction: TruckDirection | null } } | { __typename?: 'ShippingItemExceptionLink' } | null } } } };

export type TriggerStatusLightForDeviceMutationVariables = Exact<{
  input: OpsTriggerTowerStatusLightInput;
}>;


export type TriggerStatusLightForDeviceMutation = { __typename?: 'Mutation', ops: { __typename?: 'BusinessOperationMutation', triggerTowerStatusLight: { __typename?: 'OpsTriggerTowerStatusLightResponse', deviceId: number, success: boolean, host: string | null } } | null };


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActionItem": [
      "DiscrepancyActionItem"
    ],
    "ExceptionActivity": [
      "ExceptionActivityCreated",
      "ExceptionActivityDeletedDocumentUploaded",
      "ExceptionActivityDocumentDeleted",
      "ExceptionActivityDocumentUploaded",
      "ExceptionActivityIssueTypeUpdated",
      "ExceptionActivityLevelUpdated",
      "ExceptionActivityOwnerUpdated",
      "ExceptionActivityPriorityUpdated",
      "ExceptionActivitySharedWithUsersAdded",
      "ExceptionActivitySharedWithUsersDeleted",
      "ExceptionActivityStatusUpdated"
    ],
    "ExceptionLink": [
      "DockDoorExceptionLink",
      "ShipmentExceptionLink",
      "ShippingItemExceptionLink"
    ],
    "FormField": [
      "DropdownFormField",
      "FieldListFormField",
      "NumericFormField",
      "StringFormField"
    ],
    "IFeatureFlag": [
      "BusinessFeatureFlag",
      "UserFeatureFlag"
    ],
    "OpsShipmentActivity": [
      "OpsShipmentActivityItemsLoaded"
    ],
    "OpsTaskDetails": [
      "OpsTaskLoadingEventDetails",
      "OpsTaskPalletEventDetails"
    ],
    "PalletConfiguration": [
      "TwoPalletConfiguration"
    ],
    "ShipmentActivity": [
      "ShipmentActivityDocumentDeleted",
      "ShipmentActivityDocumentUpload",
      "ShipmentActivityDoorEvent",
      "ShipmentActivityExceptionCreated",
      "ShipmentActivityItemsLoaded",
      "ShipmentActivityOrderUpdated",
      "ShipmentActivityStatusUpdated",
      "ShipmentActivityStringFieldUpdated"
    ]
  }
};
      export default result;
    